// // import React, { useState, useEffect, useCallback, useRef } from "react";
// // import {
// //   Sparkles,
// //   LayoutGrid,
// //   Upload,
// //   FileText,
// //   Eye,
// //   Code2,
// //   Plus,
// //   Settings,
// //   Trash2,
// //   Copy,
// //   ChevronDown,
// //   ChevronRight,
// //   Save,
// //   X,
// //   Clock,
// //   Layers,
// //   Wand2,
// //   AlertCircle,
// //   CheckCircle2,
// //   Table2,
// //   Hash,
// //   Calendar,
// //   Type,
// //   RefreshCw,
// //   Cpu,
// //   ArrowLeft,
// //   Check,
// //   SquareCheck,
// //   Square,
// //   XCircle,
// //   MoreVertical,
// //   Search,
// //   Pencil,
// //   Braces,
// // } from "lucide-react";
// // import {
// //   ingestDocument,
// //   getTemplates,
// //   getTemplate,
// //   createTemplate,
// //   updateTemplate,
// //   duplicateTemplate,
// //   universalExtract,
// //   API_BASE,
// //   UNIVERSAL_EXTRACT_PATH,
// // } from "./extractorApi";
// // import "./extractor.css";
// // import DownloadCSVButton from "./DownloadCSVButton";
// // import OcrEngineModal, { ENGINE_OPTIONS, EngineCardGrid } from "./OcrEngineModal";
// // import { OnboardingHero, StarterTemplateGallery } from "./DashboardOnboarding";

// // // ─── Helpers ─────────────────────────────────────────────────────────────────

// // let _docIdCounter = 0;
// // const nextDocId = () => `doc_${++_docIdCounter}_${Date.now()}`;

// // const Spinner = ({ size = 16 }) => (
// //   <svg
// //     className="ex-spinner"
// //     width={size}
// //     height={size}
// //     viewBox="0 0 24 24"
// //     fill="none"
// //     stroke="currentColor"
// //     strokeWidth="2.5"
// //   >
// //     <path d="M21 12a9 9 0 1 1-6.219-8.56" />
// //   </svg>
// // );

// // const generateSlug = (name) =>
// //   name
// //     .toLowerCase()
// //     .trim()
// //     .replace(/[^a-z0-9\s-]/g, "")
// //     .replace(/\s+/g, "-")
// //     .replace(/-+/g, "-");

// // const formatBytes = (bytes) => {
// //   if (bytes < 1024) return `${bytes} B`;
// //   if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
// //   return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
// // };

// // const copyTextToClipboard = async (text) => {
// //   if (navigator.clipboard?.writeText) {
// //     await navigator.clipboard.writeText(text);
// //     return;
// //   }

// //   const textarea = document.createElement("textarea");
// //   textarea.value = text;
// //   textarea.setAttribute("readonly", "");
// //   textarea.style.position = "absolute";
// //   textarea.style.left = "-9999px";
// //   document.body.appendChild(textarea);
// //   textarea.select();
// //   document.execCommand("copy");
// //   document.body.removeChild(textarea);
// // };

// // const buildUniversalExtractUrl = (slug) =>
// //   `${API_BASE}${UNIVERSAL_EXTRACT_PATH}?template=${encodeURIComponent(slug || "")}`;

// // const buildCurlSnippet = (slug) => `curl -X POST "${buildUniversalExtractUrl(slug)}" \\
// //   -H "Authorization: Bearer YOUR_ACCESS_TOKEN" \\
// //   -F "file=@/path/to/document.pdf"`;

// // const buildFetchSnippet = (slug) => `const formData = new FormData();
// // formData.append("file", file);

// // const response = await fetch("${buildUniversalExtractUrl(slug)}", {
// //   method: "POST",
// //   headers: {
// //     Authorization: "Bearer YOUR_ACCESS_TOKEN",
// //   },
// //   body: formData,
// // });

// // const data = await response.json();
// // console.log(data);`;

// // const DATA_TYPE_META = {
// //   text:   { label: "Text",   icon: Type,     color: "text"   },
// //   number: { label: "Number", icon: Hash,     color: "number" },
// //   date:   { label: "Date",   icon: Calendar, color: "date"   },
// //   table:  { label: "Table",  icon: Table2,   color: "table"  },
// //   object: { label: "Object", icon: Braces,   color: "object" },
// // };

// // const RETRIEVAL_OPTIONS = [
// //   { value: "full_text",  label: "Full Text" },
// //   { value: "similarity", label: "Similarity Search" },
// //   { value: "fusion",     label: "Hybrid Fusion" },
// // ];

// // const LLM_MODEL_OPTIONS = [
// //   { value: "gemini_2_5_flash_lite", label: "Gemini 2.5 Flash Lite (Lightweight & Fast)" },
// //   { value: "gemini_2_5_flash", label: "Gemini 2.5 Flash (Full & Accurate)" },
// // ];

// // // ─── Suggested Fields per Document Type ──────────────────────────────────────

// // const SUGGESTED_FIELDS = {
// //   invoice: [
// //     { field_key: "vendor_name",    data_type: "text",   instruction: "Extract the company or vendor name issuing the invoice", output_rules: "" },
// //     { field_key: "customer_name",  data_type: "text",   instruction: "Extract the bill-to company or customer name", output_rules: "" },
// //     { field_key: "invoice_number", data_type: "text",   instruction: "Extract the invoice or bill number", output_rules: "" },
// //     { field_key: "invoice_date",   data_type: "date",   instruction: "Extract the invoice date", output_rules: "Format as YYYY-MM-DD" },
// //     { field_key: "due_date",       data_type: "date",   instruction: "Extract the payment due date", output_rules: "Format as YYYY-MM-DD" },
// //     { field_key: "total_amount",   data_type: "number", instruction: "Extract the total amount due including all taxes", output_rules: "Return as float, no currency symbols" },
// //     { field_key: "tax_amount",     data_type: "number", instruction: "Extract the tax or VAT amount", output_rules: "Return as float, no currency symbols" },
// //     { field_key: "currency",       data_type: "text",   instruction: "Extract the currency code (e.g. USD, EUR, INR)", output_rules: "" },
// //     { field_key: "line_items",     data_type: "table",  instruction: "Extract all line items as a table with quantity, price and description", output_rules: "Columns: description, quantity, unit_price, total" },
// //     { field_key: "vendor_address", data_type: "text",   instruction: "Extract the vendor full address", output_rules: "" },
// //   ],
// //   purchase_order: [
// //     { field_key: "po_number",      data_type: "text",   instruction: "Extract the purchase order number", output_rules: "" },
// //     { field_key: "vendor_name",    data_type: "text",   instruction: "Extract the vendor or supplier name", output_rules: "" },
// //     { field_key: "order_date",     data_type: "date",   instruction: "Extract the purchase order date", output_rules: "Format as YYYY-MM-DD" },
// //     { field_key: "delivery_date",  data_type: "date",   instruction: "Extract the expected delivery date", output_rules: "Format as YYYY-MM-DD" },
// //     { field_key: "total_value",    data_type: "number", instruction: "Extract the total order value", output_rules: "Return as float" },
// //     { field_key: "buyer_name",     data_type: "text",   instruction: "Extract the buyer or purchasing company name", output_rules: "" },
// //     { field_key: "line_items",     data_type: "table",  instruction: "Extract all order line items", output_rules: "Columns: item_code, description, quantity, unit_price, total" },
// //   ],
// //   contract: [
// //     { field_key: "contract_title", data_type: "text",   instruction: "Extract the title or name of the contract", output_rules: "" },
// //     { field_key: "effective_date", data_type: "date",   instruction: "Extract the contract start or effective date", output_rules: "Format as YYYY-MM-DD" },
// //     { field_key: "expiry_date",    data_type: "date",   instruction: "Extract the contract end or expiry date", output_rules: "Format as YYYY-MM-DD" },
// //     { field_key: "party_1",        data_type: "text",   instruction: "Extract the first party (service provider) name", output_rules: "" },
// //     { field_key: "party_2",        data_type: "text",   instruction: "Extract the second party (client) name", output_rules: "" },
// //     { field_key: "contract_value", data_type: "number", instruction: "Extract the total contract value", output_rules: "Return as float" },
// //     { field_key: "governing_law",  data_type: "text",   instruction: "Extract the governing law or jurisdiction", output_rules: "" },
// //   ],
// //   receipt: [
// //     { field_key: "merchant_name",  data_type: "text",   instruction: "Extract the store or merchant name", output_rules: "" },
// //     { field_key: "receipt_date",   data_type: "date",   instruction: "Extract the transaction date", output_rules: "Format as YYYY-MM-DD" },
// //     { field_key: "total_amount",   data_type: "number", instruction: "Extract the total amount paid", output_rules: "Return as float" },
// //     { field_key: "payment_method", data_type: "text",   instruction: "Extract the payment method (cash, card, UPI, etc.)", output_rules: "" },
// //     { field_key: "items",          data_type: "table",  instruction: "Extract all purchased items", output_rules: "Columns: name, quantity, price" },
// //   ],
// //   custom: [],
// // };

// // // ─── Schema Builder (recursive tree editor for object/table schemas) ─────────

// // const SCHEMA_TYPES = ["text", "number", "date", "table", "object"];

// // const SchemaPropertyRow = ({ prop, path, onChange, onDelete, depth = 0 }) => {
// //   const [open, setOpen] = useState(depth < 2);
// //   const hasChildren = prop.type === "object" || prop.type === "table";
// //   const meta = DATA_TYPE_META[prop.type] || DATA_TYPE_META.text;
// //   const Icon = meta.icon;

// //   const update = (key, value) => {
// //     const updated = { ...prop, [key]: value };
// //     // Clean up incompatible fields when type changes
// //     if (key === "type") {
// //       if (value !== "object" && value !== "table") {
// //         delete updated.properties;
// //         delete updated.items;
// //         delete updated.merge_key;
// //       }
// //       if (value === "object" && !updated.properties) {
// //         updated.properties = [];
// //       }
// //       if (value === "table" && !updated.items) {
// //         updated.items = { type: "object", properties: [] };
// //       }
// //       if (value !== "table") {
// //         delete updated.merge_key;
// //       }
// //     }
// //     onChange(updated);
// //   };

// //   const addChild = () => {
// //     if (prop.type === "object") {
// //       const props = [...(prop.properties || [])];
// //       props.push({ key: `field_${props.length + 1}`, type: "text" });
// //       onChange({ ...prop, properties: props });
// //     } else if (prop.type === "table") {
// //       const items = prop.items || { type: "object", properties: [] };
// //       const props = [...(items.properties || [])];
// //       props.push({ key: `field_${props.length + 1}`, type: "text" });
// //       onChange({ ...prop, items: { ...items, properties: props } });
// //     }
// //     setOpen(true);
// //   };

// //   const updateChild = (idx, updated) => {
// //     if (prop.type === "object") {
// //       const props = [...(prop.properties || [])];
// //       props[idx] = updated;
// //       onChange({ ...prop, properties: props });
// //     } else if (prop.type === "table") {
// //       const items = { ...(prop.items || { type: "object", properties: [] }) };
// //       const props = [...(items.properties || [])];
// //       props[idx] = updated;
// //       onChange({ ...prop, items: { ...items, properties: props } });
// //     }
// //   };

// //   const deleteChild = (idx) => {
// //     if (prop.type === "object") {
// //       const props = (prop.properties || []).filter((_, i) => i !== idx);
// //       onChange({ ...prop, properties: props });
// //     } else if (prop.type === "table") {
// //       const items = { ...(prop.items || { type: "object", properties: [] }) };
// //       const props = (items.properties || []).filter((_, i) => i !== idx);
// //       onChange({ ...prop, items: { ...items, properties: props } });
// //     }
// //   };

// //   const children = prop.type === "object"
// //     ? (prop.properties || [])
// //     : prop.type === "table"
// //       ? (prop.items?.properties || [])
// //       : [];

// //   return (
// //     <div className="ex-schema-node" style={{ "--depth": depth }}>
// //       <div className="ex-schema-node-header">
// //         {hasChildren ? (
// //           <button className="ex-schema-toggle" onClick={() => setOpen((o) => !o)}>
// //             {open ? <ChevronDown size={11} /> : <ChevronRight size={11} />}
// //           </button>
// //         ) : (
// //           <span className="ex-schema-toggle-spacer" />
// //         )}
// //         <input
// //           className="ex-schema-key-input"
// //           value={prop.key || ""}
// //           onChange={(e) => update("key", e.target.value)}
// //           placeholder="key_name"
// //         />
// //         <select
// //           className="ex-schema-type-select"
// //           value={prop.type}
// //           onChange={(e) => update("type", e.target.value)}
// //         >
// //           {SCHEMA_TYPES.map((t) => (
// //             <option key={t} value={t}>{t}</option>
// //           ))}
// //         </select>
// //         <span className={`ex-field-type-badge ${meta.color}`} style={{ fontSize: "0.5rem" }}>
// //           <Icon size={8} />
// //         </span>
// //         {prop.type === "table" && (
// //           <input
// //             className="ex-schema-merge-input"
// //             value={prop.merge_key || ""}
// //             onChange={(e) => update("merge_key", e.target.value)}
// //             placeholder="merge_key"
// //             title="Merge key for batch deduplication (optional)"
// //           />
// //         )}
// //         <button className="ex-schema-delete-btn" onClick={onDelete} title="Remove property">
// //           <X size={11} />
// //         </button>
// //       </div>

// //       {/* Description (inline, compact) */}
// //       <div className="ex-schema-node-desc-row">
// //         <input
// //           className="ex-schema-desc-input"
// //           value={prop.description || ""}
// //           onChange={(e) => update("description", e.target.value)}
// //           placeholder="description (optional hint for AI)"
// //         />
// //       </div>

// //       {/* Children */}
// //       {hasChildren && open && (
// //         <div className="ex-schema-children">
// //           {children.map((child, idx) => (
// //             <SchemaPropertyRow
// //               key={idx}
// //               prop={child}
// //               path={`${path}.${child.key || idx}`}
// //               depth={depth + 1}
// //               onChange={(updated) => updateChild(idx, updated)}
// //               onDelete={() => deleteChild(idx)}
// //             />
// //           ))}
// //           <button className="ex-schema-add-btn" onClick={addChild}>
// //             <Plus size={10} /> Add Property
// //           </button>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // const SchemaBuilder = ({ schema, onChange }) => {
// //   // Normalize: schema can be an array or { type: "object", properties: [...] }
// //   const normalized = Array.isArray(schema)
// //     ? { type: "object", properties: schema }
// //     : schema || { type: "object", properties: [] };

// //   const properties = normalized.properties || [];

// //   const updateProperty = (idx, updated) => {
// //     const props = [...properties];
// //     props[idx] = updated;
// //     onChange({ ...normalized, properties: props });
// //   };

// //   const deleteProperty = (idx) => {
// //     const props = properties.filter((_, i) => i !== idx);
// //     onChange({ ...normalized, properties: props });
// //   };

// //   const addProperty = () => {
// //     const props = [...properties];
// //     props.push({ key: `field_${props.length + 1}`, type: "text" });
// //     onChange({ ...normalized, properties: props });
// //   };

// //   return (
// //     <div className="ex-schema-builder">
// //       <div className="ex-schema-builder-header">
// //         <Braces size={12} />
// //         <span>Schema Definition</span>
// //         <span className="ex-schema-count">{properties.length} properties</span>
// //       </div>
// //       <div className="ex-schema-builder-body">
// //         {properties.length === 0 ? (
// //           <div className="ex-schema-empty">
// //             No properties defined yet. Add properties to define the output shape.
// //           </div>
// //         ) : (
// //           properties.map((prop, idx) => (
// //             <SchemaPropertyRow
// //               key={idx}
// //               prop={prop}
// //               path={prop.key || String(idx)}
// //               depth={0}
// //               onChange={(updated) => updateProperty(idx, updated)}
// //               onDelete={() => deleteProperty(idx)}
// //             />
// //           ))
// //         )}
// //         <button className="ex-schema-add-btn ex-schema-add-btn--root" onClick={addProperty}>
// //           <Plus size={11} /> Add Property
// //         </button>
// //       </div>
// //     </div>
// //   );
// // };

// // // ─── Field Row (inside Template Builder) ─────────────────────────────────────

// // const FieldRow = ({ field, index, onChange, onDelete }) => {
// //   const [open, setOpen] = useState(false);
// //   const [showAdvanced, setShowAdvanced] = useState(false);
// //   const meta = DATA_TYPE_META[field.data_type] || DATA_TYPE_META.text;
// //   const Icon = meta.icon;

// //   return (
// //     <div className={`ex-field-row ${open ? "ex-field-row--open" : ""}`}>
// //       <div className="ex-field-row-header" onClick={() => setOpen((o) => !o)}>
// //         <span className="ex-field-num">{index + 1}</span>
// //         <div className="ex-field-chevron">
// //           {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
// //         </div>
// //         <input
// //           className="ex-field-key"
// //           value={field.field_key}
// //           onChange={(e) => onChange({ ...field, field_key: e.target.value })}
// //           placeholder="Field name"
// //           title="Field Name"
// //           onClick={(e) => e.stopPropagation()}
// //         />
// //         <span className={`ex-field-type-badge ${meta.color}`}>
// //           <Icon size={10} />
// //           {meta.label}
// //         </span>
// //         <button
// //           className="ex-field-delete-btn"
// //           onClick={(e) => { e.stopPropagation(); onDelete(); }}
// //           title="Remove field"
// //         >
// //           <Trash2 size={13} />
// //         </button>
// //       </div>

// //       {open && (
// //         <div className="ex-field-body">
// //           <div className="ex-field-body-section">
// //             <div className="ex-field-body-section-title">
// //               <Settings size={11} />
// //               Configuration
// //             </div>
// //             <div className="ex-form-row">
// //               <div className="ex-form-group">
// //                 <label className="ex-label">Field Name</label>
// //                 <input
// //                   className="ex-input"
// //                   value={field.field_key}
// //                   onChange={(e) => onChange({ ...field, field_key: e.target.value })}
// //                   placeholder="e.g. vendor_name"
// //                 />
// //               </div>
// //               <div className="ex-form-group">
// //                 <label className="ex-label">Data Type</label>
// //                 <select
// //                   className="ex-field-select"
// //                   value={field.data_type}
// //                   onChange={(e) => {
// //                     const newType = e.target.value;
// //                     const updated = { ...field, data_type: newType };
// //                     // Auto-init schema_definition for object; clear for scalar types
// //                     if (newType === "object" && !updated.schema_definition) {
// //                       updated.schema_definition = { type: "object", properties: [] };
// //                     } else if (newType !== "object" && newType !== "table") {
// //                       updated.schema_definition = null;
// //                     }
// //                     onChange(updated);
// //                   }}
// //                 >
// //                   <option value="text">Text</option>
// //                   <option value="number">Number</option>
// //                   <option value="date">Date</option>
// //                   <option value="table">Table</option>
// //                   <option value="object">Object</option>
// //                 </select>
// //               </div>
// //             </div>
// //           </div>

// //           <div className="ex-field-body-section">
// //             <div className="ex-field-body-section-title">
// //               <Sparkles size={11} />
// //               AI Instructions
// //             </div>
// //             <div className="ex-form-group">
// //               <label className="ex-label">
// //                 Extraction Instruction
// //                 <span className="ex-label-hint">Tell the AI what to look for</span>
// //               </label>
// //               <textarea
// //                 className="ex-field-textarea ex-field-textarea--tall"
// //                 value={field.instruction || ""}
// //                 onChange={(e) => onChange({ ...field, instruction: e.target.value })}
// //                 placeholder='e.g. "Extract the total amount from the bottom-right of the invoice"'
// //               />
// //             </div>
// //             <div className="ex-form-group">
// //               <label className="ex-label">
// //                 Output Rules
// //                 <span className="ex-label-hint">Formatting constraints</span>
// //               </label>
// //               <textarea
// //                 className="ex-field-textarea"
// //                 value={field.output_rules || ""}
// //                 onChange={(e) => onChange({ ...field, output_rules: e.target.value })}
// //                 placeholder='e.g. "Format as float, no currency symbols"'
// //               />
// //             </div>
// //           </div>

// //           {/* Schema Builder — shown for object (required) and table (optional) */}
// //           {(field.data_type === "object" || field.data_type === "table") && (
// //             <div className="ex-field-body-section">
// //               <div className="ex-field-body-section-title">
// //                 <Braces size={11} />
// //                 Schema Definition
// //                 {field.data_type === "object" && <span className="ex-label-hint" style={{ color: "#DC2626" }}>required</span>}
// //                 {field.data_type === "table" && <span className="ex-label-hint">optional — improves batch merge</span>}
// //               </div>
// //               <div style={{ padding: "0 0.875rem 0.875rem" }}>
// //                 <SchemaBuilder
// //                   schema={field.schema_definition}
// //                   onChange={(schema) => onChange({ ...field, schema_definition: schema })}
// //                 />
// //               </div>
// //             </div>
// //           )}

// //           {/* Advanced: ERP mapping — hidden by default */}
// //           <div className="ex-field-body-section" style={{ borderTop: "1px solid #f3f4f6", paddingTop: "0.5rem" }}>
// //             <button
// //               type="button"
// //               className="ex-advanced-toggle"
// //               style={{ fontSize: "0.6875rem", padding: "0.25rem 0.875rem" }}
// //               onClick={() => setShowAdvanced((v) => !v)}
// //             >
// //               {showAdvanced ? <ChevronDown size={11} /> : <ChevronRight size={11} />}
// //               Advanced options
// //             </button>
// //             {showAdvanced && (
// //               <div className="ex-form-group" style={{ padding: "0.5rem 0.875rem 0.875rem" }}>
// //                 <label className="ex-label">System Mapping <span className="ex-label-hint">optional ERP field code</span></label>
// //                 <input
// //                   className="ex-input"
// //                   value={field.system_mapping || ""}
// //                   onChange={(e) => onChange({ ...field, system_mapping: e.target.value })}
// //                   placeholder="ERP_FIELD_CODE"
// //                 />
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // // ─── Result Renderer ──────────────────────────────────────────────────────────

// // // Recursive renderer for nested object/table results
// // const NestedObjectRenderer = ({ data, label, depth = 0 }) => {
// //   if (data === null || data === undefined || data === "") {
// //     return <span className="ex-result-field-empty">—</span>;
// //   }
// //   if (typeof data !== "object") {
// //     return <span>{String(data)}</span>;
// //   }
// //   if (Array.isArray(data)) {
// //     if (data.length === 0) return <span className="ex-result-field-empty">empty array</span>;
// //     // Table rendering for arrays of objects
// //     if (typeof data[0] === "object" && data[0] !== null) {
// //       const allKeys = [...new Set(data.flatMap((row) => Object.keys(row)))];
// //       // Check if any values are nested objects
// //       const hasNestedValues = data.some((row) =>
// //         Object.values(row).some((v) => typeof v === "object" && v !== null)
// //       );
// //       if (!hasNestedValues) {
// //         // Simple table
// //         return (
// //           <div className="ex-result-table-card" style={{ marginLeft: depth > 0 ? "0.5rem" : 0 }}>
// //             <div className="ex-result-table-header">
// //               <Table2 size={12} />
// //               {label && <>{label.replace(/_/g, " ")} · </>}
// //               <span className="ex-result-table-count">{data.length} rows</span>
// //             </div>
// //             <div className="ex-result-table-wrapper">
// //               <table className="ex-result-table">
// //                 <thead>
// //                   <tr>{allKeys.map((col) => <th key={col}>{col}</th>)}</tr>
// //                 </thead>
// //                 <tbody>
// //                   {data.map((row, i) => (
// //                     <tr key={i}>
// //                       {allKeys.map((col) => {
// //                         const cell = row[col];
// //                         return (
// //                           <td key={col}>
// //                             {cell === null || cell === undefined ? "—" : String(cell)}
// //                           </td>
// //                         );
// //                       })}
// //                     </tr>
// //                   ))}
// //                 </tbody>
// //               </table>
// //             </div>
// //           </div>
// //         );
// //       }
// //       // Nested table - render each row as a card
// //       return (
// //         <div style={{ marginLeft: depth > 0 ? "0.5rem" : 0 }}>
// //           {label && (
// //             <div className="ex-nested-section-header">
// //               <Table2 size={12} />
// //               {label.replace(/_/g, " ")}
// //               <span className="ex-result-table-count">{data.length} items</span>
// //             </div>
// //           )}
// //           {data.map((item, i) => (
// //             <div key={i} className="ex-nested-card">
// //               <div className="ex-nested-card-index">#{i + 1}</div>
// //               <NestedObjectRenderer data={item} depth={depth + 1} />
// //             </div>
// //           ))}
// //         </div>
// //       );
// //     }
// //     // Array of primitives
// //     return <span>{data.join(", ")}</span>;
// //   }
// //   // Plain object
// //   const entries = Object.entries(data);
// //   const scalarEntries = entries.filter(([, v]) => typeof v !== "object" || v === null);
// //   const nestedEntries = entries.filter(([, v]) => typeof v === "object" && v !== null);

// //   return (
// //     <div style={{ marginLeft: depth > 0 ? "0.5rem" : 0 }}>
// //       {label && depth > 0 && (
// //         <div className="ex-nested-section-header">
// //           <Braces size={12} />
// //           {label.replace(/_/g, " ")}
// //         </div>
// //       )}
// //       {scalarEntries.length > 0 && (
// //         <div className="ex-scalar-grid">
// //           {scalarEntries.map(([key, value]) => (
// //             <div key={key} className="ex-result-field">
// //               <div className="ex-result-field-label">
// //                 <Type size={10} />
// //                 {key.replace(/_/g, " ")}
// //               </div>
// //               <div className="ex-result-field-value">
// //                 {value !== null && value !== undefined && value !== "" ? String(value) : <span className="ex-result-field-empty">—</span>}
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       )}
// //       {nestedEntries.map(([key, value]) => (
// //         <NestedObjectRenderer key={key} data={value} label={key} depth={depth + 1} />
// //       ))}
// //     </div>
// //   );
// // };

// // const ResultRenderer = ({ data, templateName }) => {
// //   const [viewMode, setViewMode] = useState("structured");

// //   const extractedData = data?.extracted_data ?? data;

// //   if (!extractedData || Object.keys(extractedData).length === 0) {
// //     return (
// //       <div className="ex-empty">
// //         <div className="ex-empty-icon"><AlertCircle size={32} /></div>
// //         <p className="ex-empty-title">No Data Extracted</p>
// //         <p className="ex-empty-hint">
// //           Gemini returned empty results. Try updating the field instructions to be more specific.
// //         </p>
// //       </div>
// //     );
// //   }

// //   // Detect if the result has deep nested structures (object schema output)
// //   const hasDeepNesting = Object.values(extractedData).some((v) => {
// //     if (typeof v === "object" && v !== null && !Array.isArray(v)) return true;
// //     if (Array.isArray(v) && v.length > 0 && typeof v[0] === "object" && v[0] !== null) {
// //       return Object.values(v[0]).some((inner) => typeof inner === "object" && inner !== null);
// //     }
// //     return false;
// //   });

// //   return (
// //     <div className="ex-results">
// //       <div className="ex-result-toggle">
// //         <button
// //           className={`ex-result-toggle-btn ${viewMode === "structured" ? "active" : ""}`}
// //           onClick={() => setViewMode("structured")}
// //         >
// //           <Layers size={12} /> Formatted
// //         </button>
// //         <button
// //           className={`ex-result-toggle-btn ${viewMode === "json" ? "active" : ""}`}
// //           onClick={() => setViewMode("json")}
// //         >
// //           <Code2 size={12} /> JSON
// //         </button>
// //         <div className="ex-result-actions">
// //           <button
// //             className="ex-result-copy-btn"
// //             title="Copy JSON"
// //             onClick={() => navigator.clipboard.writeText(JSON.stringify(extractedData, null, 2))}
// //           >
// //             <Copy size={12} /> Copy
// //           </button>
// //           <DownloadCSVButton data={data} templateName={templateName} />
// //         </div>
// //       </div>

// //       {viewMode === "json" && (
// //         <div className="ex-json-block">
// //           <pre className="ex-json-content">
// //             {JSON.stringify(extractedData, null, 2)}
// //           </pre>
// //         </div>
// //       )}

// //       {viewMode === "structured" && (
// //         hasDeepNesting ? (
// //           <div style={{ padding: "0.5rem" }}>
// //             <NestedObjectRenderer data={extractedData} depth={0} />
// //           </div>
// //         ) : (
// //           <>
// //             {(() => {
// //               const entries = Object.entries(extractedData);
// //               const isSimpleTable = (arr) => {
// //                 if (!Array.isArray(arr) || arr.length === 0) return false;
// //                 const firstItem = arr[0];
// //                 if (typeof firstItem !== "object" || firstItem === null) return false;
// //                 return Object.values(firstItem).every(v => {
// //                   if (v === null || v === undefined) return true;
// //                   return typeof v !== "object" || (typeof v === "string" || typeof v === "number" || typeof v === "boolean");
// //                 });
// //               };
// //               const tableFields  = entries.filter(([, v]) => Array.isArray(v) && isSimpleTable(v));
// //               const scalarFields = entries.filter(([, v]) => !(Array.isArray(v) && isSimpleTable(v)));
// //               return (
// //                 <>
// //                   {scalarFields.length > 0 && scalarFields.some(([, v]) => typeof v !== "object" || v === null) && (
// //                     <div className="ex-scalar-grid">
// //                       {scalarFields.filter(([, v]) => typeof v !== "object" || v === null).map(([key, value]) => (
// //                         <div key={key} className="ex-result-field">
// //                           <div className="ex-result-field-label">
// //                             <Type size={10} />
// //                             {key.replace(/_/g, " ")}
// //                           </div>
// //                           <div className="ex-result-field-value">
// //                             {value !== null && value !== undefined && value !== "" ? (
// //                               String(value)
// //                             ) : (
// //                               <span className="ex-result-field-empty">—</span>
// //                             )}
// //                           </div>
// //                         </div>
// //                       ))}
// //                     </div>
// //                   )}

// //                   {tableFields.map(([key, rows]) => (
// //                     <div key={key} className="ex-result-table-card">
// //                       <div className="ex-result-table-header">
// //                         <Table2 size={12} />
// //                         {key.replace(/_/g, " ")}
// //                         <span className="ex-result-table-count">{rows.length} rows</span>
// //                       </div>
// //                       <div className="ex-result-table-wrapper">
// //                         <table className="ex-result-table">
// //                           <thead>
// //                             <tr>
// //                               {Object.keys(rows[0]).map((col) => (
// //                                 <th key={col}>{col}</th>
// //                               ))}
// //                             </tr>
// //                           </thead>
// //                           <tbody>
// //                             {rows.map((row, i) => (
// //                               <tr key={i}>
// //                                 {Object.values(row).map((cell, j) => {
// //                                   let displayValue = cell;
// //                                   if (typeof cell === "object" && cell !== null) {
// //                                     if (Array.isArray(cell)) displayValue = `[Array: ${cell.length} items]`;
// //                                     else displayValue = `[Object]`;
// //                                   } else if (cell === null || cell === undefined) {
// //                                     displayValue = "—";
// //                                   }
// //                                   return <td key={j}>{displayValue}</td>;
// //                                 })}
// //                               </tr>
// //                             ))}
// //                           </tbody>
// //                         </table>
// //                       </div>
// //                     </div>
// //                   ))}

// //                   {scalarFields.filter(([, v]) => typeof v === "object" && v !== null && !Array.isArray(v)).length > 0 && (
// //                     <div className="ex-scalar-grid">
// //                       {scalarFields.filter(([, v]) => typeof v === "object" && v !== null && !Array.isArray(v)).map(([key, value]) => (
// //                         <div key={key} className="ex-result-field">
// //                           <div className="ex-result-field-label">
// //                             <Code2 size={10} />
// //                             {key.replace(/_/g, " ")}
// //                           </div>
// //                           <div className="ex-result-field-value" style={{ fontSize: "0.6875rem", fontFamily: "monospace" }}>
// //                             {JSON.stringify(value, null, 1)}
// //                           </div>
// //                         </div>
// //                       ))}
// //                     </div>
// //                   )}
// //                 </>
// //               );
// //             })()}
// //           </>
// //         )
// //       )}
// //     </div>
// //   );
// // };

// // // ─── New Template Wizard (3-step slide-over) ──────────────────────────────────

// // const WIZARD_STEPS = [
// //   { num: 1, label: "Basics" },
// //   { num: 2, label: "Engine" },
// //   { num: 3, label: "Fields" },
// // ];

// // const WizardStepBar = ({ current }) => (
// //   <div className="ex-wizard-steps">
// //     {WIZARD_STEPS.map((s, i) => {
// //       const isDone   = s.num < current;
// //       const isActive = s.num === current;
// //       return (
// //         <React.Fragment key={s.num}>
// //           <div className={`ex-wizard-step ${isDone ? "ex-wizard-step--done" : ""} ${isActive ? "ex-wizard-step--active" : ""}`}>
// //             <div className="ex-wizard-step-num">
// //               {isDone ? <Check size={10} /> : s.num}
// //             </div>
// //             {s.label}
// //           </div>
// //           {i < WIZARD_STEPS.length - 1 && <div className="ex-wizard-connector" />}
// //         </React.Fragment>
// //       );
// //     })}
// //   </div>
// // );

// // const NewTemplateSlideOver = ({ isOpen, onClose, onCreated }) => {
// //   // Wizard state
// //   const [step, setStep] = useState(1);

// //   // Step 1 – Basics
// //   const [name, setName]               = useState("");
// //   const [slug, setSlug]               = useState("");
// //   const [slugManual, setSlugManual]   = useState(false);
// //   const [documentType, setDocumentType] = useState("invoice");
// //   const [nameError, setNameError]     = useState("");
// //   const [slugError, setSlugError]     = useState("");
// //   const [showAdvanced, setShowAdvanced] = useState(false);
// //   const nameRef = useRef(null);

// //   // Step 2 – Engine (no default — user must actively choose)
// //   const [engine, setEngine] = useState(null);

// //   // Step 3 – Fields
// //   const [selectedKeys, setSelectedKeys] = useState(new Set());
// //   const [showJsonImport, setShowJsonImport] = useState(false);
// //   const [importedFields, setImportedFields] = useState([]);
// //   const [importError, setImportError] = useState("");

// //   // Saving
// //   const [saving, setSaving]   = useState(false);
// //   const [apiError, setApiError] = useState("");

// //   // Reset on open
// //   useEffect(() => {
// //     if (isOpen) {
// //       setStep(1);
// //       setName(""); setSlug(""); setSlugManual(false);
// //       setDocumentType("invoice"); setNameError(""); setSlugError("");
// //       setShowAdvanced(false); setEngine(null);
// //       setImportedFields([]); setImportError(""); setShowJsonImport(false);
// //       setApiError(""); setSaving(false);
// //       setTimeout(() => nameRef.current?.focus(), 300);
// //     }
// //   }, [isOpen]);

// //   // Sync suggested field selection when doc type changes
// //   useEffect(() => {
// //     const suggestions = SUGGESTED_FIELDS[documentType] || [];
// //     setSelectedKeys(new Set(suggestions.map((f) => f.field_key)));
// //   }, [documentType]);

// //   // ── Step 1 handlers ──────────────────────────────────────────────────────
// //   const handleNameChange = (val) => {
// //     setName(val);
// //     setNameError("");
// //     if (!slugManual) setSlug(generateSlug(val));
// //   };

// //   const handleSlugChange = (val) => {
// //     setSlugManual(true);
// //     const s = generateSlug(val);
// //     setSlug(s);
// //     setSlugError(s.length > 0 && s.length < 3 ? "Min 3 characters" : "");
// //   };

// //   const goToStep2 = () => {
// //     if (!name.trim()) { setNameError("Template name is required"); return; }
// //     if (slug && slug.length < 3) { setSlugError("Min 3 characters"); return; }
// //     setStep(2);
// //   };

// //   // ── Step 3 handlers ──────────────────────────────────────────────────────
// //   const toggleKey = (key) => {
// //     setSelectedKeys((prev) => {
// //       const next = new Set(prev);
// //       if (next.has(key)) next.delete(key); else next.add(key);
// //       return next;
// //     });
// //   };

// //   const selectAll = () => {
// //     const suggestions = SUGGESTED_FIELDS[documentType] || [];
// //     setSelectedKeys(new Set(suggestions.map((f) => f.field_key)));
// //   };

// //   const deselectAll = () => setSelectedKeys(new Set());

// //   const handleJsonFile = (file) => {
// //     setImportError("");
// //     if (!file) return;
// //     const reader = new FileReader();
// //     reader.onload = (e) => {
// //       try {
// //         const parsed = JSON.parse(e.target.result);
// //         const arr = Array.isArray(parsed) ? parsed : parsed.fields;
// //         if (!Array.isArray(arr)) throw new Error("Expected an array of fields");
// //         const fields = arr.map((f, i) => ({
// //           field_key: f.field_key || f.name || `field_${i + 1}`,
// //           data_type: f.data_type || "text",
// //           instruction: f.instruction || "",
// //           output_rules: f.output_rules || "",
// //           field_order: f.field_order || i + 1,
// //           system_mapping: f.system_mapping || "",
// //           schema_definition: f.schema_definition || null,
// //         }));
// //         setImportedFields(fields);
// //       } catch (err) {
// //         setImportError("Failed to parse JSON: " + err.message);
// //         setImportedFields([]);
// //       }
// //     };
// //     reader.readAsText(file);
// //   };

// //   // ── Create ───────────────────────────────────────────────────────────────
// //   const handleCreate = async () => {
// //     const suggestions = SUGGESTED_FIELDS[documentType] || [];
// //     const checkedSuggestions = suggestions
// //       .filter((f) => selectedKeys.has(f.field_key))
// //       .map((f, i) => ({ ...f, field_order: i + 1 }));

// //     // Merge: checked suggestions first, then any JSON-imported extras (de-duped by key)
// //     const importedKeys = new Set(checkedSuggestions.map((f) => f.field_key));
// //     const extras = importedFields
// //       .filter((f) => !importedKeys.has(f.field_key))
// //       .map((f, i) => ({ ...f, field_order: checkedSuggestions.length + i + 1 }));

// //     const fields = [...checkedSuggestions, ...extras];

// //     setSaving(true);
// //     setApiError("");
// //     try {
// //       const payload = {
// //         name: name.trim(),
// //         slug: slug || generateSlug(name),
// //         document_type: documentType,
// //         extraction_engine: engine,
// //         retrieval_strategy: "full_text",
// //         llm_model_key: "gemini_2_5_flash_lite",
// //         fields,
// //       };
// //       const created = await createTemplate(payload);
// //       onCreated(created);
// //     } catch (err) {
// //       if (err.response?.data?.slug) {
// //         setSlugError("This slug is already in use.");
// //         setStep(1);
// //       } else {
// //         setApiError("Failed to create template. Please try again.");
// //       }
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   // ── Render ───────────────────────────────────────────────────────────────
// //   const suggestions = SUGGESTED_FIELDS[documentType] || [];

// //   return (
// //     <>
// //       {isOpen && <div className="ex-slideover-backdrop" onClick={onClose} />}
// //       <div className={`ex-slideover-panel ${isOpen ? "open" : ""}`} style={{ width: step === 2 ? "860px" : "440px", maxWidth: "95vw" }}>

// //         {/* Header */}
// //         <div className="ex-slideover-header">
// //           <h2 style={{ margin: 0, fontSize: "1.125rem", fontWeight: 700, color: "#171717" }}>New Template</h2>
// //           <button className="ex-modal-close" onClick={onClose}><X size={16} /></button>
// //         </div>

// //         {/* Step indicator */}
// //         <WizardStepBar current={step} />

// //         {/* ── STEP 1: BASICS ─────────────────────────────────────────── */}
// //         {step === 1 && (
// //           <>
// //             <div className="ex-slideover-body">
// //               <div className="ex-form-group">
// //                 <label className="ex-label">Template Name</label>
// //                 <input
// //                   ref={nameRef}
// //                   className={`ex-input ${nameError ? "error" : ""}`}
// //                   value={name}
// //                   onChange={(e) => handleNameChange(e.target.value)}
// //                   onKeyDown={(e) => { if (e.key === "Enter") goToStep2(); }}
// //                   placeholder="e.g. TJS Group Invoice"
// //                 />
// //                 {nameError && <span className="ex-error-text">{nameError}</span>}
// //               </div>

// //               <div className="ex-form-group">
// //                 <label className="ex-label">Document Type</label>
// //                 <select
// //                   className="ex-input"
// //                   value={documentType}
// //                   onChange={(e) => setDocumentType(e.target.value)}
// //                 >
// //                   <option value="invoice">Invoice</option>
// //                   <option value="purchase_order">Purchase Order</option>
// //                   <option value="contract">Contract</option>
// //                   <option value="receipt">Receipt</option>
// //                   <option value="custom">Custom</option>
// //                 </select>
// //               </div>

// //               {/* Advanced: Slug (hidden by default) */}
// //               <div>
// //                 <button
// //                   type="button"
// //                   className="ex-advanced-toggle"
// //                   onClick={() => setShowAdvanced((v) => !v)}
// //                 >
// //                   {showAdvanced ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
// //                   Advanced options
// //                 </button>
// //                 {showAdvanced && (
// //                   <div className="ex-form-group" style={{ marginTop: "0.75rem" }}>
// //                     <label className="ex-label">
// //                       Slug <span className="ex-label-hint">auto-generated — edit if needed</span>
// //                     </label>
// //                     <input
// //                       className={`ex-input ${slugError ? "error" : ""}`}
// //                       value={slug}
// //                       onChange={(e) => handleSlugChange(e.target.value)}
// //                       placeholder="unique-identifier"
// //                       style={{ fontFamily: "'Fira Code', monospace" }}
// //                     />
// //                     {slugError && <span className="ex-error-text">{slugError}</span>}
// //                   </div>
// //                 )}
// //               </div>
// //             </div>

// //             <div className="ex-slideover-footer">
// //               <button className="ex-btn ex-btn-ghost" onClick={onClose}>Cancel</button>
// //               <button className="ex-btn ex-btn-primary" onClick={goToStep2} disabled={!name.trim()}>
// //                 Next: Choose Engine →
// //               </button>
// //             </div>
// //           </>
// //         )}

// //         {/* ── STEP 2: ENGINE ─────────────────────────────────────────── */}
// //         {step === 2 && (
// //           <>
// //             <div style={{ flex: 1, overflowY: "auto" }}>
// //               <div style={{ padding: "0.875rem 1.25rem 0.5rem", fontSize: "0.8125rem", color: "#52525b" }}>
// //                 Click a card to select the engine for <strong>{name}</strong>. Sample documents show what each engine handles best.
// //               </div>
// //               <EngineCardGrid selected={engine} onChange={setEngine} />
// //             </div>

// //             <div className="ex-slideover-footer">
// //               <button className="ex-btn ex-btn-ghost" onClick={() => setStep(1)}>← Back</button>
// //               <button
// //                 className="ex-btn ex-btn-primary"
// //                 onClick={() => setStep(3)}
// //                 disabled={!engine}
// //               >
// //                 {engine ? "Next: Review Fields →" : "Select an engine above"}
// //               </button>
// //             </div>
// //           </>
// //         )}

// //         {/* ── STEP 3: FIELDS ─────────────────────────────────────────── */}
// //         {step === 3 && (
// //           <>
// //             <div className="ex-slideover-body">
// //               {suggestions.length > 0 ? (
// //                 <>
// //                   <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
// //                     <span style={{ fontSize: "0.8125rem", color: "#52525b" }}>
// //                       Suggested fields for <strong>{documentType.replace("_", " ")}</strong> — uncheck any you don't need.
// //                     </span>
// //                     <div style={{ display: "flex", gap: "0.5rem" }}>
// //                       <button type="button" className="ex-suggested-select-all" onClick={selectAll}>All</button>
// //                       <span style={{ color: "#e5e7eb" }}>·</span>
// //                       <button type="button" className="ex-suggested-select-all" onClick={deselectAll}>None</button>
// //                     </div>
// //                   </div>

// //                   <div className="ex-suggested-fields">
// //                     {suggestions.map((f) => {
// //                       const meta = DATA_TYPE_META[f.data_type] || DATA_TYPE_META.text;
// //                       const Icon = meta.icon;
// //                       return (
// //                         <label key={f.field_key} className="ex-suggested-field-row">
// //                           <input
// //                             type="checkbox"
// //                             checked={selectedKeys.has(f.field_key)}
// //                             onChange={() => toggleKey(f.field_key)}
// //                           />
// //                           <Icon size={11} style={{ color: "#9ca3af", flexShrink: 0 }} />
// //                           <span className="ex-suggested-field-key">{f.field_key}</span>
// //                           <span className={`ex-field-type-badge ${meta.color}`} style={{ fontSize: "0.5rem", flexShrink: 0 }}>{meta.label}</span>
// //                           <span className="ex-suggested-field-hint">{f.instruction}</span>
// //                         </label>
// //                       );
// //                     })}
// //                   </div>
// //                   <div style={{ fontSize: "0.6875rem", color: "#9ca3af" }}>
// //                     {selectedKeys.size} of {suggestions.length} fields selected — you can add, edit or remove fields after creation.
// //                   </div>
// //                 </>
// //               ) : (
// //                 <div className="ex-no-suggestions">
// //                   No suggested fields for custom templates.<br />
// //                   You can add fields manually in the Schema editor after creating.
// //                 </div>
// //               )}

// //               {/* JSON import (collapsed by default) */}
// //               <div>
// //                 <button
// //                   type="button"
// //                   className="ex-import-json-toggle"
// //                   onClick={() => setShowJsonImport((v) => !v)}
// //                 >
// //                   {showJsonImport ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
// //                   Import additional fields from JSON
// //                 </button>
// //                 {showJsonImport && (
// //                   <div className="ex-form-group" style={{ marginTop: "0.75rem" }}>
// //                     <div className="ex-json-dropzone">
// //                       <Upload size={18} style={{ color: "#9ca3af", marginBottom: "0.25rem" }} />
// //                       <p style={{ margin: 0, fontSize: "0.8125rem", color: "#71717A" }}>
// //                         Drag and drop JSON file or click to browse
// //                       </p>
// //                       <input
// //                         type="file"
// //                         accept=".json"
// //                         onChange={(e) => { handleJsonFile(e.target.files[0]); e.target.value = ""; }}
// //                       />
// //                     </div>
// //                     {importError && <span className="ex-error-text">{importError}</span>}
// //                     {importedFields.length > 0 && (
// //                       <span style={{ fontSize: "0.75rem", color: "#10b981" }}>
// //                         <CheckCircle2 size={12} style={{ display: "inline", verticalAlign: "middle" }} /> {importedFields.length} fields imported
// //                       </span>
// //                     )}
// //                   </div>
// //                 )}
// //               </div>

// //               {apiError && (
// //                 <div style={{ fontSize: "0.8125rem", color: "#DC2626" }}>{apiError}</div>
// //               )}
// //             </div>

// //             <div className="ex-slideover-footer">
// //               <button className="ex-btn ex-btn-ghost" onClick={() => setStep(2)}>← Back</button>
// //               <button className="ex-btn ex-btn-primary" onClick={handleCreate} disabled={saving}>
// //                 {saving ? <Spinner size={13} /> : null}
// //                 Create Template →
// //               </button>
// //             </div>
// //           </>
// //         )}
// //       </div>
// //     </>
// //   );
// // };

// // // ─── Template Workspace ──────────────────────────────────────────────────────

// // const TemplateWorkspace = ({ template: initialTemplate, onBack }) => {
// //   // Template state
// //   const [template, setTemplate] = useState(initialTemplate);
// //   const [saveStatus, setSaveStatus] = useState("idle"); // idle | unsaved | saving | saved
// //   const saveTimerRef = useRef(null);
// //   const savedTimerRef = useRef(null);

// //   // Tabs
// //   const [activeTab, setActiveTab] = useState("schema");

// //   // Inline name editing
// //   const [editingName, setEditingName] = useState(false);
// //   const nameInputRef = useRef(null);
// //   const [slugDraft, setSlugDraft] = useState(initialTemplate.slug || "");
// //   const [slugError, setSlugError] = useState("");
// //   const [slugSaving, setSlugSaving] = useState(false);

// //   // Schema version tracking
// //   const [schemaVersion, setSchemaVersion] = useState(0);
// //   const [lastExtractedSchemaVersion, setLastExtractedSchemaVersion] = useState(0);

// //   // Document / extraction state (for Test tab)
// //   const [documents, setDocuments] = useState([]);
// //   const [activeDocId, setActiveDocId] = useState(null);
// //   const [leftTab, setLeftTab] = useState("pdf");
// //   const [dragging, setDragging] = useState(false);
// //   const [ocrEngine, setOcrEngine] = useState(initialTemplate.extraction_engine || "");
// //   const [isOcrModalOpen, setIsOcrModalOpen] = useState(false);
// //   const [pendingFiles, setPendingFiles] = useState(null);
// //   const [reindex, setReindex] = useState(false);
// //   const [engineChanged, setEngineChanged] = useState(false);      // tracks if engine changed after docs ingested
// //   const [isEngineSettingsModal, setIsEngineSettingsModal] = useState(false); // modal opened from Pipeline Settings
// //   const [batchRunning, setBatchRunning] = useState(false);
// //   const [activePage, setActivePage] = useState(1);

// //   // Highlight state
// //   const [highlightFields, setHighlightFields] = useState({});

// //   // Pipeline Settings popover
// //   const [pipelineOpen, setPipelineOpen] = useState(false);
// //   const pipelineRef = useRef(null);
// //   const [apiOpen, setApiOpen] = useState(false);
// //   const apiRef = useRef(null);
// //   const [apiSnippetMode, setApiSnippetMode] = useState("curl");
// //   const [copiedKey, setCopiedKey] = useState("");
// //   const copyTimerRef = useRef(null);

// //   const fileInputRef = useRef(null);

// //   // Close workspace popovers on outside click
// //   useEffect(() => {
// //     if (!pipelineOpen && !apiOpen) return;
// //     const handler = (e) => {
// //       if (pipelineRef.current && !pipelineRef.current.contains(e.target)) {
// //         setPipelineOpen(false);
// //       }
// //       if (apiRef.current && !apiRef.current.contains(e.target)) {
// //         setApiOpen(false);
// //       }
// //     };
// //     document.addEventListener("mousedown", handler);
// //     return () => document.removeEventListener("mousedown", handler);
// //   }, [pipelineOpen, apiOpen]);

// //   useEffect(() => {
// //     setSlugDraft(template?.slug || "");
// //     setSlugError("");
// //   }, [template?.slug]);

// //   useEffect(() => () => {
// //     if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
// //   }, []);

// //   // Load full template on mount if fields not populated
// //   useEffect(() => {
// //     if (initialTemplate?.id && (!initialTemplate.fields || initialTemplate.fields.length === undefined)) {
// //       getTemplate(initialTemplate.id).then((full) => {
// //         setTemplate(full);
// //       }).catch(() => {});
// //     }
// //   }, [initialTemplate]);

// //   // ── Auto-save logic ─────────────────────────────────────────────────────────

// //   const triggerAutoSave = useCallback((updatedTemplate) => {
// //     setSaveStatus("unsaved");
// //     if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
// //     if (savedTimerRef.current) clearTimeout(savedTimerRef.current);

// //     saveTimerRef.current = setTimeout(async () => {
// //       setSaveStatus("saving");
// //       try {
// //         const saved = await updateTemplate(updatedTemplate.id, updatedTemplate);
// //         setTemplate(saved);
// //         setSaveStatus("saved");
// //         savedTimerRef.current = setTimeout(() => setSaveStatus("idle"), 3000);
// //       } catch {
// //         setSaveStatus("unsaved");
// //       }
// //     }, 800);
// //   }, []);

// //   const markCopied = useCallback((key) => {
// //     setCopiedKey(key);
// //     if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
// //     copyTimerRef.current = setTimeout(() => setCopiedKey(""), 1800);
// //   }, []);

// //   const copyToClipboard = useCallback(async (text, key) => {
// //     try {
// //       await copyTextToClipboard(text);
// //       markCopied(key);
// //     } catch {
// //       window.alert("Couldn't copy automatically. Please copy the text manually.");
// //     }
// //   }, [markCopied]);

// //   const updateTemplateField = (key, value) => {
// //     setTemplate((prev) => {
// //       const updated = { ...prev, [key]: value };
// //       triggerAutoSave(updated);
// //       return updated;
// //     });
// //   };

// //   const handleSlugDraftChange = (value) => {
// //     const nextSlug = generateSlug(value);
// //     setSlugDraft(nextSlug);
// //     if (!nextSlug) {
// //       setSlugError("");
// //       return;
// //     }
// //     setSlugError(nextSlug.length < 3 ? "Slug must be at least 3 characters." : "");
// //   };

// //   const handleSlugSave = async () => {
// //     const nextSlug = generateSlug(slugDraft);

// //     if (!nextSlug) {
// //       setSlugError("Slug is required.");
// //       return;
// //     }

// //     if (nextSlug.length < 3) {
// //       setSlugError("Slug must be at least 3 characters.");
// //       return;
// //     }

// //     if (nextSlug === (template.slug || "")) {
// //       setSlugError("");
// //       return;
// //     }

// //     if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
// //     if (savedTimerRef.current) clearTimeout(savedTimerRef.current);

// //     setSlugSaving(true);
// //     setSlugError("");
// //     setSaveStatus("saving");

// //     try {
// //       const saved = await updateTemplate(template.id, {
// //         ...template,
// //         slug: nextSlug,
// //       });
// //       setTemplate(saved);
// //       setSaveStatus("saved");
// //       savedTimerRef.current = setTimeout(() => setSaveStatus("idle"), 3000);
// //     } catch (err) {
// //       setSaveStatus("unsaved");
// //       const slugMessage = err.response?.data?.slug;
// //       setSlugError(
// //         Array.isArray(slugMessage)
// //           ? slugMessage[0]
// //           : slugMessage || "Failed to update slug. Please try again."
// //       );
// //     } finally {
// //       setSlugSaving(false);
// //     }
// //   };

// //   // ── Field management ────────────────────────────────────────────────────────

// //   const addField = () => {
// //     setTemplate((prev) => {
// //       const updated = {
// //         ...prev,
// //         fields: [
// //           ...(prev.fields || []),
// //           {
// //             field_key: `field_${(prev.fields?.length || 0) + 1}`,
// //             data_type: "text",
// //             instruction: "",
// //             output_rules: "",
// //             field_order: (prev.fields?.length || 0) + 1,
// //             system_mapping: "",
// //             schema_definition: null,
// //           },
// //         ],
// //       };
// //       triggerAutoSave(updated);
// //       setSchemaVersion((v) => v + 1);
// //       return updated;
// //     });
// //   };

// //   const updateField = (idx, updatedField) => {
// //     setTemplate((prev) => {
// //       const fields = [...(prev.fields || [])];
// //       fields[idx] = updatedField;
// //       const updated = { ...prev, fields };
// //       triggerAutoSave(updated);
// //       setSchemaVersion((v) => v + 1);
// //       return updated;
// //     });
// //   };

// //   const deleteField = (idx) => {
// //     setTemplate((prev) => {
// //       const updated = {
// //         ...prev,
// //         fields: (prev.fields || []).filter((_, i) => i !== idx),
// //       };
// //       triggerAutoSave(updated);
// //       setSchemaVersion((v) => v + 1);
// //       return updated;
// //     });
// //   };

// //   // ── Name editing ────────────────────────────────────────────────────────────

// //   const handleNameBlur = () => {
// //     setEditingName(false);
// //     if (template.name?.trim()) {
// //       triggerAutoSave(template);
// //     }
// //   };

// //   const handleNameKeyDown = (e) => {
// //     if (e.key === "Enter") {
// //       e.target.blur();
// //     }
// //   };

// //   // ── Document handling (for Test tab) ────────────────────────────────────────

// //   const updateDoc = useCallback((docId, updates) => {
// //     setDocuments((prev) =>
// //       prev.map((d) => (d.id === docId ? { ...d, ...updates } : d))
// //     );
// //   }, []);

// //   const handleFiles = useCallback(async (fileList, forceEngine = null) => {
// //     if (!fileList || fileList.length === 0) return;

// //     const engineToUse = forceEngine || ocrEngine;
// //     if (!engineToUse) {
// //       setPendingFiles(Array.from(fileList));
// //       setIsOcrModalOpen(true);
// //       return;
// //     }

// //     const newDocs = Array.from(fileList).map((f) => ({
// //       id: nextDocId(),
// //       file: f,
// //       ingestData: null,
// //       ingesting: true,
// //       extracting: false,
// //       result: null,
// //       selected: true,
// //     }));

// //     setDocuments((prev) => [...prev, ...newDocs]);
// //     setActiveDocId((prev) => prev || newDocs[0].id);

// //     for (const doc of newDocs) {
// //       try {
// //         const data = await ingestDocument(doc.file, { engine: engineToUse, reindex });
// //         setDocuments((prev) =>
// //           prev.map((d) =>
// //             d.id === doc.id ? { ...d, ingestData: data, ingesting: false } : d
// //           )
// //         );
// //       } catch {
// //         setDocuments((prev) =>
// //           prev.map((d) =>
// //             d.id === doc.id ? { ...d, ingesting: false, ingestData: null } : d
// //           )
// //         );
// //       }
// //     }
// //   }, [ocrEngine, reindex]);

// //   const handleOcrEngineSelect = (selectedEngine) => {
// //     const prevEngine = ocrEngine;
// //     setOcrEngine(selectedEngine);
// //     setIsOcrModalOpen(false);

// //     if (isEngineSettingsModal) {
// //       // Opened from Pipeline Settings — update the template engine
// //       updateTemplateField("extraction_engine", selectedEngine);
// //       setIsEngineSettingsModal(false);
// //       // Flag that docs need re-ingestion if there are already ingested docs
// //       if (prevEngine && prevEngine !== selectedEngine && documents.some((d) => d.ingestData)) {
// //         setEngineChanged(true);
// //       }
// //     } else if (pendingFiles) {
// //       handleFiles(pendingFiles, selectedEngine);
// //       setPendingFiles(null);
// //     }
// //   };

// //   const onDrop = useCallback(
// //     (e) => {
// //       e.preventDefault();
// //       setDragging(false);
// //       if (e.dataTransfer.files?.length > 0) handleFiles(e.dataTransfer.files);
// //     },
// //     [handleFiles]
// //   );

// //   const onDragOver = (e) => { e.preventDefault(); setDragging(true); };
// //   const onDragLeave = () => setDragging(false);

// //   const removeDoc = (docId) => {
// //     setDocuments((prev) => prev.filter((d) => d.id !== docId));
// //     setActiveDocId((prev) => {
// //       if (prev !== docId) return prev;
// //       const remaining = documents.filter((d) => d.id !== docId);
// //       return remaining.length > 0 ? remaining[0].id : null;
// //     });
// //   };

// //   // ── Re-ingest documents with current engine ────────────────────────────────

// //   const handleReIngest = async () => {
// //     const docsToReIngest = documents.filter((d) => d.selected && d.file);
// //     if (docsToReIngest.length === 0) return;

// //     setEngineChanged(false);

// //     for (const doc of docsToReIngest) {
// //       updateDoc(doc.id, { ingesting: true, ingestData: null, result: null });
// //     }

// //     for (const doc of docsToReIngest) {
// //       try {
// //         const data = await ingestDocument(doc.file, { engine: ocrEngine, reindex: true });
// //         updateDoc(doc.id, { ingestData: data, ingesting: false });
// //       } catch {
// //         updateDoc(doc.id, { ingesting: false, ingestData: null });
// //       }
// //     }
// //   };

// //   // ── Batch Extraction ────────────────────────────────────────────────────────

// //   const handleBatchExtract = async () => {
// //     if (!template?.slug) return;
// //     const docsToExtract = documents.filter((d) => d.selected && d.ingestData && !d.extracting);
// //     if (docsToExtract.length === 0) return;

// //     setBatchRunning(true);

// //     for (const doc of docsToExtract) {
// //       updateDoc(doc.id, { extracting: true, result: null });
// //     }

// //     for (const doc of docsToExtract) {
// //       try {
// //         const data = await universalExtract(doc.file, template.slug, { reindex });
// //         updateDoc(doc.id, { result: data, extracting: false });
// //       } catch {
// //         updateDoc(doc.id, {
// //           result: { _error: "Extraction failed. Check template instructions." },
// //           extracting: false,
// //         });
// //       }
// //     }

// //     setLastExtractedSchemaVersion(schemaVersion);
// //     setBatchRunning(false);
// //   };

// //   // ── Derived state ───────────────────────────────────────────────────────────

// //   const activeDoc = documents.find((d) => d.id === activeDocId);
// //   const readyCount = documents.filter((d) => d.selected && d.ingestData).length;
// //   const canExtract = readyCount > 0 && template?.slug && !batchRunning;
// //   const fields = template?.fields || [];
// //   const isStale = activeDoc?.result && !activeDoc.result._error && schemaVersion > lastExtractedSchemaVersion && lastExtractedSchemaVersion > 0;
// //   const trimmedSlugDraft = slugDraft.trim();
// //   const canSaveSlug =
// //     !!trimmedSlugDraft &&
// //     trimmedSlugDraft.length >= 3 &&
// //     trimmedSlugDraft !== (template?.slug || "") &&
// //     !slugSaving;
// //   const universalExtractUrl = buildUniversalExtractUrl(template?.slug || "");
// //   const curlSnippet = buildCurlSnippet(template?.slug || "");
// //   const fetchSnippet = buildFetchSnippet(template?.slug || "");
// //   const activeApiSnippet = apiSnippetMode === "curl" ? curlSnippet : fetchSnippet;

// //   // Text highlighting helper
// //   const getHighlightedText = (pageText) => {
// //     if (!pageText) return pageText;
// //     const activeHighlights = Object.entries(highlightFields).filter(([, v]) => v);
// //     if (activeHighlights.length === 0) return null;

// //     const extractedData = activeDoc?.result?.extracted_data ?? activeDoc?.result;
// //     if (!extractedData) return null;

// //     let html = pageText.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// //     for (const [fieldKey] of activeHighlights) {
// //       const val = extractedData[fieldKey];
// //       if (val && typeof val === "string" && val.trim()) {
// //         const escaped = val.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
// //         const regex = new RegExp(`(${escaped})`, "gi");
// //         html = html.replace(regex, `<mark class="ex-highlight">$1</mark>`);
// //       }
// //     }
// //     return html;
// //   };

// //   const hasActiveHighlights = Object.values(highlightFields).some(Boolean);

// //   // Auto-switch to text view when highlight enabled
// //   useEffect(() => {
// //     if (hasActiveHighlights && leftTab === "pdf") {
// //       setLeftTab("text");
// //     }
// //   }, [hasActiveHighlights]);

// //   // ── Render ──────────────────────────────────────────────────────────────────

// //   return (
// //     <div className="ex-workspace">
// //       <OcrEngineModal
// //         isOpen={isOcrModalOpen}
// //         onClose={() => { setIsOcrModalOpen(false); setPendingFiles(null); setIsEngineSettingsModal(false); }}
// //         onSelect={handleOcrEngineSelect}
// //         currentEngine={ocrEngine}
// //       />

// //       {/* ── TOP BAR ──────────────────────────────────────────────────────── */}
// //       <div className="ex-workspace-topbar">
// //         <button className="ex-builder-back" onClick={onBack}>
// //           <ArrowLeft size={16} /> Back
// //         </button>

// //         {/* Template name - inline editable */}
// //         <div className="ex-template-title-group">
// //           {editingName ? (
// //             <input
// //               ref={nameInputRef}
// //               className="ex-name-editable"
// //               style={{ fontSize: "1rem", fontWeight: 700, color: "#171717", width: "200px" }}
// //               value={template.name || ""}
// //               onChange={(e) => setTemplate((prev) => ({ ...prev, name: e.target.value }))}
// //               onBlur={handleNameBlur}
// //               onKeyDown={handleNameKeyDown}
// //               autoFocus
// //             />
// //           ) : (
// //             <span
// //               style={{ fontSize: "1rem", fontWeight: 700, color: "#171717", cursor: "pointer", display: "flex", alignItems: "center", gap: "0.375rem" }}
// //               onClick={() => setEditingName(true)}
// //             >
// //               {template.name || "Untitled"}
// //               <Pencil size={12} style={{ color: "#9ca3af" }} />
// //             </span>
// //           )}
// //           {template.slug && (
// //             <span
// //               className="ex-template-card-slug"
// //               title="This slug is used in the universal extract API."
// //             >
// //               /{template.slug}
// //             </span>
// //           )}
// //         </div>

// //         {/* Save status */}
// //         {saveStatus === "unsaved" && (
// //           <span className="ex-save-status ex-save-status--unsaved">● Unsaved changes</span>
// //         )}
// //         {saveStatus === "saving" && (
// //           <span className="ex-save-status ex-save-status--saving"><Spinner size={10} /> Saving...</span>
// //         )}
// //         {saveStatus === "saved" && (
// //           <span className="ex-save-status ex-save-status--saved"><CheckCircle2 size={12} /> Saved</span>
// //         )}

// //         {/* Doc type badge */}
// //         {template.document_type && (
// //           <span className="ex-template-card-badge">{template.document_type}</span>
// //         )}

// //         {/* Center tabs */}
// //         <div className="ex-workspace-tabs">
// //           {["schema", "test", "history"].map((tab) => (
// //             <button
// //               key={tab}
// //               className={`ex-workspace-tab ${activeTab === tab ? "active" : ""}`}
// //               onClick={() => setActiveTab(tab)}
// //             >
// //               {tab.charAt(0).toUpperCase() + tab.slice(1)}
// //             </button>
// //           ))}
// //         </div>

// //         {/* Pipeline Settings — single button replacing 3 raw selects */}
// //         <div className="ex-pipeline-settings-wrapper" ref={pipelineRef}>
// //           <button
// //             className="ex-btn ex-btn-ghost"
// //             onClick={() => {
// //               setApiOpen(false);
// //               setPipelineOpen((v) => !v);
// //             }}
// //             style={{ gap: "0.375rem" }}
// //           >
// //             <Settings size={13} />
// //             Pipeline Settings
// //             <ChevronDown size={11} style={{ opacity: 0.6 }} />
// //           </button>
// //           {pipelineOpen && (
// //             <div className="ex-pipeline-popover">
// //               <div className="ex-pipeline-popover-title">Pipeline Settings</div>

// //               <div className="ex-pipeline-setting-row">
// //                 <span className="ex-pipeline-setting-label">Template Slug</span>
// //                 <span className="ex-pipeline-setting-hint">Used in the universal extract API URL for this template</span>
// //                 <div className="ex-slug-settings-row">
// //                   <input
// //                     className={`ex-input ex-slug-settings-input ${slugError ? "error" : ""}`}
// //                     value={slugDraft}
// //                     onChange={(e) => handleSlugDraftChange(e.target.value)}
// //                     onKeyDown={(e) => {
// //                       if (e.key === "Enter") handleSlugSave();
// //                     }}
// //                     placeholder="unique-template-slug"
// //                   />
// //                   <button
// //                     className="ex-btn ex-btn-secondary ex-btn-sm"
// //                     onClick={handleSlugSave}
// //                     disabled={!canSaveSlug}
// //                   >
// //                     {slugSaving ? <><Spinner size={12} /> Updating</> : "Update"}
// //                   </button>
// //                 </div>
// //                 {slugError && (
// //                   <span className="ex-pipeline-setting-error">{slugError}</span>
// //                 )}
// //               </div>

// //               <div className="ex-pipeline-setting-row">
// //                 <span className="ex-pipeline-setting-label">Extraction Engine</span>
// //                 <span className="ex-pipeline-setting-hint">How the document is read before AI processing</span>
// //                 <button
// //                   className="ex-engine-select-btn"
// //                   onClick={() => {
// //                     setIsEngineSettingsModal(true);
// //                     setIsOcrModalOpen(true);
// //                     setPipelineOpen(false);
// //                   }}
// //                 >
// //                   <Cpu size={13} />
// //                   <span className="ex-engine-select-btn-label">
// //                     {ENGINE_OPTIONS.find((o) => o.value === (template.extraction_engine || ocrEngine))?.label || "Select Engine"}
// //                   </span>
// //                   <span className="ex-engine-select-btn-desc">
// //                     {ENGINE_OPTIONS.find((o) => o.value === (template.extraction_engine || ocrEngine))?.shortDesc || ""}
// //                   </span>
// //                   <ChevronRight size={13} style={{ marginLeft: "auto", opacity: 0.4, flexShrink: 0 }} />
// //                 </button>
// //               </div>

// //               <div className="ex-pipeline-setting-row">
// //                 <span className="ex-pipeline-setting-label">AI Model</span>
// //                 <span className="ex-pipeline-setting-hint">Model used to extract the fields</span>
// //                 <select
// //                   className="ex-topbar-select"
// //                   style={{ width: "100%", marginTop: "0.25rem" }}
// //                   value={template.llm_model_key || "gemini_2_5_flash_lite"}
// //                   onChange={(e) => updateTemplateField("llm_model_key", e.target.value)}
// //                 >
// //                   {LLM_MODEL_OPTIONS.map((opt) => (
// //                     <option key={opt.value} value={opt.value}>{opt.label}</option>
// //                   ))}
// //                 </select>
// //               </div>

// //               <div className="ex-pipeline-setting-row">
// //                 <span className="ex-pipeline-setting-label">Retrieval Mode</span>
// //                 <span className="ex-pipeline-setting-hint">How relevant sections are found in long documents</span>
// //                 <select
// //                   className="ex-topbar-select"
// //                   style={{ width: "100%", marginTop: "0.25rem" }}
// //                   value={template.retrieval_strategy || "full_text"}
// //                   onChange={(e) => updateTemplateField("retrieval_strategy", e.target.value)}
// //                 >
// //                   {RETRIEVAL_OPTIONS.map((opt) => (
// //                     <option key={opt.value} value={opt.value}>{opt.label}</option>
// //                   ))}
// //                 </select>
// //               </div>
// //             </div>
// //           )}
// //         </div>

// //         <div className="ex-pipeline-settings-wrapper" ref={apiRef}>
// //           <button
// //             className="ex-btn ex-btn-ghost"
// //             onClick={() => {
// //               setPipelineOpen(false);
// //               setApiOpen((v) => !v);
// //             }}
// //             style={{ gap: "0.375rem" }}
// //           >
// //             <Code2 size={13} />
// //             API Usage
// //             <ChevronDown size={11} style={{ opacity: 0.6 }} />
// //           </button>
// //           {apiOpen && (
// //             <div className="ex-api-popover">
// //               <div className="ex-pipeline-popover-title">Universal Extract API</div>
// //               <p className="ex-api-popover-hint">
// //                 Post a file to this endpoint with your saved template slug to reuse the template anywhere.
// //               </p>

// //               <div className="ex-api-meta-row">
// //                 <div>
// //                   <span className="ex-pipeline-setting-label">Template Slug</span>
// //                   <code className="ex-api-inline-code">{template.slug}</code>
// //                 </div>
// //                 <button
// //                   className="ex-result-copy-btn"
// //                   onClick={() => copyToClipboard(template.slug || "", "slug")}
// //                 >
// //                   {copiedKey === "slug" ? <><Check size={12} /> Copied</> : <><Copy size={12} /> Copy</>}
// //                 </button>
// //               </div>

// //               <div className="ex-api-meta-row">
// //                 <div className="ex-api-meta-copy">
// //                   <span className="ex-pipeline-setting-label">Endpoint</span>
// //                   <code className="ex-api-inline-code ex-api-inline-code--multiline">
// //                     {universalExtractUrl}
// //                   </code>
// //                 </div>
// //                 <button
// //                   className="ex-result-copy-btn"
// //                   onClick={() => copyToClipboard(universalExtractUrl, "endpoint")}
// //                 >
// //                   {copiedKey === "endpoint" ? <><Check size={12} /> Copied</> : <><Copy size={12} /> Copy</>}
// //                 </button>
// //               </div>

// //               <div className="ex-api-note">
// //                 Send the document as <strong>multipart/form-data</strong> in the <code>file</code> field and include a bearer token.
// //               </div>

// //               <div className="ex-api-snippet-tabs">
// //                 <button
// //                   className={`ex-api-snippet-tab ${apiSnippetMode === "curl" ? "active" : ""}`}
// //                   onClick={() => setApiSnippetMode("curl")}
// //                 >
// //                   cURL
// //                 </button>
// //                 <button
// //                   className={`ex-api-snippet-tab ${apiSnippetMode === "fetch" ? "active" : ""}`}
// //                   onClick={() => setApiSnippetMode("fetch")}
// //                 >
// //                   JavaScript
// //                 </button>
// //               </div>

// //               <div className="ex-api-snippet-card">
// //                 <button
// //                   className="ex-result-copy-btn ex-api-snippet-copy"
// //                   onClick={() => copyToClipboard(activeApiSnippet, "snippet")}
// //                 >
// //                   {copiedKey === "snippet" ? <><Check size={12} /> Copied</> : <><Copy size={12} /> Copy Snippet</>}
// //                 </button>
// //                 <pre className="ex-api-snippet-pre">{activeApiSnippet}</pre>
// //               </div>
// //             </div>
// //           )}
// //         </div>

// //         <div className="ex-topbar-divider-v" />

// //         {activeTab === "schema" && (
// //           <button className="ex-btn ex-btn-ghost" onClick={addField}>
// //             <Plus size={13} /> Add Field
// //           </button>
// //         )}
// //         {activeTab === "test" && (
// //           <>
// //             <button
// //               className="ex-btn ex-btn-ghost"
// //               onClick={() => fileInputRef.current?.click()}
// //             >
// //               <Plus size={13} /> Add Files
// //             </button>
// //             <input
// //               ref={fileInputRef}
// //               type="file"
// //               multiple
// //               accept=".pdf,.png,.jpg,.jpeg,.docx,.txt,.xlsx,.xls,.csv"
// //               style={{ display: "none" }}
// //               onChange={(e) => { handleFiles(e.target.files); e.target.value = ""; }}
// //             />
// //             <button
// //               className="ex-run-btn"
// //               onClick={handleBatchExtract}
// //               disabled={!canExtract}
// //             >
// //               {batchRunning ? (
// //                 <><Spinner size={14} /> Extracting…</>
// //               ) : (
// //                 <><Sparkles size={14} /> Run Extraction{readyCount > 0 ? ` (${readyCount})` : ""}</>
// //               )}
// //             </button>
// //           </>
// //         )}
// //       </div>

// //       {/* ── BODY ─────────────────────────────────────────────────────────── */}
// //       <div className="ex-workspace-body">

// //         {/* ── SCHEMA TAB ─────────────────────────────────────────────────── */}
// //         {activeTab === "schema" && (
// //           <div className="ex-workspace-schema-panel ex-workspace-schema-panel--full" style={{ background: "#FEF9F7" }}>
// //             <div className="ex-builder-fields-header">
// //               <span className="ex-builder-section-title">
// //                 <Layers size={13} />
// //                 Extraction Fields
// //                 <span className="ex-field-count-badge">{fields.length}</span>
// //               </span>
// //               <button className="ex-add-field-btn" onClick={addField}>
// //                 <Plus size={13} /> Add Field
// //               </button>
// //             </div>
// //             <div className="ex-builder-fields-scroll">
// //               {fields.length === 0 ? (
// //                 <div className="ex-fields-empty">
// //                   <div className="ex-fields-empty-icon"><Layers size={28} /></div>
// //                   <p className="ex-fields-empty-title">No fields defined</p>
// //                   <p className="ex-fields-empty-hint">Add fields to tell the AI what data to extract from your documents.</p>
// //                   <button className="ex-add-field-btn ex-add-field-btn--large" onClick={addField}>
// //                     <Plus size={14} /> Add Your First Field
// //                   </button>
// //                 </div>
// //               ) : (
// //                 <div className="ex-fields-list">
// //                   {fields.map((field, idx) => (
// //                     <FieldRow
// //                       key={idx}
// //                       index={idx}
// //                       field={field}
// //                       onChange={(updated) => updateField(idx, updated)}
// //                       onDelete={() => deleteField(idx)}
// //                     />
// //                   ))}
// //                 </div>
// //               )}
// //             </div>
// //           </div>
// //         )}

// //         {/* ── TEST TAB ───────────────────────────────────────────────────── */}
// //         {activeTab === "test" && (
// //           <>
// //             {/* Left: Compact schema panel */}
// //             <div className="ex-workspace-schema-panel ex-workspace-schema-panel--compact" style={{ background: "#fff" }}>
// //               <div className="ex-panel-topbar">
// //                 <span className="ex-panel-title">
// //                   Schema
// //                   <span className="ex-field-count-badge">{fields.length}</span>
// //                 </span>
// //               </div>
// //               <div style={{ flex: 1, overflowY: "auto", padding: "0.5rem 0" }}>
// //                 {fields.length === 0 ? (
// //                   <div className="ex-empty" style={{ padding: "1.5rem" }}>
// //                     <p className="ex-empty-hint">No fields defined yet</p>
// //                   </div>
// //                 ) : (
// //                   fields.map((field, idx) => {
// //                     const meta = DATA_TYPE_META[field.data_type] || DATA_TYPE_META.text;
// //                     const FIcon = meta.icon;
// //                     return (
// //                       <div key={idx} className="ex-compact-field">
// //                         <FIcon size={12} style={{ color: "#9ca3af", flexShrink: 0 }} />
// //                         <span style={{ flex: 1, fontSize: "0.8125rem", fontFamily: "'Fira Code', monospace", color: "#3F3F46" }}>
// //                           {field.field_key}
// //                         </span>
// //                         <span className={`ex-field-type-badge ${meta.color}`} style={{ fontSize: "0.5rem" }}>
// //                           {meta.label}
// //                         </span>
// //                       </div>
// //                     );
// //                   })
// //                 )}
// //               </div>
// //               <div style={{ padding: "0.5rem 0.75rem", borderTop: "1px solid #e5e7eb" }}>
// //                 <button
// //                   className="ex-btn ex-btn-ghost ex-btn-sm"
// //                   style={{ width: "100%", justifyContent: "center" }}
// //                   onClick={() => setActiveTab("schema")}
// //                 >
// //                   Edit Schema →
// //                 </button>
// //               </div>
// //             </div>

// //             {/* Center: Document Viewer */}
// //             <div
// //               className="ex-workspace-doc-panel"
// //               onDrop={onDrop}
// //               onDragOver={onDragOver}
// //               onDragLeave={onDragLeave}
// //               style={{ position: "relative" }}
// //             >
// //               {dragging && (
// //                 <div className="ex-drop-overlay">
// //                   <Upload size={32} />
// //                   <span className="ex-drop-overlay-text">Drop to upload</span>
// //                 </div>
// //               )}

// //               {/* Doc tabs */}
// //               {documents.length > 0 && (
// //                 <div className="ex-doc-tabs">
// //                   <div className="ex-doc-tabs-scroll">
// //                     {documents.map((doc) => (
// //                       <div
// //                         key={doc.id}
// //                         className={`ex-doc-tab ${doc.id === activeDocId ? "active" : ""}`}
// //                         onClick={() => setActiveDocId(doc.id)}
// //                       >
// //                         <input
// //                           type="checkbox"
// //                           className="ex-doc-tab-checkbox"
// //                           checked={!!doc.selected}
// //                           title={doc.selected ? "Selected for extraction" : "Click to include in extraction"}
// //                           onClick={(e) => e.stopPropagation()}
// //                           onChange={(e) => {
// //                             const checked = e.target.checked;
// //                             setDocuments((prev) =>
// //                               prev.map((d) => d.id === doc.id ? { ...d, selected: checked } : d)
// //                             );
// //                           }}
// //                         />
// //                         <span className="ex-doc-tab-name">{doc.file.name}</span>
// //                         {doc.ingesting && <Spinner size={10} />}
// //                         {!doc.ingesting && doc.ingestData && !doc.result && (
// //                           <CheckCircle2 size={11} className="ex-doc-tab-ready" />
// //                         )}
// //                         {doc.extracting && <Spinner size={10} />}
// //                         {doc.result && !doc.result._error && !doc.extracting && (
// //                           <CheckCircle2 size={11} className="ex-doc-tab-done" />
// //                         )}
// //                         {doc.result && doc.result._error && (
// //                           <XCircle size={11} className="ex-doc-tab-error" />
// //                         )}
// //                         <button
// //                           className="ex-doc-tab-close"
// //                           onClick={(e) => { e.stopPropagation(); removeDoc(doc.id); }}
// //                         >
// //                           <X size={11} />
// //                         </button>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 </div>
// //               )}

// //               {/* Engine changed banner */}
// //               {engineChanged && documents.length > 0 && (
// //                 <div className="ex-engine-changed-banner">
// //                   <RefreshCw size={14} />
// //                   <span>Engine changed to <strong>{ENGINE_OPTIONS.find((o) => o.value === ocrEngine)?.label}</strong> — documents need re-processing</span>
// //                   <button
// //                     className="ex-btn ex-btn-primary ex-btn-sm"
// //                     onClick={handleReIngest}
// //                   >
// //                     Re-process{documents.filter((d) => d.selected).length > 0
// //                       ? ` (${documents.filter((d) => d.selected).length})`
// //                       : ""}
// //                   </button>
// //                 </div>
// //               )}

// //               {/* Panel header */}
// //               <div className="ex-panel-topbar">
// //                 <span className="ex-panel-title">
// //                   <FileText size={13} />
// //                   Document Viewer
// //                 </span>
// //                 {activeDoc?.ingestData && (
// //                   <span style={{ fontSize: "0.6875rem", color: "#9ca3af", marginLeft: "auto" }}>
// //                     Page {activePage} of {activeDoc.ingestData.pages?.length || 0}
// //                   </span>
// //                 )}
// //               </div>

// //               {/* View tabs for loaded doc */}
// //               {activeDoc?.ingestData && (
// //                 <div className="ex-tabs">
// //                   <button
// //                     className={`ex-tab ${leftTab === "pdf" ? "active" : ""}`}
// //                     onClick={() => setLeftTab("pdf")}
// //                   >
// //                     <Eye size={12} /> PDF View
// //                   </button>
// //                   <button
// //                     className={`ex-tab ${leftTab === "text" ? "active" : ""}`}
// //                     onClick={() => setLeftTab("text")}
// //                   >
// //                     <Code2 size={12} /> AI Text View
// //                   </button>
// //                 </div>
// //               )}

// //               {/* Content area */}
// //               {activeDoc?.ingesting ? (
// //                 <div className="ex-ingesting">
// //                   <div className="ex-ingesting-bar">
// //                     <div className="ex-ingesting-bar-fill" />
// //                   </div>
// //                   <span className="ex-ingesting-text">Indexing {activeDoc.file.name}…</span>
// //                   <span className="ex-ingesting-subtext">
// //                     Processing with {ENGINE_OPTIONS.find(e => e.value === ocrEngine)?.label || ocrEngine} engine
// //                   </span>
// //                 </div>
// //               ) : activeDoc?.ingestData ? (
// //                 <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>
// //                   {/* Thumbnail strip */}
// //                   <div className="ex-doc-thumbnail-strip">
// //                     {activeDoc.ingestData.pages?.map((page, idx) => {
// //                       const pageNum = page?.page_number ?? idx + 1;
// //                       return (
// //                         <div
// //                           key={pageNum}
// //                           className={`ex-doc-thumbnail ${activePage === pageNum ? "active" : ""}`}
// //                           onClick={() => setActivePage(pageNum)}
// //                         >
// //                           {pageNum}
// //                         </div>
// //                       );
// //                     })}
// //                   </div>

// //                   {/* Main view */}
// //                   <div className="ex-doc-main-area" style={{ flexDirection: "column" }}>
// //                     {leftTab === "pdf" && (
// //                       <iframe
// //                         className="ex-pdf-frame"
// //                         src={activeDoc.ingestData.file_url}
// //                         title="Document PDF"
// //                       />
// //                     )}
// //                     {leftTab === "text" && (
// //                       <div className="ex-text-view">
// //                         {activeDoc.ingestData.pages?.map((page) => {
// //                           const pageNumber = page?.page_number ?? activeDoc.ingestData.pages.indexOf(page) + 1;
// //                           const pageText = typeof page === "string" ? page : page?.text ?? "";
// //                           const highlightHtml = getHighlightedText(pageText);

// //                           return (
// //                             <div key={pageNumber} className="ex-page-block">
// //                               <div className="ex-page-block-header">
// //                                 <FileText size={11} />
// //                                 Page {pageNumber}
// //                                 <span className="ex-page-line-count">
// //                                   {pageText.split("\n").length} lines
// //                                 </span>
// //                               </div>
// //                               {highlightHtml ? (
// //                                 <pre
// //                                   className="ex-page-block-content"
// //                                   dangerouslySetInnerHTML={{ __html: highlightHtml }}
// //                                 />
// //                               ) : (
// //                                 <pre className="ex-page-block-content">{pageText}</pre>
// //                               )}
// //                             </div>
// //                           );
// //                         })}
// //                       </div>
// //                     )}
// //                   </div>
// //                 </div>
// //               ) : documents.length === 0 ? (
// //                 <div
// //                   className={`ex-drop-zone ${dragging ? "dragging" : ""}`}
// //                   onClick={() => fileInputRef.current?.click()}
// //                 >
// //                   <div className="ex-drop-icon">
// //                     <Upload size={22} />
// //                   </div>
// //                   <p className="ex-drop-title">Drop your documents here</p>
// //                   <p className="ex-drop-hint">or click to browse — supports multiple files</p>
// //                   <span className="ex-drop-badge">PDF · DOCX · TXT · XLS · CSV · PNG · JPG</span>
// //                 </div>
// //               ) : activeDoc && !activeDoc.ingestData && !activeDoc.ingesting ? (
// //                 <div className="ex-ingesting">
// //                   <div className="ex-empty-icon"><AlertCircle size={28} /></div>
// //                   <span className="ex-ingesting-text">Ingestion failed for this document</span>
// //                   <span className="ex-ingesting-subtext">Try removing and re-uploading</span>
// //                 </div>
// //               ) : (
// //                 <div className="ex-ingesting">
// //                   <span className="ex-ingesting-text">Select a document tab above</span>
// //                 </div>
// //               )}
// //             </div>

// //             {/* Right: Results panel */}
// //             <div className="ex-workspace-results-panel" style={{ background: "#fff" }}>
// //               <div className="ex-panel-topbar">
// //                 <span className="ex-panel-title">Results</span>
// //               </div>

// //               {/* Stale banner */}
// //               {isStale && (
// //                 <div className="ex-stale-banner">
// //                   <RefreshCw size={14} style={{ color: "#f59e0b" }} />
// //                   <span>Schema updated — re-run to refresh</span>
// //                   <button
// //                     className="ex-btn ex-btn-primary ex-stale-banner-btn"
// //                     onClick={handleBatchExtract}
// //                     disabled={!canExtract}
// //                   >
// //                     Run Again
// //                   </button>
// //                 </div>
// //               )}

// //               <div style={{ flex: 1, overflowY: "auto", opacity: isStale ? 0.6 : 1, transition: "opacity 0.2s" }}>
// //                 {activeDoc?.extracting ? (
// //                   /* Skeleton loading state */
// //                   <div style={{ padding: "1rem" }}>
// //                     {fields.map((field, idx) => (
// //                       <div key={idx} className="ex-skeleton-card">
// //                         <span style={{ fontSize: "0.75rem", color: "#9ca3af", fontWeight: 500 }}>
// //                           {field.field_key}
// //                         </span>
// //                         <div className="ex-skeleton-bar ex-skeleton-bar--long" />
// //                         <div className="ex-skeleton-bar ex-skeleton-bar--medium" />
// //                       </div>
// //                     ))}
// //                     {fields.length === 0 && (
// //                       <div className="ex-skeleton-card">
// //                         <div className="ex-skeleton-bar ex-skeleton-bar--short" />
// //                         <div className="ex-skeleton-bar ex-skeleton-bar--long" />
// //                         <div className="ex-skeleton-bar ex-skeleton-bar--medium" />
// //                       </div>
// //                     )}
// //                   </div>
// //                 ) : activeDoc?.result ? (
// //                   activeDoc.result._error ? (
// //                     <div className="ex-empty">
// //                       <div className="ex-empty-icon"><AlertCircle size={28} /></div>
// //                       <p className="ex-empty-title">Extraction Failed</p>
// //                       <p className="ex-empty-hint">{activeDoc.result._error}</p>
// //                     </div>
// //                   ) : (
// //                     <>
// //                       {/* Success status bar */}
// //                       <div style={{
// //                         padding: "0.5rem 0.875rem",
// //                         borderBottom: "1px solid #e5e7eb",
// //                         fontSize: "0.75rem",
// //                         color: "#10b981",
// //                         display: "flex",
// //                         alignItems: "center",
// //                         gap: "0.375rem",
// //                       }}>
// //                         <CheckCircle2 size={12} />
// //                         Extracted successfully · {Object.keys(activeDoc.result?.extracted_data ?? activeDoc.result ?? {}).length} fields
// //                       </div>

// //                       <ResultRenderer
// //                         data={activeDoc.result}
// //                         templateName={template?.name ?? "Extraction"}
// //                       />

// //                       {/* Highlight toggles */}
// //                       {fields.length > 0 && (
// //                         <div style={{ padding: "0.5rem 0.875rem", borderTop: "1px solid #e5e7eb" }}>
// //                           <span style={{ fontSize: "0.625rem", fontWeight: 700, color: "#71717A", textTransform: "uppercase", letterSpacing: "0.06em" }}>
// //                             Highlight in document
// //                           </span>
// //                           {fields.map((field) => {
// //                             const extractedData = activeDoc.result?.extracted_data ?? activeDoc.result;
// //                             const val = extractedData?.[field.field_key];
// //                             if (!val || typeof val !== "string") return null;
// //                             return (
// //                               <label
// //                                 key={field.field_key}
// //                                 style={{
// //                                   display: "flex", alignItems: "center", gap: "0.5rem",
// //                                   padding: "0.25rem 0", fontSize: "0.75rem", color: "#3F3F46", cursor: "pointer",
// //                                 }}
// //                               >
// //                                 <input
// //                                   type="checkbox"
// //                                   checked={!!highlightFields[field.field_key]}
// //                                   onChange={(e) => setHighlightFields((prev) => ({
// //                                     ...prev,
// //                                     [field.field_key]: e.target.checked,
// //                                   }))}
// //                                   style={{ accentColor: "#8B55DD" }}
// //                                 />
// //                                 {field.field_key.replace(/_/g, " ")}
// //                               </label>
// //                             );
// //                           })}
// //                         </div>
// //                       )}
// //                     </>
// //                   )
// //                 ) : (
// //                   <div className="ex-empty" style={{ paddingTop: "3rem" }}>
// //                     <div className="ex-empty-icon"><Wand2 size={28} /></div>
// //                     <p className="ex-empty-title">Run an extraction</p>
// //                     <p className="ex-empty-hint">
// //                       Upload a document and click Run Extraction to see results here.
// //                     </p>
// //                   </div>
// //                 )}
// //               </div>
// //             </div>
// //           </>
// //         )}

// //         {/* ── HISTORY TAB ────────────────────────────────────────────────── */}
// //         {activeTab === "history" && (
// //           <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
// //             <div className="ex-empty">
// //               <div className="ex-empty-icon"><Clock size={28} /></div>
// //               <p className="ex-empty-title">History coming soon</p>
// //               <p className="ex-empty-hint">
// //                 Extraction history and version tracking will appear here.
// //               </p>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // // ─── Templates Dashboard ──────────────────────────────────────────────────────

// // const TemplatesDashboard = ({ onNewTemplate, onOpenWorkspace }) => {
// //   const [templates, setTemplates]   = useState([]);
// //   const [loading, setLoading]       = useState(true);
// //   const [dupeId, setDupeId]         = useState(null);
// //   const [searchQuery, setSearchQuery] = useState("");
// //   const [openMenuId, setOpenMenuId] = useState(null);
// //   const [copiedTemplateId, setCopiedTemplateId] = useState(null);
// //   const copyTimerRef = useRef(null);

// //   useEffect(() => { loadTemplates(); }, []);

// //   useEffect(() => () => {
// //     if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
// //   }, []);

// //   // Close menu on outside click
// //   useEffect(() => {
// //     if (!openMenuId) return;
// //     const handler = () => setOpenMenuId(null);
// //     document.addEventListener("click", handler);
// //     return () => document.removeEventListener("click", handler);
// //   }, [openMenuId]);

// //   const loadTemplates = async () => {
// //     try {
// //       const data = await getTemplates();
// //       setTemplates(data);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleDelete = async (id) => {
// //     if (!window.confirm("Delete this template? This cannot be undone.")) return;
// //     try {
// //       const { deleteTemplate } = await import("./extractorApi");
// //       await deleteTemplate(id);
// //       setTemplates((prev) => prev.filter((t) => t.id !== id));
// //     } catch {
// //       alert("Failed to delete template.");
// //     }
// //   };

// //   const handleDuplicate = async (id) => {
// //     setDupeId(id);
// //     try {
// //       const copy = await duplicateTemplate(id);
// //       setTemplates((prev) => [...prev, copy]);
// //     } catch {
// //       alert("Failed to duplicate.");
// //     } finally {
// //       setDupeId(null);
// //     }
// //   };

// //   const handleCopyEndpoint = async (e, template) => {
// //     e.stopPropagation();
// //     if (!template?.slug) return;

// //     try {
// //       await copyTextToClipboard(buildUniversalExtractUrl(template.slug));
// //       setCopiedTemplateId(template.id);
// //       if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
// //       copyTimerRef.current = setTimeout(() => setCopiedTemplateId(null), 1800);
// //     } catch {
// //       window.alert("Couldn't copy automatically. Please copy the endpoint manually.");
// //     }
// //   };

// //   const filteredTemplates = templates.filter((t) => {
// //     if (!searchQuery.trim()) return true;
// //     const q = searchQuery.toLowerCase();
// //     return (
// //       (t.name || "").toLowerCase().includes(q) ||
// //       (t.slug || "").toLowerCase().includes(q)
// //     );
// //   });

// //   return (
// //     <div className="ex-dashboard">
// //       <div className="ex-dashboard-header">
// //         <div>
// //           <h1 className="ex-dashboard-title">Templates</h1>
// //         </div>
// //         <button
// //           className="ex-btn ex-btn-primary"
// //           onClick={onNewTemplate}
// //         >
// //           <Plus size={14} /> New Template
// //         </button>
// //       </div>

// //       {/* Search */}
// //       {/* <div className="ex-search-input-wrapper">
// //         <Search size={16} />
// //         <input
// //           className="ex-search-input"
// //           placeholder="Search templates..."
// //           value={searchQuery}
// //           onChange={(e) => setSearchQuery(e.target.value)}
// //         />
// //       </div> */}

// //       {/* Onboarding Hero */}
// //       <OnboardingHero />

// //       {/* Starter Template Gallery */}
// //       <StarterTemplateGallery
// //         suggestedFields={SUGGESTED_FIELDS}
// //         onOpenWorkspace={onOpenWorkspace}
// //         onOpenWizard={onNewTemplate}
// //       />

// //       {loading ? (
// //         <div className="ex-loading-center">
// //           <Spinner size={28} />
// //         </div>
// //       ) : templates.length === 0 ? (
// //         <div className="ex-empty" style={{ marginTop: "4rem" }}>
// //           <div className="ex-empty-icon"><Layers size={40} /></div>
// //           <p className="ex-empty-title">No templates yet</p>
// //           <p className="ex-empty-hint">Create your first extraction template to get started.</p>
// //         </div>
// //       ) : filteredTemplates.length === 0 ? (
// //         <div className="ex-empty" style={{ marginTop: "2rem" }}>
// //           <p className="ex-empty-title">No matching templates</p>
// //           <p className="ex-empty-hint">Try a different search term.</p>
// //         </div>
// //       ) : (
// //         <div className="ex-template-grid">
// //           {filteredTemplates.map((t) => (
// //             <div
// //               key={t.id}
// //               className="ex-template-card"
// //               style={{ cursor: "pointer" }}
// //               onClick={() => onOpenWorkspace(t)}
// //             >
// //               <div className="ex-template-card-header">
// //                 <div className="ex-template-card-title-group">
// //                   <p className="ex-template-card-name">{t.name}</p>
// //                   <div className="ex-template-card-row">
// //                     {t.slug && (
// //                       <span className="ex-template-card-slug">{t.slug}</span>
// //                     )}
// //                     <span className="ex-template-card-badge">{t.document_type}</span>
// //                   </div>
// //                 </div>
// //                 {/* Three-dot menu */}
// //                 <div className="ex-card-menu-wrapper">
// //                   <button
// //                     className="ex-card-menu-btn"
// //                     onClick={(e) => {
// //                       e.stopPropagation();
// //                       setOpenMenuId(openMenuId === t.id ? null : t.id);
// //                     }}
// //                   >
// //                     <MoreVertical size={16} />
// //                   </button>
// //                   {openMenuId === t.id && (
// //                     <div className="ex-card-menu-dropdown">
// //                       <button
// //                         className="ex-card-menu-item"
// //                         onClick={(e) => {
// //                           e.stopPropagation();
// //                           setOpenMenuId(null);
// //                           onOpenWorkspace(t);
// //                         }}
// //                       >
// //                         <Settings size={14} /> Edit
// //                       </button>
// //                       <button
// //                         className="ex-card-menu-item"
// //                         onClick={(e) => {
// //                           e.stopPropagation();
// //                           setOpenMenuId(null);
// //                           handleDuplicate(t.id);
// //                         }}
// //                         disabled={dupeId === t.id}
// //                       >
// //                         <Copy size={14} /> Duplicate
// //                       </button>
// //                       <button
// //                         className="ex-card-menu-item ex-card-menu-item--danger"
// //                         onClick={(e) => {
// //                           e.stopPropagation();
// //                           setOpenMenuId(null);
// //                           handleDelete(t.id);
// //                         }}
// //                       >
// //                         <Trash2 size={14} /> Delete
// //                       </button>
// //                     </div>
// //                   )}
// //                 </div>
// //               </div>
// //               <div className="ex-template-card-divider" />
// //               <div className="ex-template-card-footer">
// //                 <div className="ex-template-card-stats">
// //                   <span className="ex-template-card-stat">{t.fields?.length || 0} fields</span>
// //                   <span className="ex-template-card-stat">
// //                     <Clock size={11} />
// //                     Updated {t.updated_at ? new Date(t.updated_at).toLocaleDateString() : "-"}
// //                   </span>
// //                 </div>
// //                 <button
// //                   className="ex-template-card-copy-btn"
// //                   onClick={(e) => handleCopyEndpoint(e, t)}
// //                   disabled={!t.slug}
// //                 >
// //                   {copiedTemplateId === t.id ? (
// //                     <><Check size={13} /> Copied</>
// //                   ) : (
// //                     <><Copy size={13} /> Copy Endpoint</>
// //                   )}
// //                 </button>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // // ─── Root Page Component ──────────────────────────────────────────────────────

// // const Extractor = () => {
// //   const [view, setView] = useState("TEMPLATES");
// //   const [activeTemplate, setActiveTemplate] = useState(null);
// //   const [slideOverOpen, setSlideOverOpen] = useState(false);

// //   const openWorkspace = (template) => {
// //     setActiveTemplate(template);
// //     setView("WORKSPACE");
// //   };

// //   const goBackToTemplates = () => {
// //     setActiveTemplate(null);
// //     setView("TEMPLATES");
// //   };

// //   const handleTemplateCreated = (template) => {
// //     setSlideOverOpen(false);
// //     openWorkspace(template);
// //   };

// //   return (
// //     <div className="ex-root">
// //       {/* Legacy Internal Sidebar Removed */}

// //       {/* Main */}
// //       <main className="ex-main">
// //         {view === "TEMPLATES" && (
// //           <>
// //             <TemplatesDashboard
// //               onNewTemplate={() => setSlideOverOpen(true)}
// //               onOpenWorkspace={openWorkspace}
// //             />
// //             <NewTemplateSlideOver
// //               isOpen={slideOverOpen}
// //               onClose={() => setSlideOverOpen(false)}
// //               onCreated={handleTemplateCreated}
// //             />
// //           </>
// //         )}
// //         {view === "WORKSPACE" && activeTemplate && (
// //           <TemplateWorkspace
// //             template={activeTemplate}
// //             onBack={goBackToTemplates}
// //           />
// //         )}
// //       </main>
// //     </div>
// //   );
// // };

// // export { generateSlug, Spinner };
// // export default Extractor;

// import React, { useState, useEffect, useCallback, useRef } from "react";
// import {
//   Sparkles,
//   LayoutGrid,
//   Upload,
//   FileText,
//   Eye,
//   Code2,
//   Plus,
//   Settings,
//   Trash2,
//   Copy,
//   ChevronDown,
//   ChevronRight,
//   Save,
//   X,
//   Clock,
//   Layers,
//   Wand2,
//   AlertCircle,
//   CheckCircle2,
//   Table2,
//   Hash,
//   Calendar,
//   Type,
//   RefreshCw,
//   Cpu,
//   ArrowLeft,
//   Check,
//   SquareCheck,
//   Square,
//   XCircle,
//   MoreVertical,
//   Search,
//   Pencil,
//   Braces,
// } from "lucide-react";
// import {
//   ingestDocument,
//   getTemplates,
//   getTemplate,
//   createTemplate,
//   updateTemplate,
//   duplicateTemplate,
//   universalExtract,
//   API_BASE,
//   UNIVERSAL_EXTRACT_PATH,
// } from "./extractorApi";
// import "./extractor.css"; // keep — contains keyframes + scrollbar + <mark> highlight only
// import DownloadCSVButton from "./DownloadCSVButton";
// import OcrEngineModal, { ENGINE_OPTIONS, EngineCardGrid } from "./OcrEngineModal";
// import { OnboardingHero, StarterTemplateGallery } from "./DashboardOnboarding";

// // ─── Helpers ─────────────────────────────────────────────────────────────────

// let _docIdCounter = 0;
// const nextDocId = () => `doc_${++_docIdCounter}_${Date.now()}`;

// const Spinner = ({ size = 16 }) => (
//   <svg
//     className="animate-spin"
//     width={size}
//     height={size}
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2.5"
//   >
//     <path d="M21 12a9 9 0 1 1-6.219-8.56" />
//   </svg>
// );

// const generateSlug = (name) =>
//   name
//     .toLowerCase()
//     .trim()
//     .replace(/[^a-z0-9\s-]/g, "")
//     .replace(/\s+/g, "-")
//     .replace(/-+/g, "-");

// const formatBytes = (bytes) => {
//   if (bytes < 1024) return `${bytes} B`;
//   if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
//   return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
// };

// const copyTextToClipboard = async (text) => {
//   if (navigator.clipboard?.writeText) {
//     await navigator.clipboard.writeText(text);
//     return;
//   }

//   const textarea = document.createElement("textarea");
//   textarea.value = text;
//   textarea.setAttribute("readonly", "");
//   textarea.style.position = "absolute";
//   textarea.style.left = "-9999px";
//   document.body.appendChild(textarea);
//   textarea.select();
//   document.execCommand("copy");
//   document.body.removeChild(textarea);
// };

// const buildUniversalExtractUrl = (slug) =>
//   `${API_BASE}${UNIVERSAL_EXTRACT_PATH}?template=${encodeURIComponent(slug || "")}`;

// const buildCurlSnippet = (slug) => `curl -X POST "${buildUniversalExtractUrl(slug)}" \\
//   -H "Authorization: Bearer YOUR_ACCESS_TOKEN" \\
//   -F "file=@/path/to/document.pdf"`;

// const buildFetchSnippet = (slug) => `const formData = new FormData();
// formData.append("file", file);

// const response = await fetch("${buildUniversalExtractUrl(slug)}", {
//   method: "POST",
//   headers: {
//     Authorization: "Bearer YOUR_ACCESS_TOKEN",
//   },
//   body: formData,
// });

// const data = await response.json();
// console.log(data);`;

// // Field type meta — Tailwind class strings instead of CSS color tokens
// const DATA_TYPE_META = {
//   text:   { label: "Text",   icon: Type,     badge: "bg-blue-500/10 text-blue-500"     },
//   number: { label: "Number", icon: Hash,     badge: "bg-green-600/10 text-green-600"   },
//   date:   { label: "Date",   icon: Calendar, badge: "bg-yellow-600/10 text-yellow-600" },
//   table:  { label: "Table",  icon: Table2,   badge: "bg-[#8B55DD]/10 text-[#8B55DD]"   },
//   object: { label: "Object", icon: Braces,   badge: "bg-orange-600/10 text-orange-600" },
// };

// const RETRIEVAL_OPTIONS = [
//   { value: "full_text",  label: "Full Text" },
//   { value: "similarity", label: "Similarity Search" },
//   { value: "fusion",     label: "Hybrid Fusion" },
// ];

// const LLM_MODEL_OPTIONS = [
//   { value: "gemini_2_5_flash_lite", label: "Gemini 2.5 Flash Lite (Lightweight & Fast)" },
//   { value: "gemini_2_5_flash", label: "Gemini 2.5 Flash (Full & Accurate)" },
// ];

// // Reusable Tailwind class bundles (kept as constants to avoid huge inline strings)
// const CLS = {
//   // Buttons
//   btn: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[0.8125rem] font-semibold border-none cursor-pointer transition-all duration-150 whitespace-nowrap disabled:opacity-[0.35] disabled:cursor-not-allowed",
//   btnPrimary: "bg-gradient-to-r from-[#8B55DD] to-[#9177B8] text-white shadow-[0_1px_2px_rgba(0,0,0,0.1)] hover:enabled:bg-gradient-to-r hover:enabled:from-[#7A48CC] hover:enabled:to-[#8068A8] hover:enabled:shadow-[0_2px_8px_rgba(139,85,221,0.25)]",
//   btnSecondary: "bg-[#F5F4F3] text-[#3F3F46] border border-black/10 hover:enabled:bg-[#EDECEB] hover:enabled:text-[#171717]",
//   btnGhost: "bg-transparent text-[#71717A] border border-black/10 hover:enabled:bg-[#F5F4F3] hover:enabled:text-[#3F3F46] hover:enabled:border-black/[0.15]",
//   btnSm: "!text-[0.6875rem] !px-2 !py-0.5",

//   // Inputs
//   input: "w-full bg-white border border-black/10 rounded-lg px-3 py-2 text-[0.8125rem] text-[#171717] outline-none transition-all duration-200 hover:border-black/20 focus:border-[rgba(187,66,174,0.36)] focus:shadow-[0_0_0_3px_rgba(139,85,221,0.08)]",
//   inputError: "border-[#D31C1C] shadow-[0_0_0_3px_rgba(211,28,28,0.06)]",

//   // Labels
//   label: "text-[0.625rem] font-bold text-[#52525B] uppercase tracking-[0.06em] flex items-center",
//   labelHint: "font-normal text-[#9CA3AF] normal-case tracking-normal text-[0.625rem] ml-1.5",

//   // Form
//   formGroup: "flex flex-col gap-1.5",
//   errorText: "text-[0.6875rem] text-[#D31C1C] flex items-center gap-1",

//   // Field type badge
//   fieldTypeBadge: "text-[0.5625rem] font-bold px-2 py-[0.1875rem] rounded-2xl uppercase tracking-[0.04em] inline-flex items-center gap-1 flex-shrink-0",

//   // Panel
//   panelTopbar: "h-[44px] flex items-center px-3 gap-2 border-b border-[#e5e7eb] flex-shrink-0",
//   panelTitle: "text-[0.6875rem] font-bold text-[#71717A] uppercase tracking-[0.06em] flex items-center gap-2",

//   // Field count badge
//   fieldCountBadge: "bg-[#8B55DD]/10 text-[#8B55DD] text-[0.6875rem] font-bold px-2 py-0.5 rounded-full ml-1.5",
// };

// // ─── Suggested Fields per Document Type ──────────────────────────────────────

// const SUGGESTED_FIELDS = {
//   invoice: [
//     { field_key: "vendor_name",    data_type: "text",   instruction: "Extract the company or vendor name issuing the invoice", output_rules: "" },
//     { field_key: "customer_name",  data_type: "text",   instruction: "Extract the bill-to company or customer name", output_rules: "" },
//     { field_key: "invoice_number", data_type: "text",   instruction: "Extract the invoice or bill number", output_rules: "" },
//     { field_key: "invoice_date",   data_type: "date",   instruction: "Extract the invoice date", output_rules: "Format as YYYY-MM-DD" },
//     { field_key: "due_date",       data_type: "date",   instruction: "Extract the payment due date", output_rules: "Format as YYYY-MM-DD" },
//     { field_key: "total_amount",   data_type: "number", instruction: "Extract the total amount due including all taxes", output_rules: "Return as float, no currency symbols" },
//     { field_key: "tax_amount",     data_type: "number", instruction: "Extract the tax or VAT amount", output_rules: "Return as float, no currency symbols" },
//     { field_key: "currency",       data_type: "text",   instruction: "Extract the currency code (e.g. USD, EUR, INR)", output_rules: "" },
//     { field_key: "line_items",     data_type: "table",  instruction: "Extract all line items as a table with quantity, price and description", output_rules: "Columns: description, quantity, unit_price, total" },
//     { field_key: "vendor_address", data_type: "text",   instruction: "Extract the vendor full address", output_rules: "" },
//   ],
//   purchase_order: [
//     { field_key: "po_number",      data_type: "text",   instruction: "Extract the purchase order number", output_rules: "" },
//     { field_key: "vendor_name",    data_type: "text",   instruction: "Extract the vendor or supplier name", output_rules: "" },
//     { field_key: "order_date",     data_type: "date",   instruction: "Extract the purchase order date", output_rules: "Format as YYYY-MM-DD" },
//     { field_key: "delivery_date",  data_type: "date",   instruction: "Extract the expected delivery date", output_rules: "Format as YYYY-MM-DD" },
//     { field_key: "total_value",    data_type: "number", instruction: "Extract the total order value", output_rules: "Return as float" },
//     { field_key: "buyer_name",     data_type: "text",   instruction: "Extract the buyer or purchasing company name", output_rules: "" },
//     { field_key: "line_items",     data_type: "table",  instruction: "Extract all order line items", output_rules: "Columns: item_code, description, quantity, unit_price, total" },
//   ],
//   contract: [
//     { field_key: "contract_title", data_type: "text",   instruction: "Extract the title or name of the contract", output_rules: "" },
//     { field_key: "effective_date", data_type: "date",   instruction: "Extract the contract start or effective date", output_rules: "Format as YYYY-MM-DD" },
//     { field_key: "expiry_date",    data_type: "date",   instruction: "Extract the contract end or expiry date", output_rules: "Format as YYYY-MM-DD" },
//     { field_key: "party_1",        data_type: "text",   instruction: "Extract the first party (service provider) name", output_rules: "" },
//     { field_key: "party_2",        data_type: "text",   instruction: "Extract the second party (client) name", output_rules: "" },
//     { field_key: "contract_value", data_type: "number", instruction: "Extract the total contract value", output_rules: "Return as float" },
//     { field_key: "governing_law",  data_type: "text",   instruction: "Extract the governing law or jurisdiction", output_rules: "" },
//   ],
//   receipt: [
//     { field_key: "merchant_name",  data_type: "text",   instruction: "Extract the store or merchant name", output_rules: "" },
//     { field_key: "receipt_date",   data_type: "date",   instruction: "Extract the transaction date", output_rules: "Format as YYYY-MM-DD" },
//     { field_key: "total_amount",   data_type: "number", instruction: "Extract the total amount paid", output_rules: "Return as float" },
//     { field_key: "payment_method", data_type: "text",   instruction: "Extract the payment method (cash, card, UPI, etc.)", output_rules: "" },
//     { field_key: "items",          data_type: "table",  instruction: "Extract all purchased items", output_rules: "Columns: name, quantity, price" },
//   ],
//   custom: [],
// };

// // ─── Schema Builder (recursive tree editor for object/table schemas) ─────────

// const SCHEMA_TYPES = ["text", "number", "date", "table", "object"];

// const SchemaPropertyRow = ({ prop, path, onChange, onDelete, depth = 0 }) => {
//   const [open, setOpen] = useState(depth < 2);
//   const hasChildren = prop.type === "object" || prop.type === "table";
//   const meta = DATA_TYPE_META[prop.type] || DATA_TYPE_META.text;
//   const Icon = meta.icon;

//   const update = (key, value) => {
//     const updated = { ...prop, [key]: value };
//     if (key === "type") {
//       if (value !== "object" && value !== "table") {
//         delete updated.properties;
//         delete updated.items;
//         delete updated.merge_key;
//       }
//       if (value === "object" && !updated.properties) {
//         updated.properties = [];
//       }
//       if (value === "table" && !updated.items) {
//         updated.items = { type: "object", properties: [] };
//       }
//       if (value !== "table") {
//         delete updated.merge_key;
//       }
//     }
//     onChange(updated);
//   };

//   const addChild = () => {
//     if (prop.type === "object") {
//       const props = [...(prop.properties || [])];
//       props.push({ key: `field_${props.length + 1}`, type: "text" });
//       onChange({ ...prop, properties: props });
//     } else if (prop.type === "table") {
//       const items = prop.items || { type: "object", properties: [] };
//       const props = [...(items.properties || [])];
//       props.push({ key: `field_${props.length + 1}`, type: "text" });
//       onChange({ ...prop, items: { ...items, properties: props } });
//     }
//     setOpen(true);
//   };

//   const updateChild = (idx, updated) => {
//     if (prop.type === "object") {
//       const props = [...(prop.properties || [])];
//       props[idx] = updated;
//       onChange({ ...prop, properties: props });
//     } else if (prop.type === "table") {
//       const items = { ...(prop.items || { type: "object", properties: [] }) };
//       const props = [...(items.properties || [])];
//       props[idx] = updated;
//       onChange({ ...prop, items: { ...items, properties: props } });
//     }
//   };

//   const deleteChild = (idx) => {
//     if (prop.type === "object") {
//       const props = (prop.properties || []).filter((_, i) => i !== idx);
//       onChange({ ...prop, properties: props });
//     } else if (prop.type === "table") {
//       const items = { ...(prop.items || { type: "object", properties: [] }) };
//       const props = (items.properties || []).filter((_, i) => i !== idx);
//       onChange({ ...prop, items: { ...items, properties: props } });
//     }
//   };

//   const children = prop.type === "object"
//     ? (prop.properties || [])
//     : prop.type === "table"
//       ? (prop.items?.properties || [])
//       : [];

//   return (
//     <div className="border border-[#e5e7eb] rounded-md bg-white mb-1.5 overflow-hidden">
//       <div className="group flex items-center gap-1.5 px-2 py-1.5 min-h-[2rem]">
//         {hasChildren ? (
//           <button
//             className="flex items-center justify-center w-5 h-5 border-none bg-transparent cursor-pointer text-[#9ca3af] rounded flex-shrink-0 p-0 hover:bg-[#f3f4f6] hover:text-[#3F3F46]"
//             onClick={() => setOpen((o) => !o)}
//           >
//             {open ? <ChevronDown size={11} /> : <ChevronRight size={11} />}
//           </button>
//         ) : (
//           <span className="w-5 flex-shrink-0" />
//         )}
//         <input
//           className="flex-1 min-w-[60px] max-w-[140px] px-1.5 py-1 text-xs font-mono border border-transparent rounded bg-transparent text-[#3F3F46] outline-none hover:border-[#e5e7eb] focus:border-[rgba(187,66,174,0.36)] focus:bg-white placeholder:text-[#D1D5DB]"
//           value={prop.key || ""}
//           onChange={(e) => update("key", e.target.value)}
//           placeholder="key_name"
//         />
//         <select
//           className="px-1.5 py-[0.2rem] text-[0.6875rem] border border-[#e5e7eb] rounded bg-[#FAFAFA] text-[#52525b] cursor-pointer outline-none flex-shrink-0 focus:border-[rgba(187,66,174,0.36)]"
//           value={prop.type}
//           onChange={(e) => update("type", e.target.value)}
//         >
//           {SCHEMA_TYPES.map((t) => (
//             <option key={t} value={t}>{t}</option>
//           ))}
//         </select>
//         <span className={`${CLS.fieldTypeBadge} ${meta.badge} !text-[0.5rem]`}>
//           <Icon size={8} />
//         </span>
//         {prop.type === "table" && (
//           <input
//             className="max-w-[90px] px-1.5 py-[0.2rem] text-[0.625rem] font-mono border border-dashed border-[#d1d5db] rounded bg-[#8B55DD]/[0.04] text-[#7C3AED] outline-none flex-shrink-0 focus:border-[#7C3AED] placeholder:text-[#C4B5FD] placeholder:italic"
//             value={prop.merge_key || ""}
//             onChange={(e) => update("merge_key", e.target.value)}
//             placeholder="merge_key"
//             title="Merge key for batch deduplication (optional)"
//           />
//         )}
//         <button
//           className="flex items-center justify-center w-5 h-5 border-none bg-transparent cursor-pointer text-[#d1d5db] rounded flex-shrink-0 p-0 opacity-0 transition-opacity duration-150 group-hover:opacity-100 hover:!text-[#DC2626] hover:bg-[#DC2626]/[0.06]"
//           onClick={onDelete}
//           title="Remove property"
//         >
//           <X size={11} />
//         </button>
//       </div>

//       {/* Description (inline, compact) */}
//       <div className="px-2 pb-1.5 pl-[2.125rem]">
//         <input
//           className="w-full px-1.5 py-[0.2rem] text-[0.6875rem] border border-transparent rounded bg-transparent text-[#71717A] outline-none italic hover:border-[#e5e7eb] focus:border-[rgba(187,66,174,0.36)] focus:bg-white focus:not-italic placeholder:text-[#D1D5DB]"
//           value={prop.description || ""}
//           onChange={(e) => update("description", e.target.value)}
//           placeholder="description (optional hint for AI)"
//         />
//       </div>

//       {/* Children */}
//       {hasChildren && open && (
//         <div className="px-1.5 py-1.5 pl-5 border-t border-[#f3f4f6] bg-black/[0.01]">
//           {children.map((child, idx) => (
//             <SchemaPropertyRow
//               key={idx}
//               prop={child}
//               path={`${path}.${child.key || idx}`}
//               depth={depth + 1}
//               onChange={(updated) => updateChild(idx, updated)}
//               onDelete={() => deleteChild(idx)}
//             />
//           ))}
//           <button
//             className="flex items-center gap-1 px-2 py-1 text-[0.6875rem] font-medium text-[#8B55DD] border border-dashed border-[#8B55DD]/25 rounded bg-transparent cursor-pointer transition-all duration-150 w-full justify-center hover:bg-[#8B55DD]/[0.06] hover:border-[#8B55DD]/40"
//             onClick={addChild}
//           >
//             <Plus size={10} /> Add Property
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// const SchemaBuilder = ({ schema, onChange }) => {
//   const normalized = Array.isArray(schema)
//     ? { type: "object", properties: schema }
//     : schema || { type: "object", properties: [] };

//   const properties = normalized.properties || [];

//   const updateProperty = (idx, updated) => {
//     const props = [...properties];
//     props[idx] = updated;
//     onChange({ ...normalized, properties: props });
//   };

//   const deleteProperty = (idx) => {
//     const props = properties.filter((_, i) => i !== idx);
//     onChange({ ...normalized, properties: props });
//   };

//   const addProperty = () => {
//     const props = [...properties];
//     props.push({ key: `field_${props.length + 1}`, type: "text" });
//     onChange({ ...normalized, properties: props });
//   };

//   return (
//     <div className="border border-[#e5e7eb] rounded-lg bg-[#FAFAFA] overflow-hidden">
//       <div className="flex items-center gap-1.5 px-3 py-2 text-[0.6875rem] font-bold text-[#71717A] uppercase tracking-[0.04em] border-b border-[#e5e7eb] bg-[#F5F5F5] [&>svg]:text-[#EA580C]">
//         <Braces size={12} />
//         <span>Schema Definition</span>
//         <span className="ml-auto font-medium text-[0.625rem] text-[#9ca3af] normal-case tracking-normal">{properties.length} properties</span>
//       </div>
//       <div className="p-2">
//         {properties.length === 0 ? (
//           <div className="p-4 text-center text-xs text-[#9ca3af]">
//             No properties defined yet. Add properties to define the output shape.
//           </div>
//         ) : (
//           properties.map((prop, idx) => (
//             <SchemaPropertyRow
//               key={idx}
//               prop={prop}
//               path={prop.key || String(idx)}
//               depth={0}
//               onChange={(updated) => updateProperty(idx, updated)}
//               onDelete={() => deleteProperty(idx)}
//             />
//           ))
//         )}
//         <button
//           className="flex items-center gap-1 px-2 py-1 text-[0.6875rem] font-medium text-[#8B55DD] border border-dashed border-[#8B55DD]/25 rounded bg-transparent cursor-pointer transition-all duration-150 w-full justify-center hover:bg-[#8B55DD]/[0.06] hover:border-[#8B55DD]/40 mt-1"
//           onClick={addProperty}
//         >
//           <Plus size={11} /> Add Property
//         </button>
//       </div>
//     </div>
//   );
// };

// // ─── Field Row (inside Template Builder) ─────────────────────────────────────

// const FieldRow = ({ field, index, onChange, onDelete }) => {
//   const [open, setOpen] = useState(false);
//   const [showAdvanced, setShowAdvanced] = useState(false);
//   const meta = DATA_TYPE_META[field.data_type] || DATA_TYPE_META.text;
//   const Icon = meta.icon;

//   return (
//     <div className={`bg-white transition-colors duration-150 ${open ? "!bg-[#FAFAFF]" : ""}`}>
//       <div
//         className="group px-3.5 py-2 pr-4 flex items-center gap-2 cursor-pointer transition-colors duration-150 hover:bg-[#8B55DD]/[0.03]"
//         onClick={() => setOpen((o) => !o)}
//       >
//         <span className="text-[0.5625rem] font-bold text-[#9CA3AF] w-5 h-5 rounded bg-black/[0.04] flex items-center justify-center flex-shrink-0">
//           {index + 1}
//         </span>
//         <div className="text-[#9CA3AF] flex items-center transition-colors duration-150 group-hover:text-[#71717A]">
//           {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
//         </div>
//         <input
//           className="font-mono text-[0.8125rem] font-semibold text-[#8B55DD] flex-1 bg-transparent border-none outline-none min-w-0 focus:text-[#7A48CC] placeholder:text-[#D1D5DB]"
//           value={field.field_key}
//           onChange={(e) => onChange({ ...field, field_key: e.target.value })}
//           placeholder="Field name"
//           title="Field Name"
//           onClick={(e) => e.stopPropagation()}
//         />
//         <span className={`${CLS.fieldTypeBadge} ${meta.badge}`}>
//           <Icon size={10} />
//           {meta.label}
//         </span>
//         <button
//           className="w-6 h-6 rounded border-none bg-transparent text-[#D1D5DB] flex items-center justify-center cursor-pointer transition-all duration-150 flex-shrink-0 opacity-0 group-hover:opacity-100 hover:!text-[#D31C1C] hover:bg-[#D31C1C]/[0.06]"
//           onClick={(e) => { e.stopPropagation(); onDelete(); }}
//           title="Remove field"
//         >
//           <Trash2 size={13} />
//         </button>
//       </div>

//       {open && (
//         <div className="p-0 flex flex-col border-t border-black/[0.04]">
//           <div className="px-4 py-3 pl-[2.625rem] flex flex-col gap-2.5 border-b border-black/[0.03]">
//             <div className="text-[0.5625rem] font-bold text-[#9CA3AF] uppercase tracking-[0.08em] flex items-center gap-1.5 mb-0.5">
//               <Settings size={11} />
//               Configuration
//             </div>
//             <div className="grid grid-cols-2 gap-3.5">
//               <div className={CLS.formGroup}>
//                 <label className={CLS.label}>Field Name</label>
//                 <input
//                   className={CLS.input}
//                   value={field.field_key}
//                   onChange={(e) => onChange({ ...field, field_key: e.target.value })}
//                   placeholder="e.g. vendor_name"
//                 />
//               </div>
//               <div className={CLS.formGroup}>
//                 <label className={CLS.label}>Data Type</label>
//                 <select
//                   className="w-full bg-white border border-black/10 rounded-lg px-2.5 py-[0.4375rem] text-xs text-[#171717] outline-none transition-all duration-200 hover:border-black/20 focus:border-[rgba(187,66,174,0.36)] focus:shadow-[0_0_0_3px_rgba(139,85,221,0.08)]"
//                   value={field.data_type}
//                   onChange={(e) => {
//                     const newType = e.target.value;
//                     const updated = { ...field, data_type: newType };
//                     if (newType === "object" && !updated.schema_definition) {
//                       updated.schema_definition = { type: "object", properties: [] };
//                     } else if (newType !== "object" && newType !== "table") {
//                       updated.schema_definition = null;
//                     }
//                     onChange(updated);
//                   }}
//                 >
//                   <option value="text">Text</option>
//                   <option value="number">Number</option>
//                   <option value="date">Date</option>
//                   <option value="table">Table</option>
//                   <option value="object">Object</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           <div className="px-4 py-3 pl-[2.625rem] flex flex-col gap-2.5 border-b border-black/[0.03]">
//             <div className="text-[0.5625rem] font-bold text-[#9CA3AF] uppercase tracking-[0.08em] flex items-center gap-1.5 mb-0.5">
//               <Sparkles size={11} />
//               AI Instructions
//             </div>
//             <div className={CLS.formGroup}>
//               <label className={CLS.label}>
//                 Extraction Instruction
//                 <span className={CLS.labelHint}>Tell the AI what to look for</span>
//               </label>
//               <textarea
//                 className="w-full bg-white border border-black/10 rounded-lg px-3 py-2 text-[0.8125rem] text-[#3F3F46] resize-y outline-none min-h-[6rem] leading-[1.6] transition-all duration-200 hover:border-black/20 focus:border-[rgba(187,66,174,0.36)] focus:shadow-[0_0_0_3px_rgba(139,85,221,0.06)]"
//                 value={field.instruction || ""}
//                 onChange={(e) => onChange({ ...field, instruction: e.target.value })}
//                 placeholder='e.g. "Extract the total amount from the bottom-right of the invoice"'
//               />
//             </div>
//             <div className={CLS.formGroup}>
//               <label className={CLS.label}>
//                 Output Rules
//                 <span className={CLS.labelHint}>Formatting constraints</span>
//               </label>
//               <textarea
//                 className="w-full bg-white border border-black/10 rounded-lg px-3 py-2 text-[0.8125rem] text-[#3F3F46] resize-y outline-none min-h-[4.5rem] leading-[1.6] transition-all duration-200 hover:border-black/20 focus:border-[rgba(187,66,174,0.36)] focus:shadow-[0_0_0_3px_rgba(139,85,221,0.06)]"
//                 value={field.output_rules || ""}
//                 onChange={(e) => onChange({ ...field, output_rules: e.target.value })}
//                 placeholder='e.g. "Format as float, no currency symbols"'
//               />
//             </div>
//           </div>

//           {/* Schema Builder — shown for object (required) and table (optional) */}
//           {(field.data_type === "object" || field.data_type === "table") && (
//             <div className="px-4 py-3 pl-[2.625rem] flex flex-col gap-2.5 border-b border-black/[0.03]">
//               <div className="text-[0.5625rem] font-bold text-[#9CA3AF] uppercase tracking-[0.08em] flex items-center gap-1.5 mb-0.5">
//                 <Braces size={11} />
//                 Schema Definition
//                 {field.data_type === "object" && <span className={CLS.labelHint} style={{ color: "#DC2626" }}>required</span>}
//                 {field.data_type === "table" && <span className={CLS.labelHint}>optional — improves batch merge</span>}
//               </div>
//               <div className="px-0 pb-3.5 pt-0">
//                 <SchemaBuilder
//                   schema={field.schema_definition}
//                   onChange={(schema) => onChange({ ...field, schema_definition: schema })}
//                 />
//               </div>
//             </div>
//           )}

//           {/* Advanced: ERP mapping — hidden by default */}
//           <div className="px-4 py-3 pl-[2.625rem] flex flex-col gap-2.5 border-t border-[#f3f4f6] pt-2">
//             <button
//               type="button"
//               className="text-[0.6875rem] py-1 px-3.5 text-[#9ca3af] bg-transparent border-none cursor-pointer font-[inherit] flex items-center gap-1 underline decoration-dotted hover:text-[#52525b]"
//               onClick={() => setShowAdvanced((v) => !v)}
//             >
//               {showAdvanced ? <ChevronDown size={11} /> : <ChevronRight size={11} />}
//               Advanced options
//             </button>
//             {showAdvanced && (
//               <div className="flex flex-col gap-1.5 px-3.5 pt-2 pb-3.5">
//                 <label className={CLS.label}>System Mapping <span className={CLS.labelHint}>optional ERP field code</span></label>
//                 <input
//                   className={CLS.input}
//                   value={field.system_mapping || ""}
//                   onChange={(e) => onChange({ ...field, system_mapping: e.target.value })}
//                   placeholder="ERP_FIELD_CODE"
//                 />
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // ─── Result Renderer ──────────────────────────────────────────────────────────

// const NestedObjectRenderer = ({ data, label, depth = 0 }) => {
//   if (data === null || data === undefined || data === "") {
//     return <span className="text-[#D1D5DB] italic text-[0.8125rem]">—</span>;
//   }
//   if (typeof data !== "object") {
//     return <span>{String(data)}</span>;
//   }
//   if (Array.isArray(data)) {
//     if (data.length === 0) return <span className="text-[#D1D5DB] italic text-[0.8125rem]">empty array</span>;
//     if (typeof data[0] === "object" && data[0] !== null) {
//       const allKeys = [...new Set(data.flatMap((row) => Object.keys(row)))];
//       const hasNestedValues = data.some((row) =>
//         Object.values(row).some((v) => typeof v === "object" && v !== null)
//       );
//       if (!hasNestedValues) {
//         return (
//           <div
//             className="border border-black/[0.08] rounded-lg overflow-hidden"
//             style={{ marginLeft: depth > 0 ? "0.5rem" : 0 }}
//           >
//             <div className="px-3.5 py-2 bg-[#FAFAFA] text-[0.625rem] font-bold text-[#71717A] uppercase tracking-[0.06em] border-b border-black/[0.06] flex items-center gap-2">
//               <Table2 size={12} />
//               {label && <>{label.replace(/_/g, " ")} · </>}
//               <span className="ml-auto text-[0.5625rem] bg-[#8B55DD]/[0.08] text-[#8B55DD] px-2 py-0.5 rounded-full font-bold normal-case tracking-normal">{data.length} rows</span>
//             </div>
//             <div className="overflow-x-auto max-h-[320px] overflow-y-auto">
//               <table className="w-full border-collapse text-xs text-[#3F3F46]">
//                 <thead>
//                   <tr>
//                     {allKeys.map((col) => (
//                       <th key={col} className="px-3 py-[0.4375rem] bg-[#F5F4F3] text-[#71717A] text-[0.625rem] font-bold uppercase tracking-[0.05em] text-left border-b border-black/[0.08] sticky top-0 z-[1] whitespace-nowrap">{col}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.map((row, i) => (
//                     <tr key={i} className="odd:[&>td]:bg-black/[0.01] hover:[&>td]:bg-[#8B55DD]/[0.03]">
//                       {allKeys.map((col) => {
//                         const cell = row[col];
//                         return (
//                           <td key={col} className="px-3 py-[0.4375rem] text-[#3F3F46] border-b border-black/[0.04] whitespace-nowrap align-middle">
//                             {cell === null || cell === undefined ? "—" : String(cell)}
//                           </td>
//                         );
//                       })}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         );
//       }
//       return (
//         <div style={{ marginLeft: depth > 0 ? "0.5rem" : 0 }}>
//           {label && (
//             <div className="flex items-center gap-1.5 px-2 pt-2 pb-1 text-xs font-semibold text-[#52525b] capitalize [&>svg]:text-[#9ca3af]">
//               <Table2 size={12} />
//               {label.replace(/_/g, " ")}
//               <span className="ml-auto text-[0.5625rem] bg-[#8B55DD]/[0.08] text-[#8B55DD] px-2 py-0.5 rounded-full font-bold normal-case tracking-normal">{data.length} items</span>
//             </div>
//           )}
//           {data.map((item, i) => (
//             <div key={i} className="border border-[#e5e7eb] rounded-md my-1.5 p-2 bg-[#FAFAFA] relative">
//               <div className="absolute top-1.5 right-2 text-[0.625rem] font-bold text-[#D1D5DB] font-mono">#{i + 1}</div>
//               <NestedObjectRenderer data={item} depth={depth + 1} />
//             </div>
//           ))}
//         </div>
//       );
//     }
//     return <span>{data.join(", ")}</span>;
//   }
//   const entries = Object.entries(data);
//   const scalarEntries = entries.filter(([, v]) => typeof v !== "object" || v === null);
//   const nestedEntries = entries.filter(([, v]) => typeof v === "object" && v !== null);

//   return (
//     <div style={{ marginLeft: depth > 0 ? "0.5rem" : 0 }}>
//       {label && depth > 0 && (
//         <div className="flex items-center gap-1.5 px-2 pt-2 pb-1 text-xs font-semibold text-[#52525b] capitalize [&>svg]:text-[#9ca3af]">
//           <Braces size={12} />
//           {label.replace(/_/g, " ")}
//         </div>
//       )}
//       {scalarEntries.length > 0 && (
//         <div className="grid grid-cols-2 gap-2">
//           {scalarEntries.map(([key, value]) => (
//             <div key={key} className="bg-[#FAFAFA] border border-black/[0.08] rounded-lg overflow-hidden">
//               <div className="px-3 py-1.5 bg-black/[0.02] text-[0.5625rem] font-bold text-[#71717A] uppercase tracking-[0.06em] border-b border-black/[0.06] flex items-center gap-1.5">
//                 <Type size={10} />
//                 {key.replace(/_/g, " ")}
//               </div>
//               <div className="px-3 py-2 text-[0.8125rem] text-[#171717] font-medium break-words">
//                 {value !== null && value !== undefined && value !== "" ? String(value) : <span className="text-[#D1D5DB] italic text-[0.8125rem]">—</span>}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//       {nestedEntries.map(([key, value]) => (
//         <NestedObjectRenderer key={key} data={value} label={key} depth={depth + 1} />
//       ))}
//     </div>
//   );
// };

// const ResultRenderer = ({ data, templateName }) => {
//   const [viewMode, setViewMode] = useState("structured");

//   const extractedData = data?.extracted_data ?? data;

//   if (!extractedData || Object.keys(extractedData).length === 0) {
//     return (
//       <div className="flex flex-col items-center text-center px-6 py-10">
//         <div className="w-14 h-14 rounded-xl bg-[#8B55DD]/[0.05] border border-[#8B55DD]/[0.08] flex items-center justify-center text-[#9CA3AF] mb-3">
//           <AlertCircle size={32} />
//         </div>
//         <p className="text-[0.8125rem] font-semibold text-[#52525B] m-0 mb-1">No Data Extracted</p>
//         <p className="text-xs text-[#9CA3AF] max-w-[300px] leading-[1.5] m-0">
//           Gemini returned empty results. Try updating the field instructions to be more specific.
//         </p>
//       </div>
//     );
//   }

//   const hasDeepNesting = Object.values(extractedData).some((v) => {
//     if (typeof v === "object" && v !== null && !Array.isArray(v)) return true;
//     if (Array.isArray(v) && v.length > 0 && typeof v[0] === "object" && v[0] !== null) {
//       return Object.values(v[0]).some((inner) => typeof inner === "object" && inner !== null);
//     }
//     return false;
//   });

//   return (
//     <div className="px-5 py-4 flex flex-col gap-3.5">
//       <div className="flex items-center gap-1 bg-[#F5F4F3] border border-black/[0.08] rounded-lg p-[0.1875rem]">
//         <button
//           className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[0.6875rem] font-semibold border-none cursor-pointer transition-all duration-150 ${viewMode === "structured" ? "bg-[#8B55DD] text-white" : "bg-transparent text-[#9CA3AF] hover:bg-black/[0.04] hover:text-[#52525B]"}`}
//           onClick={() => setViewMode("structured")}
//         >
//           <Layers size={12} /> Formatted
//         </button>
//         <button
//           className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[0.6875rem] font-semibold border-none cursor-pointer transition-all duration-150 ${viewMode === "json" ? "bg-[#8B55DD] text-white" : "bg-transparent text-[#9CA3AF] hover:bg-black/[0.04] hover:text-[#52525B]"}`}
//           onClick={() => setViewMode("json")}
//         >
//           <Code2 size={12} /> JSON
//         </button>
//         <div className="ml-auto flex gap-1.5 items-center">
//           <button
//             className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[0.6875rem] font-semibold border-none cursor-pointer bg-transparent text-[#9CA3AF] transition-all duration-150 hover:bg-black/[0.04] hover:text-[#52525B]"
//             title="Copy JSON"
//             onClick={() => navigator.clipboard.writeText(JSON.stringify(extractedData, null, 2))}
//           >
//             <Copy size={12} /> Copy
//           </button>
//           <DownloadCSVButton data={data} templateName={templateName} />
//         </div>
//       </div>

//       {viewMode === "json" && (
//         <div className="border border-black/[0.08] rounded-lg overflow-hidden">
//           <pre className="p-5 font-mono text-[0.6875rem] text-[#3F3F46] whitespace-pre-wrap break-words leading-[1.7] bg-[#FAFAFA] m-0 max-h-[500px] overflow-y-auto">
//             {JSON.stringify(extractedData, null, 2)}
//           </pre>
//         </div>
//       )}

//       {viewMode === "structured" && (
//         hasDeepNesting ? (
//           <div className="p-2">
//             <NestedObjectRenderer data={extractedData} depth={0} />
//           </div>
//         ) : (
//           <>
//             {(() => {
//               const entries = Object.entries(extractedData);
//               const isSimpleTable = (arr) => {
//                 if (!Array.isArray(arr) || arr.length === 0) return false;
//                 const firstItem = arr[0];
//                 if (typeof firstItem !== "object" || firstItem === null) return false;
//                 return Object.values(firstItem).every(v => {
//                   if (v === null || v === undefined) return true;
//                   return typeof v !== "object" || (typeof v === "string" || typeof v === "number" || typeof v === "boolean");
//                 });
//               };
//               const tableFields  = entries.filter(([, v]) => Array.isArray(v) && isSimpleTable(v));
//               const scalarFields = entries.filter(([, v]) => !(Array.isArray(v) && isSimpleTable(v)));
//               return (
//                 <>
//                   {scalarFields.length > 0 && scalarFields.some(([, v]) => typeof v !== "object" || v === null) && (
//                     <div className="grid grid-cols-2 gap-2">
//                       {scalarFields.filter(([, v]) => typeof v !== "object" || v === null).map(([key, value]) => (
//                         <div key={key} className="bg-[#FAFAFA] border border-black/[0.08] rounded-lg overflow-hidden">
//                           <div className="px-3 py-1.5 bg-black/[0.02] text-[0.5625rem] font-bold text-[#71717A] uppercase tracking-[0.06em] border-b border-black/[0.06] flex items-center gap-1.5">
//                             <Type size={10} />
//                             {key.replace(/_/g, " ")}
//                           </div>
//                           <div className="px-3 py-2 text-[0.8125rem] text-[#171717] font-medium break-words">
//                             {value !== null && value !== undefined && value !== "" ? (
//                               String(value)
//                             ) : (
//                               <span className="text-[#D1D5DB] italic text-[0.8125rem]">—</span>
//                             )}
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}

//                   {tableFields.map(([key, rows]) => (
//                     <div key={key} className="border border-black/[0.08] rounded-lg overflow-hidden">
//                       <div className="px-3.5 py-2 bg-[#FAFAFA] text-[0.625rem] font-bold text-[#71717A] uppercase tracking-[0.06em] border-b border-black/[0.06] flex items-center gap-2">
//                         <Table2 size={12} />
//                         {key.replace(/_/g, " ")}
//                         <span className="ml-auto text-[0.5625rem] bg-[#8B55DD]/[0.08] text-[#8B55DD] px-2 py-0.5 rounded-full font-bold normal-case tracking-normal">{rows.length} rows</span>
//                       </div>
//                       <div className="overflow-x-auto max-h-[320px] overflow-y-auto">
//                         <table className="w-full border-collapse text-xs text-[#3F3F46]">
//                           <thead>
//                             <tr>
//                               {Object.keys(rows[0]).map((col) => (
//                                 <th key={col} className="px-3 py-[0.4375rem] bg-[#F5F4F3] text-[#71717A] text-[0.625rem] font-bold uppercase tracking-[0.05em] text-left border-b border-black/[0.08] sticky top-0 z-[1] whitespace-nowrap">{col}</th>
//                               ))}
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {rows.map((row, i) => (
//                               <tr key={i} className="odd:[&>td]:bg-black/[0.01] hover:[&>td]:bg-[#8B55DD]/[0.03]">
//                                 {Object.values(row).map((cell, j) => {
//                                   let displayValue = cell;
//                                   if (typeof cell === "object" && cell !== null) {
//                                     if (Array.isArray(cell)) displayValue = `[Array: ${cell.length} items]`;
//                                     else displayValue = `[Object]`;
//                                   } else if (cell === null || cell === undefined) {
//                                     displayValue = "—";
//                                   }
//                                   return <td key={j} className="px-3 py-[0.4375rem] text-[#3F3F46] border-b border-black/[0.04] whitespace-nowrap align-middle">{displayValue}</td>;
//                                 })}
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     </div>
//                   ))}

//                   {scalarFields.filter(([, v]) => typeof v === "object" && v !== null && !Array.isArray(v)).length > 0 && (
//                     <div className="grid grid-cols-2 gap-2">
//                       {scalarFields.filter(([, v]) => typeof v === "object" && v !== null && !Array.isArray(v)).map(([key, value]) => (
//                         <div key={key} className="bg-[#FAFAFA] border border-black/[0.08] rounded-lg overflow-hidden">
//                           <div className="px-3 py-1.5 bg-black/[0.02] text-[0.5625rem] font-bold text-[#71717A] uppercase tracking-[0.06em] border-b border-black/[0.06] flex items-center gap-1.5">
//                             <Code2 size={10} />
//                             {key.replace(/_/g, " ")}
//                           </div>
//                           <div className="px-3 py-2 text-[0.6875rem] font-mono text-[#171717] font-medium break-words">
//                             {JSON.stringify(value, null, 1)}
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </>
//               );
//             })()}
//           </>
//         )
//       )}
//     </div>
//   );
// };

// // ─── New Template Wizard (3-step slide-over) ──────────────────────────────────

// const WIZARD_STEPS = [
//   { num: 1, label: "Basics" },
//   { num: 2, label: "Engine" },
//   { num: 3, label: "Fields" },
// ];

// const WizardStepBar = ({ current }) => (
//   <div className="flex items-center px-6 py-3.5 border-b border-[#e5e7eb] bg-[#fafafa] flex-shrink-0">
//     {WIZARD_STEPS.map((s, i) => {
//       const isDone   = s.num < current;
//       const isActive = s.num === current;
//       return (
//         <React.Fragment key={s.num}>
//           <div className={`flex items-center gap-2 text-xs font-medium ${isActive ? "!text-[#8B55DD] !font-bold" : isDone ? "!text-[#10b981]" : "text-[#9ca3af]"}`}>
//             <div className={`w-[22px] h-[22px] rounded-full border-2 flex items-center justify-center text-[0.625rem] font-bold flex-shrink-0 ${isActive ? "border-[#8B55DD] bg-[#8B55DD] text-white" : isDone ? "border-[#10b981] bg-[#10b981] text-white" : "border-[#e5e7eb]"}`}>
//               {isDone ? <Check size={10} /> : s.num}
//             </div>
//             {s.label}
//           </div>
//           {i < WIZARD_STEPS.length - 1 && <div className="flex-1 h-px bg-[#e5e7eb] mx-2 max-w-[2rem]" />}
//         </React.Fragment>
//       );
//     })}
//   </div>
// );

// const NewTemplateSlideOver = ({ isOpen, onClose, onCreated }) => {
//   // Wizard state
//   const [step, setStep] = useState(1);

//   // Step 1 – Basics
//   const [name, setName]               = useState("");
//   const [slug, setSlug]               = useState("");
//   const [slugManual, setSlugManual]   = useState(false);
//   const [documentType, setDocumentType] = useState("invoice");
//   const [nameError, setNameError]     = useState("");
//   const [slugError, setSlugError]     = useState("");
//   const [showAdvanced, setShowAdvanced] = useState(false);
//   const nameRef = useRef(null);

//   // Step 2 – Engine
//   const [engine, setEngine] = useState(null);

//   // Step 3 – Fields
//   const [selectedKeys, setSelectedKeys] = useState(new Set());
//   const [showJsonImport, setShowJsonImport] = useState(false);
//   const [importedFields, setImportedFields] = useState([]);
//   const [importError, setImportError] = useState("");

//   // Saving
//   const [saving, setSaving]   = useState(false);
//   const [apiError, setApiError] = useState("");

//   useEffect(() => {
//     if (isOpen) {
//       setStep(1);
//       setName(""); setSlug(""); setSlugManual(false);
//       setDocumentType("invoice"); setNameError(""); setSlugError("");
//       setShowAdvanced(false); setEngine(null);
//       setImportedFields([]); setImportError(""); setShowJsonImport(false);
//       setApiError(""); setSaving(false);
//       setTimeout(() => nameRef.current?.focus(), 300);
//     }
//   }, [isOpen]);

//   useEffect(() => {
//     const suggestions = SUGGESTED_FIELDS[documentType] || [];
//     setSelectedKeys(new Set(suggestions.map((f) => f.field_key)));
//   }, [documentType]);

//   const handleNameChange = (val) => {
//     setName(val);
//     setNameError("");
//     if (!slugManual) setSlug(generateSlug(val));
//   };

//   const handleSlugChange = (val) => {
//     setSlugManual(true);
//     const s = generateSlug(val);
//     setSlug(s);
//     setSlugError(s.length > 0 && s.length < 3 ? "Min 3 characters" : "");
//   };

//   const goToStep2 = () => {
//     if (!name.trim()) { setNameError("Template name is required"); return; }
//     if (slug && slug.length < 3) { setSlugError("Min 3 characters"); return; }
//     setStep(2);
//   };

//   const toggleKey = (key) => {
//     setSelectedKeys((prev) => {
//       const next = new Set(prev);
//       if (next.has(key)) next.delete(key); else next.add(key);
//       return next;
//     });
//   };

//   const selectAll = () => {
//     const suggestions = SUGGESTED_FIELDS[documentType] || [];
//     setSelectedKeys(new Set(suggestions.map((f) => f.field_key)));
//   };

//   const deselectAll = () => setSelectedKeys(new Set());

//   const handleJsonFile = (file) => {
//     setImportError("");
//     if (!file) return;
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       try {
//         const parsed = JSON.parse(e.target.result);
//         const arr = Array.isArray(parsed) ? parsed : parsed.fields;
//         if (!Array.isArray(arr)) throw new Error("Expected an array of fields");
//         const fields = arr.map((f, i) => ({
//           field_key: f.field_key || f.name || `field_${i + 1}`,
//           data_type: f.data_type || "text",
//           instruction: f.instruction || "",
//           output_rules: f.output_rules || "",
//           field_order: f.field_order || i + 1,
//           system_mapping: f.system_mapping || "",
//           schema_definition: f.schema_definition || null,
//         }));
//         setImportedFields(fields);
//       } catch (err) {
//         setImportError("Failed to parse JSON: " + err.message);
//         setImportedFields([]);
//       }
//     };
//     reader.readAsText(file);
//   };

//   const handleCreate = async () => {
//     const suggestions = SUGGESTED_FIELDS[documentType] || [];
//     const checkedSuggestions = suggestions
//       .filter((f) => selectedKeys.has(f.field_key))
//       .map((f, i) => ({ ...f, field_order: i + 1 }));

//     const importedKeys = new Set(checkedSuggestions.map((f) => f.field_key));
//     const extras = importedFields
//       .filter((f) => !importedKeys.has(f.field_key))
//       .map((f, i) => ({ ...f, field_order: checkedSuggestions.length + i + 1 }));

//     const fields = [...checkedSuggestions, ...extras];

//     setSaving(true);
//     setApiError("");
//     try {
//       const payload = {
//         name: name.trim(),
//         slug: slug || generateSlug(name),
//         document_type: documentType,
//         extraction_engine: engine,
//         retrieval_strategy: "full_text",
//         llm_model_key: "gemini_2_5_flash_lite",
//         fields,
//       };
//       const created = await createTemplate(payload);
//       onCreated(created);
//     } catch (err) {
//       if (err.response?.data?.slug) {
//         setSlugError("This slug is already in use.");
//         setStep(1);
//       } else {
//         setApiError("Failed to create template. Please try again.");
//       }
//     } finally {
//       setSaving(false);
//     }
//   };

//   const suggestions = SUGGESTED_FIELDS[documentType] || [];

//   return (
//     <>
//       {isOpen && <div className="fixed inset-0 bg-black/30 z-50" onClick={onClose} />}
//       <div
//         className={`fixed top-0 right-0 bottom-0 bg-white z-[51] overflow-y-auto shadow-[-4px_0_24px_rgba(0,0,0,0.12)] transition-transform duration-[250ms] ease-out flex flex-col ${isOpen ? "translate-x-0" : "translate-x-full"}`}
//         style={{ width: step === 2 ? "860px" : "440px", maxWidth: "95vw" }}
//       >
//         {/* Header */}
//         <div className="flex justify-between items-center px-6 py-5 border-b border-[#e5e7eb]">
//           <h2 style={{ margin: 0, fontSize: "1.125rem", fontWeight: 700, color: "#171717" }}>New Template</h2>
//           <button
//             className="w-7 h-7 rounded-md border border-black/10 bg-[#F5F4F3] text-[#71717A] flex items-center justify-center cursor-pointer transition-all duration-150 hover:!text-[#D31C1C] hover:border-[#D31C1C]/20 hover:bg-[#D31C1C]/[0.06]"
//             onClick={onClose}
//           >
//             <X size={16} />
//           </button>
//         </div>

//         {/* Step indicator */}
//         <WizardStepBar current={step} />

//         {/* ── STEP 1: BASICS ─────────────────────────────────────────── */}
//         {step === 1 && (
//           <>
//             <div className="p-6 flex flex-col gap-4">
//               <div className={CLS.formGroup}>
//                 <label className={CLS.label}>Template Name</label>
//                 <input
//                   ref={nameRef}
//                   className={`${CLS.input} ${nameError ? CLS.inputError : ""}`}
//                   value={name}
//                   onChange={(e) => handleNameChange(e.target.value)}
//                   onKeyDown={(e) => { if (e.key === "Enter") goToStep2(); }}
//                   placeholder="e.g. TJS Group Invoice"
//                 />
//                 {nameError && <span className={CLS.errorText}>{nameError}</span>}
//               </div>

//               <div className={CLS.formGroup}>
//                 <label className={CLS.label}>Document Type</label>
//                 <select
//                   className={CLS.input}
//                   value={documentType}
//                   onChange={(e) => setDocumentType(e.target.value)}
//                 >
//                   <option value="invoice">Invoice</option>
//                   <option value="purchase_order">Purchase Order</option>
//                   <option value="contract">Contract</option>
//                   <option value="receipt">Receipt</option>
//                   <option value="custom">Custom</option>
//                 </select>
//               </div>

//               <div>
//                 <button
//                   type="button"
//                   className="text-xs py-1 text-[#9ca3af] bg-transparent border-none cursor-pointer font-[inherit] flex items-center gap-1 underline decoration-dotted hover:text-[#52525b]"
//                   onClick={() => setShowAdvanced((v) => !v)}
//                 >
//                   {showAdvanced ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
//                   Advanced options
//                 </button>
//                 {showAdvanced && (
//                   <div className={`${CLS.formGroup} mt-3`}>
//                     <label className={CLS.label}>
//                       Slug <span className={CLS.labelHint}>auto-generated — edit if needed</span>
//                     </label>
//                     <input
//                       className={`${CLS.input} font-mono ${slugError ? CLS.inputError : ""}`}
//                       value={slug}
//                       onChange={(e) => handleSlugChange(e.target.value)}
//                       placeholder="unique-identifier"
//                     />
//                     {slugError && <span className={CLS.errorText}>{slugError}</span>}
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="px-6 py-4 border-t border-[#e5e7eb] flex justify-end gap-3 mt-auto">
//               <button className={`${CLS.btn} ${CLS.btnGhost}`} onClick={onClose}>Cancel</button>
//               <button className={`${CLS.btn} ${CLS.btnPrimary}`} onClick={goToStep2} disabled={!name.trim()}>
//                 Next: Choose Engine →
//               </button>
//             </div>
//           </>
//         )}

//         {/* ── STEP 2: ENGINE ─────────────────────────────────────────── */}
//         {step === 2 && (
//           <>
//             <div className="flex-1 overflow-y-auto">
//               <div className="px-5 pt-3.5 pb-2 text-[0.8125rem] text-[#52525b]">
//                 Click a card to select the engine for <strong>{name}</strong>. Sample documents show what each engine handles best.
//               </div>
//               <EngineCardGrid selected={engine} onChange={setEngine} />
//             </div>

//             <div className="px-6 py-4 border-t border-[#e5e7eb] flex justify-end gap-3">
//               <button className={`${CLS.btn} ${CLS.btnGhost}`} onClick={() => setStep(1)}>← Back</button>
//               <button
//                 className={`${CLS.btn} ${CLS.btnPrimary}`}
//                 onClick={() => setStep(3)}
//                 disabled={!engine}
//               >
//                 {engine ? "Next: Review Fields →" : "Select an engine above"}
//               </button>
//             </div>
//           </>
//         )}

//         {/* ── STEP 3: FIELDS ─────────────────────────────────────────── */}
//         {step === 3 && (
//           <>
//             <div className="p-6 flex flex-col gap-4">
//               {suggestions.length > 0 ? (
//                 <>
//                   <div className="flex items-center justify-between">
//                     <span className="text-[0.8125rem] text-[#52525b]">
//                       Suggested fields for <strong>{documentType.replace("_", " ")}</strong> — uncheck any you don't need.
//                     </span>
//                     <div className="flex gap-2">
//                       <button type="button" className="text-[0.6875rem] text-[#8B55DD] cursor-pointer bg-transparent border-none p-0 font-[inherit] underline hover:text-[#6d38c3]" onClick={selectAll}>All</button>
//                       <span className="text-[#e5e7eb]">·</span>
//                       <button type="button" className="text-[0.6875rem] text-[#8B55DD] cursor-pointer bg-transparent border-none p-0 font-[inherit] underline hover:text-[#6d38c3]" onClick={deselectAll}>None</button>
//                     </div>
//                   </div>

//                   <div className="flex flex-col border border-[#e5e7eb] rounded-lg overflow-hidden">
//                     {suggestions.map((f) => {
//                       const meta = DATA_TYPE_META[f.data_type] || DATA_TYPE_META.text;
//                       const Icon = meta.icon;
//                       return (
//                         <label key={f.field_key} className="flex items-center gap-2.5 px-3 py-2 border-b border-[#f3f4f6] last:border-b-0 cursor-pointer transition-colors hover:bg-[#f9fafb]">
//                           <input
//                             type="checkbox"
//                             className="w-3.5 h-3.5 flex-shrink-0 cursor-pointer accent-[#8B55DD]"
//                             checked={selectedKeys.has(f.field_key)}
//                             onChange={() => toggleKey(f.field_key)}
//                           />
//                           <Icon size={11} className="text-[#9ca3af] flex-shrink-0" />
//                           <span className="flex-1 text-[0.8125rem] font-mono text-[#3F3F46]">{f.field_key}</span>
//                           <span className={`${CLS.fieldTypeBadge} ${meta.badge} !text-[0.5rem]`}>{meta.label}</span>
//                           <span className="text-[0.6875rem] text-[#9ca3af] flex-[2] whitespace-nowrap overflow-hidden text-ellipsis">{f.instruction}</span>
//                         </label>
//                       );
//                     })}
//                   </div>
//                   <div className="text-[0.6875rem] text-[#9ca3af]">
//                     {selectedKeys.size} of {suggestions.length} fields selected — you can add, edit or remove fields after creation.
//                   </div>
//                 </>
//               ) : (
//                 <div className="p-6 text-center text-[#9ca3af] text-[0.8125rem] border border-dashed border-[#e5e7eb] rounded-lg">
//                   No suggested fields for custom templates.<br />
//                   You can add fields manually in the Schema editor after creating.
//                 </div>
//               )}

//               {/* JSON import (collapsed by default) */}
//               <div>
//                 <button
//                   type="button"
//                   className="text-xs text-[#8B55DD] bg-transparent border-none cursor-pointer p-0 font-[inherit] flex items-center gap-1 hover:text-[#6d38c3]"
//                   onClick={() => setShowJsonImport((v) => !v)}
//                 >
//                   {showJsonImport ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
//                   Import additional fields from JSON
//                 </button>
//                 {showJsonImport && (
//                   <div className={`${CLS.formGroup} mt-3`}>
//                     <div className="border-2 border-dashed border-black/[0.12] rounded-xl p-5 text-center cursor-pointer transition-all duration-200 relative hover:border-[#8B55DD]/30 hover:bg-[#8B55DD]/[0.02]">
//                       <Upload size={18} className="text-[#9ca3af] mb-1 mx-auto" />
//                       <p className="m-0 text-[0.8125rem] text-[#71717A]">
//                         Drag and drop JSON file or click to browse
//                       </p>
//                       <input
//                         type="file"
//                         accept=".json"
//                         className="absolute inset-0 opacity-0 cursor-pointer"
//                         onChange={(e) => { handleJsonFile(e.target.files[0]); e.target.value = ""; }}
//                       />
//                     </div>
//                     {importError && <span className={CLS.errorText}>{importError}</span>}
//                     {importedFields.length > 0 && (
//                       <span className="text-xs text-[#10b981]">
//                         <CheckCircle2 size={12} className="inline align-middle" /> {importedFields.length} fields imported
//                       </span>
//                     )}
//                   </div>
//                 )}
//               </div>

//               {apiError && (
//                 <div className="text-[0.8125rem] text-[#DC2626]">{apiError}</div>
//               )}
//             </div>

//             <div className="px-6 py-4 border-t border-[#e5e7eb] flex justify-end gap-3 mt-auto">
//               <button className={`${CLS.btn} ${CLS.btnGhost}`} onClick={() => setStep(2)}>← Back</button>
//               <button className={`${CLS.btn} ${CLS.btnPrimary}`} onClick={handleCreate} disabled={saving}>
//                 {saving ? <Spinner size={13} /> : null}
//                 Create Template →
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//     </>
//   );
// };

// // ─── Template Workspace ──────────────────────────────────────────────────────

// const TemplateWorkspace = ({ template: initialTemplate, onBack }) => {
//   const [template, setTemplate] = useState(initialTemplate);
//   const [saveStatus, setSaveStatus] = useState("idle");
//   const saveTimerRef = useRef(null);
//   const savedTimerRef = useRef(null);

//   const [activeTab, setActiveTab] = useState("schema");

//   const [editingName, setEditingName] = useState(false);
//   const nameInputRef = useRef(null);
//   const [slugDraft, setSlugDraft] = useState(initialTemplate.slug || "");
//   const [slugError, setSlugError] = useState("");
//   const [slugSaving, setSlugSaving] = useState(false);

//   const [schemaVersion, setSchemaVersion] = useState(0);
//   const [lastExtractedSchemaVersion, setLastExtractedSchemaVersion] = useState(0);

//   const [documents, setDocuments] = useState([]);
//   const [activeDocId, setActiveDocId] = useState(null);
//   const [leftTab, setLeftTab] = useState("pdf");
//   const [dragging, setDragging] = useState(false);
//   const [ocrEngine, setOcrEngine] = useState(initialTemplate.extraction_engine || "");
//   const [isOcrModalOpen, setIsOcrModalOpen] = useState(false);
//   const [pendingFiles, setPendingFiles] = useState(null);
//   const [reindex, setReindex] = useState(false);
//   const [engineChanged, setEngineChanged] = useState(false);
//   const [isEngineSettingsModal, setIsEngineSettingsModal] = useState(false);
//   const [batchRunning, setBatchRunning] = useState(false);
//   const [activePage, setActivePage] = useState(1);

//   const [highlightFields, setHighlightFields] = useState({});

//   const [pipelineOpen, setPipelineOpen] = useState(false);
//   const pipelineRef = useRef(null);
//   const [apiOpen, setApiOpen] = useState(false);
//   const apiRef = useRef(null);
//   const [apiSnippetMode, setApiSnippetMode] = useState("curl");
//   const [copiedKey, setCopiedKey] = useState("");
//   const copyTimerRef = useRef(null);

//   const fileInputRef = useRef(null);

//   useEffect(() => {
//     if (!pipelineOpen && !apiOpen) return;
//     const handler = (e) => {
//       if (pipelineRef.current && !pipelineRef.current.contains(e.target)) {
//         setPipelineOpen(false);
//       }
//       if (apiRef.current && !apiRef.current.contains(e.target)) {
//         setApiOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, [pipelineOpen, apiOpen]);

//   useEffect(() => {
//     setSlugDraft(template?.slug || "");
//     setSlugError("");
//   }, [template?.slug]);

//   useEffect(() => () => {
//     if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
//   }, []);

//   useEffect(() => {
//     if (initialTemplate?.id && (!initialTemplate.fields || initialTemplate.fields.length === undefined)) {
//       getTemplate(initialTemplate.id).then((full) => {
//         setTemplate(full);
//       }).catch(() => {});
//     }
//   }, [initialTemplate]);

//   const triggerAutoSave = useCallback((updatedTemplate) => {
//     setSaveStatus("unsaved");
//     if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
//     if (savedTimerRef.current) clearTimeout(savedTimerRef.current);

//     saveTimerRef.current = setTimeout(async () => {
//       setSaveStatus("saving");
//       try {
//         const saved = await updateTemplate(updatedTemplate.id, updatedTemplate);
//         setTemplate(saved);
//         setSaveStatus("saved");
//         savedTimerRef.current = setTimeout(() => setSaveStatus("idle"), 3000);
//       } catch {
//         setSaveStatus("unsaved");
//       }
//     }, 800);
//   }, []);

//   const markCopied = useCallback((key) => {
//     setCopiedKey(key);
//     if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
//     copyTimerRef.current = setTimeout(() => setCopiedKey(""), 1800);
//   }, []);

//   const copyToClipboard = useCallback(async (text, key) => {
//     try {
//       await copyTextToClipboard(text);
//       markCopied(key);
//     } catch {
//       window.alert("Couldn't copy automatically. Please copy the text manually.");
//     }
//   }, [markCopied]);

//   const updateTemplateField = (key, value) => {
//     setTemplate((prev) => {
//       const updated = { ...prev, [key]: value };
//       triggerAutoSave(updated);
//       return updated;
//     });
//   };

//   const handleSlugDraftChange = (value) => {
//     const nextSlug = generateSlug(value);
//     setSlugDraft(nextSlug);
//     if (!nextSlug) {
//       setSlugError("");
//       return;
//     }
//     setSlugError(nextSlug.length < 3 ? "Slug must be at least 3 characters." : "");
//   };

//   const handleSlugSave = async () => {
//     const nextSlug = generateSlug(slugDraft);

//     if (!nextSlug) {
//       setSlugError("Slug is required.");
//       return;
//     }

//     if (nextSlug.length < 3) {
//       setSlugError("Slug must be at least 3 characters.");
//       return;
//     }

//     if (nextSlug === (template.slug || "")) {
//       setSlugError("");
//       return;
//     }

//     if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
//     if (savedTimerRef.current) clearTimeout(savedTimerRef.current);

//     setSlugSaving(true);
//     setSlugError("");
//     setSaveStatus("saving");

//     try {
//       const saved = await updateTemplate(template.id, {
//         ...template,
//         slug: nextSlug,
//       });
//       setTemplate(saved);
//       setSaveStatus("saved");
//       savedTimerRef.current = setTimeout(() => setSaveStatus("idle"), 3000);
//     } catch (err) {
//       setSaveStatus("unsaved");
//       const slugMessage = err.response?.data?.slug;
//       setSlugError(
//         Array.isArray(slugMessage)
//           ? slugMessage[0]
//           : slugMessage || "Failed to update slug. Please try again."
//       );
//     } finally {
//       setSlugSaving(false);
//     }
//   };

//   const addField = () => {
//     setTemplate((prev) => {
//       const updated = {
//         ...prev,
//         fields: [
//           ...(prev.fields || []),
//           {
//             field_key: `field_${(prev.fields?.length || 0) + 1}`,
//             data_type: "text",
//             instruction: "",
//             output_rules: "",
//             field_order: (prev.fields?.length || 0) + 1,
//             system_mapping: "",
//             schema_definition: null,
//           },
//         ],
//       };
//       triggerAutoSave(updated);
//       setSchemaVersion((v) => v + 1);
//       return updated;
//     });
//   };

//   const updateField = (idx, updatedField) => {
//     setTemplate((prev) => {
//       const fields = [...(prev.fields || [])];
//       fields[idx] = updatedField;
//       const updated = { ...prev, fields };
//       triggerAutoSave(updated);
//       setSchemaVersion((v) => v + 1);
//       return updated;
//     });
//   };

//   const deleteField = (idx) => {
//     setTemplate((prev) => {
//       const updated = {
//         ...prev,
//         fields: (prev.fields || []).filter((_, i) => i !== idx),
//       };
//       triggerAutoSave(updated);
//       setSchemaVersion((v) => v + 1);
//       return updated;
//     });
//   };

//   const handleNameBlur = () => {
//     setEditingName(false);
//     if (template.name?.trim()) {
//       triggerAutoSave(template);
//     }
//   };

//   const handleNameKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.target.blur();
//     }
//   };

//   const updateDoc = useCallback((docId, updates) => {
//     setDocuments((prev) =>
//       prev.map((d) => (d.id === docId ? { ...d, ...updates } : d))
//     );
//   }, []);

//   const handleFiles = useCallback(async (fileList, forceEngine = null) => {
//     if (!fileList || fileList.length === 0) return;

//     const engineToUse = forceEngine || ocrEngine;
//     if (!engineToUse) {
//       setPendingFiles(Array.from(fileList));
//       setIsOcrModalOpen(true);
//       return;
//     }

//     const newDocs = Array.from(fileList).map((f) => ({
//       id: nextDocId(),
//       file: f,
//       ingestData: null,
//       ingesting: true,
//       extracting: false,
//       result: null,
//       selected: true,
//     }));

//     setDocuments((prev) => [...prev, ...newDocs]);
//     setActiveDocId((prev) => prev || newDocs[0].id);

//     for (const doc of newDocs) {
//       try {
//         const data = await ingestDocument(doc.file, { engine: engineToUse, reindex });
//         setDocuments((prev) =>
//           prev.map((d) =>
//             d.id === doc.id ? { ...d, ingestData: data, ingesting: false } : d
//           )
//         );
//       } catch {
//         setDocuments((prev) =>
//           prev.map((d) =>
//             d.id === doc.id ? { ...d, ingesting: false, ingestData: null } : d
//           )
//         );
//       }
//     }
//   }, [ocrEngine, reindex]);

//   const handleOcrEngineSelect = (selectedEngine) => {
//     const prevEngine = ocrEngine;
//     setOcrEngine(selectedEngine);
//     setIsOcrModalOpen(false);

//     if (isEngineSettingsModal) {
//       updateTemplateField("extraction_engine", selectedEngine);
//       setIsEngineSettingsModal(false);
//       if (prevEngine && prevEngine !== selectedEngine && documents.some((d) => d.ingestData)) {
//         setEngineChanged(true);
//       }
//     } else if (pendingFiles) {
//       handleFiles(pendingFiles, selectedEngine);
//       setPendingFiles(null);
//     }
//   };

//   const onDrop = useCallback(
//     (e) => {
//       e.preventDefault();
//       setDragging(false);
//       if (e.dataTransfer.files?.length > 0) handleFiles(e.dataTransfer.files);
//     },
//     [handleFiles]
//   );

//   const onDragOver = (e) => { e.preventDefault(); setDragging(true); };
//   const onDragLeave = () => setDragging(false);

//   const removeDoc = (docId) => {
//     setDocuments((prev) => prev.filter((d) => d.id !== docId));
//     setActiveDocId((prev) => {
//       if (prev !== docId) return prev;
//       const remaining = documents.filter((d) => d.id !== docId);
//       return remaining.length > 0 ? remaining[0].id : null;
//     });
//   };

//   const handleReIngest = async () => {
//     const docsToReIngest = documents.filter((d) => d.selected && d.file);
//     if (docsToReIngest.length === 0) return;

//     setEngineChanged(false);

//     for (const doc of docsToReIngest) {
//       updateDoc(doc.id, { ingesting: true, ingestData: null, result: null });
//     }

//     for (const doc of docsToReIngest) {
//       try {
//         const data = await ingestDocument(doc.file, { engine: ocrEngine, reindex: true });
//         updateDoc(doc.id, { ingestData: data, ingesting: false });
//       } catch {
//         updateDoc(doc.id, { ingesting: false, ingestData: null });
//       }
//     }
//   };

//   const handleBatchExtract = async () => {
//     if (!template?.slug) return;
//     const docsToExtract = documents.filter((d) => d.selected && d.ingestData && !d.extracting);
//     if (docsToExtract.length === 0) return;

//     setBatchRunning(true);

//     for (const doc of docsToExtract) {
//       updateDoc(doc.id, { extracting: true, result: null });
//     }

//     for (const doc of docsToExtract) {
//       try {
//         const data = await universalExtract(doc.file, template.slug, { reindex });
//         updateDoc(doc.id, { result: data, extracting: false });
//       } catch {
//         updateDoc(doc.id, {
//           result: { _error: "Extraction failed. Check template instructions." },
//           extracting: false,
//         });
//       }
//     }

//     setLastExtractedSchemaVersion(schemaVersion);
//     setBatchRunning(false);
//   };

//   const activeDoc = documents.find((d) => d.id === activeDocId);
//   const readyCount = documents.filter((d) => d.selected && d.ingestData).length;
//   const canExtract = readyCount > 0 && template?.slug && !batchRunning;
//   const fields = template?.fields || [];
//   const isStale = activeDoc?.result && !activeDoc.result._error && schemaVersion > lastExtractedSchemaVersion && lastExtractedSchemaVersion > 0;
//   const trimmedSlugDraft = slugDraft.trim();
//   const canSaveSlug =
//     !!trimmedSlugDraft &&
//     trimmedSlugDraft.length >= 3 &&
//     trimmedSlugDraft !== (template?.slug || "") &&
//     !slugSaving;
//   const universalExtractUrl = buildUniversalExtractUrl(template?.slug || "");
//   const curlSnippet = buildCurlSnippet(template?.slug || "");
//   const fetchSnippet = buildFetchSnippet(template?.slug || "");
//   const activeApiSnippet = apiSnippetMode === "curl" ? curlSnippet : fetchSnippet;

//   const getHighlightedText = (pageText) => {
//     if (!pageText) return pageText;
//     const activeHighlights = Object.entries(highlightFields).filter(([, v]) => v);
//     if (activeHighlights.length === 0) return null;

//     const extractedData = activeDoc?.result?.extracted_data ?? activeDoc?.result;
//     if (!extractedData) return null;

//     let html = pageText.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

//     for (const [fieldKey] of activeHighlights) {
//       const val = extractedData[fieldKey];
//       if (val && typeof val === "string" && val.trim()) {
//         const escaped = val.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//         const regex = new RegExp(`(${escaped})`, "gi");
//         html = html.replace(regex, `<mark class="ex-highlight">$1</mark>`);
//       }
//     }
//     return html;
//   };

//   const hasActiveHighlights = Object.values(highlightFields).some(Boolean);

//   useEffect(() => {
//     if (hasActiveHighlights && leftTab === "pdf") {
//       setLeftTab("text");
//     }
//   }, [hasActiveHighlights]);

//   return (
//     <div className="flex flex-col h-screen overflow-hidden">
//       <OcrEngineModal
//         isOpen={isOcrModalOpen}
//         onClose={() => { setIsOcrModalOpen(false); setPendingFiles(null); setIsEngineSettingsModal(false); }}
//         onSelect={handleOcrEngineSelect}
//         currentEngine={ocrEngine}
//       />

//       {/* ── TOP BAR ──────────────────────────────────────────────────────── */}
//       <div className="h-14 flex items-center px-4 gap-3 border-b border-[#e5e7eb] flex-shrink-0 bg-white">
//         <button
//           className="flex items-center gap-1.5 bg-transparent border-none cursor-pointer text-[0.8125rem] font-medium text-[#71717A] px-2 py-1.5 rounded-md transition-all duration-150 hover:bg-black/[0.04] hover:text-[#3F3F46]"
//           onClick={onBack}
//         >
//           <ArrowLeft size={16} /> Back
//         </button>

//         {/* Template name - inline editable */}
//         <div className="flex items-center gap-2 min-w-0">
//           {editingName ? (
//             <input
//               ref={nameInputRef}
//               className="bg-transparent border-none border-b border-dashed border-transparent text-base font-bold text-[#171717] cursor-pointer px-0.5 w-[200px] hover:border-b-[#d1d5db] focus:border-b-[#d1d5db] focus:outline-none"
//               value={template.name || ""}
//               onChange={(e) => setTemplate((prev) => ({ ...prev, name: e.target.value }))}
//               onBlur={handleNameBlur}
//               onKeyDown={handleNameKeyDown}
//               autoFocus
//             />
//           ) : (
//             <span
//               className="text-base font-bold text-[#171717] cursor-pointer flex items-center gap-1.5"
//               onClick={() => setEditingName(true)}
//             >
//               {template.name || "Untitled"}
//               <Pencil size={12} className="text-[#9ca3af]" />
//             </span>
//           )}
//           {template.slug && (
//             <span
//               className="text-xs font-mono text-[#8B55DD] bg-[#8B55DD]/[0.08] px-2 py-1 rounded-lg inline-flex max-w-full overflow-hidden text-ellipsis whitespace-nowrap"
//               title="This slug is used in the universal extract API."
//             >
//               /{template.slug}
//             </span>
//           )}
//         </div>

//         {/* Save status */}
//         {saveStatus === "unsaved" && (
//           <span className="text-xs flex items-center gap-1 text-[#f59e0b]">● Unsaved changes</span>
//         )}
//         {saveStatus === "saving" && (
//           <span className="text-xs flex items-center gap-1 text-[#9ca3af]"><Spinner size={10} /> Saving...</span>
//         )}
//         {saveStatus === "saved" && (
//           <span className="text-xs flex items-center gap-1 text-[#10b981]"><CheckCircle2 size={12} /> Saved</span>
//         )}

//         {/* Doc type badge */}
//         {template.document_type && (
//           <span className="text-[0.625rem] font-bold uppercase tracking-[0.06em] px-2.5 py-1 rounded-full bg-[#F5F4F3] text-[#71717A] border border-black/[0.08]">{template.document_type}</span>
//         )}

//         {/* Center tabs */}
//         <div className="flex gap-1 mx-auto">
//           {["schema", "test", "history"].map((tab) => (
//             <button
//               key={tab}
//               className={`px-3.5 py-1.5 rounded-md text-sm border-none cursor-pointer font-medium transition-all duration-150 ${activeTab === tab ? "!font-semibold !text-[#8B55DD] !bg-[#8B55DD]/[0.08]" : "bg-transparent text-[#6b7280] hover:bg-black/[0.04] hover:text-[#3F3F46]"}`}
//               onClick={() => setActiveTab(tab)}
//             >
//               {tab.charAt(0).toUpperCase() + tab.slice(1)}
//             </button>
//           ))}
//         </div>

//         {/* Pipeline Settings */}
//         <div className="relative" ref={pipelineRef}>
//           <button
//             className={`${CLS.btn} ${CLS.btnGhost} !gap-1.5`}
//             onClick={() => {
//               setApiOpen(false);
//               setPipelineOpen((v) => !v);
//             }}
//           >
//             <Settings size={13} />
//             Pipeline Settings
//             <ChevronDown size={11} className="opacity-60" />
//           </button>
//           {pipelineOpen && (
//             <div className="absolute top-[calc(100%+8px)] right-0 bg-white border border-[#e5e7eb] rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] p-4 w-[280px] z-[200] flex flex-col gap-3.5">
//               <div className="text-[0.6875rem] font-bold uppercase tracking-[0.06em] text-[#9ca3af] pb-2 border-b border-[#f3f4f6]">Pipeline Settings</div>

//               <div className="flex flex-col gap-1">
//                 <span className="text-[0.6875rem] font-semibold text-[#52525b]">Template Slug</span>
//                 <span className="text-[0.625rem] text-[#9ca3af]">Used in the universal extract API URL for this template</span>
//                 <div className="flex items-center gap-2">
//                   <input
//                     className={`${CLS.input} flex-1 min-w-0 font-mono ${slugError ? CLS.inputError : ""}`}
//                     value={slugDraft}
//                     onChange={(e) => handleSlugDraftChange(e.target.value)}
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter") handleSlugSave();
//                     }}
//                     placeholder="unique-template-slug"
//                   />
//                   <button
//                     className={`${CLS.btn} ${CLS.btnSecondary} ${CLS.btnSm}`}
//                     onClick={handleSlugSave}
//                     disabled={!canSaveSlug}
//                   >
//                     {slugSaving ? <><Spinner size={12} /> Updating</> : "Update"}
//                   </button>
//                 </div>
//                 {slugError && (
//                   <span className="text-[0.6875rem] text-[#dc2626]">{slugError}</span>
//                 )}
//               </div>

//               <div className="flex flex-col gap-1">
//                 <span className="text-[0.6875rem] font-semibold text-[#52525b]">Extraction Engine</span>
//                 <span className="text-[0.625rem] text-[#9ca3af]">How the document is read before AI processing</span>
//                 <button
//                   className="w-full mt-1 px-2.5 py-2 border border-black/10 rounded-lg bg-[#FAFAFF] cursor-pointer flex items-center gap-2 text-left transition-all duration-150 flex-wrap text-[#8B55DD] hover:border-[#8B55DD]/30 hover:bg-[#8B55DD]/[0.04]"
//                   onClick={() => {
//                     setIsEngineSettingsModal(true);
//                     setIsOcrModalOpen(true);
//                     setPipelineOpen(false);
//                   }}
//                 >
//                   <Cpu size={13} />
//                   <span className="text-[0.8125rem] font-bold text-[#171717]">
//                     {ENGINE_OPTIONS.find((o) => o.value === (template.extraction_engine || ocrEngine))?.label || "Select Engine"}
//                   </span>
//                   <span className="w-full text-[0.6875rem] text-[#9CA3AF] leading-[1.3] pl-[1.625rem] -mt-0.5">
//                     {ENGINE_OPTIONS.find((o) => o.value === (template.extraction_engine || ocrEngine))?.shortDesc || ""}
//                   </span>
//                   <ChevronRight size={13} className="ml-auto opacity-40 flex-shrink-0" />
//                 </button>
//               </div>

//               <div className="flex flex-col gap-1">
//                 <span className="text-[0.6875rem] font-semibold text-[#52525b]">AI Model</span>
//                 <span className="text-[0.625rem] text-[#9ca3af]">Model used to extract the fields</span>
//                 <select
//                   className="w-full mt-1 px-2 py-1.5 border border-black/10 rounded-md text-xs text-[#3F3F46] bg-white outline-none cursor-pointer transition-all duration-150 hover:border-black/20 focus:border-[rgba(139,85,221,0.4)] focus:shadow-[0_0_0_2px_rgba(139,85,221,0.08)]"
//                   value={template.llm_model_key || "gemini_2_5_flash_lite"}
//                   onChange={(e) => updateTemplateField("llm_model_key", e.target.value)}
//                 >
//                   {LLM_MODEL_OPTIONS.map((opt) => (
//                     <option key={opt.value} value={opt.value}>{opt.label}</option>
//                   ))}
//                 </select>
//               </div>

//               <div className="flex flex-col gap-1">
//                 <span className="text-[0.6875rem] font-semibold text-[#52525b]">Retrieval Mode</span>
//                 <span className="text-[0.625rem] text-[#9ca3af]">How relevant sections are found in long documents</span>
//                 <select
//                   className="w-full mt-1 px-2 py-1.5 border border-black/10 rounded-md text-xs text-[#3F3F46] bg-white outline-none cursor-pointer transition-all duration-150 hover:border-black/20 focus:border-[rgba(139,85,221,0.4)] focus:shadow-[0_0_0_2px_rgba(139,85,221,0.08)]"
//                   value={template.retrieval_strategy || "full_text"}
//                   onChange={(e) => updateTemplateField("retrieval_strategy", e.target.value)}
//                 >
//                   {RETRIEVAL_OPTIONS.map((opt) => (
//                     <option key={opt.value} value={opt.value}>{opt.label}</option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="relative" ref={apiRef}>
//           <button
//             className={`${CLS.btn} ${CLS.btnGhost} !gap-1.5`}
//             onClick={() => {
//               setPipelineOpen(false);
//               setApiOpen((v) => !v);
//             }}
//           >
//             <Code2 size={13} />
//             API Usage
//             <ChevronDown size={11} className="opacity-60" />
//           </button>
//           {apiOpen && (
//             <div className="absolute top-[calc(100%+8px)] right-0 w-[420px] max-w-[min(420px,calc(100vw-2rem))] bg-white border border-[#e5e7eb] rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] p-4 z-[200]">
//               <div className="text-[0.6875rem] font-bold uppercase tracking-[0.06em] text-[#9ca3af] pb-2 border-b border-[#f3f4f6]">Universal Extract API</div>
//               <p className="m-0 mt-3.5 mb-3.5 text-xs leading-[1.5] text-[#71717a]">
//                 Post a file to this endpoint with your saved template slug to reuse the template anywhere.
//               </p>

//               <div className="flex items-start justify-between gap-3 py-3">
//                 <div>
//                   <span className="text-[0.6875rem] font-semibold text-[#52525b]">Template Slug</span>
//                   <code className="inline-block mt-1.5 px-2 py-[0.3125rem] rounded-lg bg-[#faf5ff] text-[#6b21a8] text-xs leading-[1.4] font-mono break-all">{template.slug}</code>
//                 </div>
//                 <button
//                   className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[0.6875rem] font-semibold border-none cursor-pointer bg-transparent text-[#9CA3AF] transition-all duration-150 hover:bg-black/[0.04] hover:text-[#52525B]"
//                   onClick={() => copyToClipboard(template.slug || "", "slug")}
//                 >
//                   {copiedKey === "slug" ? <><Check size={12} /> Copied</> : <><Copy size={12} /> Copy</>}
//                 </button>
//               </div>

//               <div className="flex items-start justify-between gap-3 py-3 border-t border-[#f4f4f5]">
//                 <div className="flex-1 min-w-0">
//                   <span className="text-[0.6875rem] font-semibold text-[#52525b]">Endpoint</span>
//                   <code className="inline-block mt-1.5 px-2 py-[0.3125rem] rounded-lg bg-[#faf5ff] text-[#6b21a8] text-xs leading-[1.4] font-mono break-all w-full whitespace-pre-wrap">
//                     {universalExtractUrl}
//                   </code>
//                 </div>
//                 <button
//                   className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-[0.6875rem] font-semibold border-none cursor-pointer bg-transparent text-[#9CA3AF] transition-all duration-150 hover:bg-black/[0.04] hover:text-[#52525B]"
//                   onClick={() => copyToClipboard(universalExtractUrl, "endpoint")}
//                 >
//                   {copiedKey === "endpoint" ? <><Check size={12} /> Copied</> : <><Copy size={12} /> Copy</>}
//                 </button>
//               </div>

//               <div className="mt-1 p-3 rounded-xl bg-[#f8fafc] text-[#475569] text-xs leading-[1.5]">
//                 Send the document as <strong>multipart/form-data</strong> in the <code className="font-mono text-[#0f172a]">file</code> field and include a bearer token.
//               </div>

//               <div className="inline-flex gap-1 mt-3.5 p-1 rounded-xl bg-[#f4f4f5]">
//                 <button
//                   className={`border-none text-xs font-semibold px-3 py-1.5 rounded-[10px] cursor-pointer transition-all duration-150 ${apiSnippetMode === "curl" ? "bg-white text-[#111827] shadow-[0_1px_2px_rgba(0,0,0,0.08)]" : "bg-transparent text-[#71717a]"}`}
//                   onClick={() => setApiSnippetMode("curl")}
//                 >
//                   cURL
//                 </button>
//                 <button
//                   className={`border-none text-xs font-semibold px-3 py-1.5 rounded-[10px] cursor-pointer transition-all duration-150 ${apiSnippetMode === "fetch" ? "bg-white text-[#111827] shadow-[0_1px_2px_rgba(0,0,0,0.08)]" : "bg-transparent text-[#71717a]"}`}
//                   onClick={() => setApiSnippetMode("fetch")}
//                 >
//                   JavaScript
//                 </button>
//               </div>

//               <div className="relative mt-3 rounded-[14px] bg-[#111827] overflow-hidden">
//                 <button
//                   className="absolute top-2.5 right-2.5 inline-flex items-center gap-1 px-2 py-1 rounded-md text-[0.6875rem] font-semibold cursor-pointer bg-white/[0.12] border border-white/[0.16] text-[#f9fafb] hover:bg-white/[0.18] hover:!text-white"
//                   onClick={() => copyToClipboard(activeApiSnippet, "snippet")}
//                 >
//                   {copiedKey === "snippet" ? <><Check size={12} /> Copied</> : <><Copy size={12} /> Copy Snippet</>}
//                 </button>
//                 <pre className="m-0 p-4 pt-12 text-[#e5e7eb] text-xs leading-[1.7] overflow-x-auto font-mono">{activeApiSnippet}</pre>
//               </div>
//             </div>
//           )}
//         </div>

//         <div className="w-px h-6 bg-black/10 flex-shrink-0" />

//         {activeTab === "schema" && (
//           <button className={`${CLS.btn} ${CLS.btnGhost}`} onClick={addField}>
//             <Plus size={13} /> Add Field
//           </button>
//         )}
//         {activeTab === "test" && (
//           <>
//             <button
//               className={`${CLS.btn} ${CLS.btnGhost}`}
//               onClick={() => fileInputRef.current?.click()}
//             >
//               <Plus size={13} /> Add Files
//             </button>
//             <input
//               ref={fileInputRef}
//               type="file"
//               multiple
//               accept=".pdf,.png,.jpg,.jpeg,.docx,.txt,.xlsx,.xls,.csv"
//               className="hidden"
//               onChange={(e) => { handleFiles(e.target.files); e.target.value = ""; }}
//             />
//             <button
//               className="px-4 py-1.5 rounded-lg text-[0.8125rem] font-bold flex items-center gap-2 border-none cursor-pointer transition-all duration-200 bg-gradient-to-r from-[#8B55DD] to-[#9177B8] text-white shadow-[0_1px_4px_rgba(139,85,221,0.2)] hover:enabled:bg-gradient-to-r hover:enabled:from-[#7A48CC] hover:enabled:to-[#8068A8] hover:enabled:shadow-[0_2px_12px_rgba(139,85,221,0.3)] hover:enabled:-translate-y-px disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
//               onClick={handleBatchExtract}
//               disabled={!canExtract}
//             >
//               {batchRunning ? (
//                 <><Spinner size={14} /> Extracting…</>
//               ) : (
//                 <><Sparkles size={14} /> Run Extraction{readyCount > 0 ? ` (${readyCount})` : ""}</>
//               )}
//             </button>
//           </>
//         )}
//       </div>

//       {/* ── BODY ─────────────────────────────────────────────────────────── */}
//       <div className="flex-1 overflow-hidden flex">

//         {/* ── SCHEMA TAB ─────────────────────────────────────────────────── */}
//         {activeTab === "schema" && (
//           <div className="w-full border-r-0 overflow-y-auto flex flex-col bg-[#FEF9F7]">
//             <div className="flex items-center justify-between px-4 py-3 border-b border-black/[0.06] bg-black/[0.015]">
//               <span className="flex items-center gap-1.5 text-xs font-semibold text-[#52525B] tracking-[0.03em] uppercase">
//                 <Layers size={13} />
//                 Extraction Fields
//                 <span className={CLS.fieldCountBadge}>{fields.length}</span>
//               </span>
//               <button
//                 className="flex items-center gap-1.5 bg-[#8B55DD]/[0.08] text-[#8B55DD] border border-dashed border-[#8B55DD]/25 rounded-md px-3 py-1.5 text-xs font-medium cursor-pointer transition-all duration-150 hover:bg-[#8B55DD]/[0.14] hover:border-[#8B55DD]/40"
//                 onClick={addField}
//               >
//                 <Plus size={13} /> Add Field
//               </button>
//             </div>
//             <div className="flex-1 overflow-y-auto p-4">
//               {fields.length === 0 ? (
//                 <div className="flex flex-col items-center text-center px-6 py-12 text-[#A1A1AA]">
//                   <div className="mb-3 opacity-30"><Layers size={28} /></div>
//                   <p className="text-[0.8125rem] font-semibold text-[#71717A] m-0 mb-1.5">No fields defined</p>
//                   <p className="text-xs text-[#A1A1AA] m-0 mb-4 max-w-[18rem] leading-[1.5]">Add fields to tell the AI what data to extract from your documents.</p>
//                   <button
//                     className="flex items-center gap-1.5 bg-[#8B55DD]/[0.08] text-[#8B55DD] border border-dashed border-[#8B55DD]/25 rounded-lg px-5 py-2 text-[0.8125rem] font-medium cursor-pointer transition-all duration-150 hover:bg-[#8B55DD]/[0.14] hover:border-[#8B55DD]/40"
//                     onClick={addField}
//                   >
//                     <Plus size={14} /> Add Your First Field
//                   </button>
//                 </div>
//               ) : (
//                 <div className="flex flex-col gap-1.5">
//                   {fields.map((field, idx) => (
//                     <FieldRow
//                       key={idx}
//                       index={idx}
//                       field={field}
//                       onChange={(updated) => updateField(idx, updated)}
//                       onDelete={() => deleteField(idx)}
//                     />
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {/* ── TEST TAB ───────────────────────────────────────────────────── */}
//         {activeTab === "test" && (
//           <>
//             {/* Left: Compact schema panel */}
//             <div className="w-[300px] flex-shrink-0 border-r border-[#e5e7eb] overflow-y-auto flex flex-col bg-white">
//               <div className={CLS.panelTopbar}>
//                 <span className={CLS.panelTitle}>
//                   Schema
//                   <span className={CLS.fieldCountBadge}>{fields.length}</span>
//                 </span>
//               </div>
//               <div className="flex-1 overflow-y-auto py-2">
//                 {fields.length === 0 ? (
//                   <div className="flex flex-col items-center text-center p-6">
//                     <p className="text-xs text-[#9CA3AF] max-w-[300px] leading-[1.5] m-0">No fields defined yet</p>
//                   </div>
//                 ) : (
//                   fields.map((field, idx) => {
//                     const meta = DATA_TYPE_META[field.data_type] || DATA_TYPE_META.text;
//                     const FIcon = meta.icon;
//                     return (
//                       <div key={idx} className="flex items-center gap-2 px-3 py-[0.4375rem] rounded-md text-[0.8125rem] text-[#3F3F46] transition-colors hover:bg-black/[0.03]">
//                         <FIcon size={12} className="text-[#9ca3af] flex-shrink-0" />
//                         <span className="flex-1 text-[0.8125rem] font-mono text-[#3F3F46]">
//                           {field.field_key}
//                         </span>
//                         <span className={`${CLS.fieldTypeBadge} ${meta.badge} !text-[0.5rem]`}>
//                           {meta.label}
//                         </span>
//                       </div>
//                     );
//                   })
//                 )}
//               </div>
//               <div className="px-3 py-2 border-t border-[#e5e7eb]">
//                 <button
//                   className={`${CLS.btn} ${CLS.btnGhost} ${CLS.btnSm} !w-full !justify-center`}
//                   onClick={() => setActiveTab("schema")}
//                 >
//                   Edit Schema →
//                 </button>
//               </div>
//             </div>

//             {/* Center: Document Viewer */}
//             <div
//               className="flex-1 min-w-[300px] flex flex-col overflow-hidden border-r border-[#e5e7eb] relative"
//               onDrop={onDrop}
//               onDragOver={onDragOver}
//               onDragLeave={onDragLeave}
//             >
//               {dragging && (
//                 <div className="absolute inset-0 bg-[#8B55DD]/[0.06] border-2 border-dashed border-[#8B55DD] rounded-lg flex flex-col items-center justify-center gap-2 z-10 pointer-events-none">
//                   <Upload size={32} />
//                   <span className="text-base font-semibold text-[#8B55DD]">Drop to upload</span>
//                 </div>
//               )}

//               {/* Doc tabs */}
//               {documents.length > 0 && (
//                 <div className="flex items-center gap-1 border-b border-black/[0.07] bg-black/[0.015] px-2 pt-1.5 min-h-[2.5rem]">
//                   <div className="flex gap-1 overflow-x-auto overflow-y-hidden flex-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
//                     {documents.map((doc) => (
//                       <div
//                         key={doc.id}
//                         className={`group relative flex items-center gap-[0.3rem] px-2 py-[0.35rem] rounded-t-md border border-transparent border-b-0 cursor-pointer text-xs font-medium whitespace-nowrap transition-all duration-150 max-w-[14rem] ${doc.id === activeDocId ? "bg-white text-[#3F3F46] !border-black/10 shadow-[0_-1px_3px_rgba(0,0,0,0.04)]" : "bg-transparent text-[#71717A] hover:bg-black/[0.03] hover:text-[#3F3F46]"}`}
//                         onClick={() => setActiveDocId(doc.id)}
//                       >
//                         {doc.id === activeDocId && (
//                           <span className="absolute -bottom-px left-0 right-0 h-px bg-white" />
//                         )}
//                         <input
//                           type="checkbox"
//                           className="w-3.5 h-3.5 cursor-pointer flex-shrink-0 m-0 accent-[#8B55DD]"
//                           checked={!!doc.selected}
//                           title={doc.selected ? "Selected for extraction" : "Click to include in extraction"}
//                           onClick={(e) => e.stopPropagation()}
//                           onChange={(e) => {
//                             const checked = e.target.checked;
//                             setDocuments((prev) =>
//                               prev.map((d) => d.id === doc.id ? { ...d, selected: checked } : d)
//                             );
//                           }}
//                         />
//                         <span className="overflow-hidden text-ellipsis max-w-[10rem]">{doc.file.name}</span>
//                         {doc.ingesting && <Spinner size={10} />}
//                         {!doc.ingesting && doc.ingestData && !doc.result && (
//                           <CheckCircle2 size={11} className="text-[#D97706]" />
//                         )}
//                         {doc.extracting && <Spinner size={10} />}
//                         {doc.result && !doc.result._error && !doc.extracting && (
//                           <CheckCircle2 size={11} className="text-[#16A34A]" />
//                         )}
//                         {doc.result && doc.result._error && (
//                           <XCircle size={11} className="text-[#DC2626]" />
//                         )}
//                         <button
//                           className="bg-transparent border-none cursor-pointer text-[#A1A1AA] p-0.5 rounded flex items-center opacity-0 transition-all duration-150 group-hover:opacity-100 hover:bg-black/[0.08] hover:!text-[#DC2626]"
//                           onClick={(e) => { e.stopPropagation(); removeDoc(doc.id); }}
//                         >
//                           <X size={11} />
//                         </button>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {/* Engine changed banner */}
//               {engineChanged && documents.length > 0 && (
//                 <div className="flex items-center gap-2 px-3.5 py-2 bg-[#FFFBEB] border-b border-[#FDE68A] text-xs text-[#92400E]">
//                   <RefreshCw size={14} />
//                   <span>Engine changed to <strong className="font-bold">{ENGINE_OPTIONS.find((o) => o.value === ocrEngine)?.label}</strong> — documents need re-processing</span>
//                   <button
//                     className={`${CLS.btn} ${CLS.btnPrimary} ${CLS.btnSm} ml-auto flex-shrink-0 whitespace-nowrap`}
//                     onClick={handleReIngest}
//                   >
//                     Re-process{documents.filter((d) => d.selected).length > 0
//                       ? ` (${documents.filter((d) => d.selected).length})`
//                       : ""}
//                   </button>
//                 </div>
//               )}

//               {/* Panel header */}
//               <div className={CLS.panelTopbar}>
//                 <span className={CLS.panelTitle}>
//                   <FileText size={13} />
//                   Document Viewer
//                 </span>
//                 {activeDoc?.ingestData && (
//                   <span className="text-[0.6875rem] text-[#9ca3af] ml-auto">
//                     Page {activePage} of {activeDoc.ingestData.pages?.length || 0}
//                   </span>
//                 )}
//               </div>

//               {/* View tabs for loaded doc */}
//               {activeDoc?.ingestData && (
//                 <div className="flex gap-0 border-b border-black/[0.08] bg-white flex-shrink-0 px-2">
//                   <button
//                     className={`px-4 py-2.5 text-xs font-semibold border-none cursor-pointer bg-transparent flex items-center gap-1.5 border-b-2 border-transparent transition-all duration-150 -mb-px ${leftTab === "pdf" ? "!text-[#171717] !border-b-[#8B55DD]" : "text-[#71717A] hover:text-[#52525B]"}`}
//                     onClick={() => setLeftTab("pdf")}
//                   >
//                     <Eye size={12} /> PDF View
//                   </button>
//                   <button
//                     className={`px-4 py-2.5 text-xs font-semibold border-none cursor-pointer bg-transparent flex items-center gap-1.5 border-b-2 border-transparent transition-all duration-150 -mb-px ${leftTab === "text" ? "!text-[#171717] !border-b-[#8B55DD]" : "text-[#71717A] hover:text-[#52525B]"}`}
//                     onClick={() => setLeftTab("text")}
//                   >
//                     <Code2 size={12} /> AI Text View
//                   </button>
//                 </div>
//               )}

//               {/* Content area */}
//               {activeDoc?.ingesting ? (
//                 <div className="flex-1 flex flex-col items-center justify-center gap-6 text-[#71717A]">
//                   <div className="w-56 h-[3px] bg-black/[0.06] rounded-sm overflow-hidden">
//                     <div className="h-full bg-gradient-to-r from-[#8B55DD] to-[#9177B8]" style={{ animation: "ex-scan 1.5s ease-in-out infinite" }} />
//                   </div>
//                   <span className="text-[0.8125rem] text-[#52525B]">Indexing {activeDoc.file.name}…</span>
//                   <span className="text-xs text-[#71717A]">
//                     Processing with {ENGINE_OPTIONS.find(e => e.value === ocrEngine)?.label || ocrEngine} engine
//                   </span>
//                 </div>
//               ) : activeDoc?.ingestData ? (
//                 <div className="flex-1 flex overflow-hidden">
//                   {/* Thumbnail strip */}
//                   <div className="w-20 flex-shrink-0 overflow-y-auto border-r border-[#e5e7eb] flex flex-col gap-2 p-2">
//                     {activeDoc.ingestData.pages?.map((page, idx) => {
//                       const pageNum = page?.page_number ?? idx + 1;
//                       return (
//                         <div
//                           key={pageNum}
//                           className={`h-[100px] rounded border-2 cursor-pointer flex items-center justify-center text-xs text-[#9ca3af] bg-[#f9fafb] flex-shrink-0 transition-colors duration-150 ${activePage === pageNum ? "border-[#8B55DD]" : "border-[#e5e7eb] hover:border-[#d1d5db]"}`}
//                           onClick={() => setActivePage(pageNum)}
//                         >
//                           {pageNum}
//                         </div>
//                       );
//                     })}
//                   </div>

//                   {/* Main view */}
//                   <div className="flex-1 overflow-hidden flex flex-col">
//                     {leftTab === "pdf" && (
//                       <iframe
//                         className="flex-1 w-full border-none bg-white"
//                         src={activeDoc.ingestData.file_url}
//                         title="Document PDF"
//                       />
//                     )}
//                     {leftTab === "text" && (
//                       <div className="flex-1 overflow-y-auto overflow-x-hidden p-5 flex flex-col gap-4 bg-[#F8F8F8]">
//                         {activeDoc.ingestData.pages?.map((page) => {
//                           const pageNumber = page?.page_number ?? activeDoc.ingestData.pages.indexOf(page) + 1;
//                           const pageText = typeof page === "string" ? page : page?.text ?? "";
//                           const highlightHtml = getHighlightedText(pageText);

//                           return (
//                             <div key={pageNumber} className="border border-black/[0.08] rounded-[10px] overflow-hidden flex-shrink-0">
//                               <div className="px-3.5 py-2 bg-white text-[0.6875rem] font-bold text-[#71717A] uppercase tracking-[0.05em] border-b border-black/[0.06] flex items-center gap-1.5 sticky top-0 z-[1]">
//                                 <FileText size={11} />
//                                 Page {pageNumber}
//                                 <span className="ml-auto text-[0.625rem] text-[#9CA3AF] font-normal">
//                                   {pageText.split("\n").length} lines
//                                 </span>
//                               </div>
//                               {highlightHtml ? (
//                                 <pre
//                                   className="px-6 py-5 font-mono text-xs text-[#3F3F46] whitespace-pre-wrap break-words leading-[1.8] bg-white min-h-[4rem] overflow-visible m-0"
//                                   dangerouslySetInnerHTML={{ __html: highlightHtml }}
//                                 />
//                               ) : (
//                                 <pre className="px-6 py-5 font-mono text-xs text-[#3F3F46] whitespace-pre-wrap break-words leading-[1.8] bg-white min-h-[4rem] overflow-visible m-0">{pageText}</pre>
//                               )}
//                             </div>
//                           );
//                         })}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               ) : documents.length === 0 ? (
//                 <div
//                   className={`flex-1 flex flex-col items-center justify-center gap-5 p-12 relative border-2 border-dashed m-6 rounded-2xl transition-all duration-[250ms] cursor-pointer ${dragging ? "border-[#8B55DD] bg-[#8B55DD]/[0.04] shadow-[inset_0_0_32px_rgba(139,85,221,0.06)]" : "border-black/[0.12]"}`}
//                   onClick={() => fileInputRef.current?.click()}
//                 >
//                   <div className="w-[4.5rem] h-[4.5rem] rounded-2xl bg-gradient-to-br from-[#8B55DD]/10 to-[#8B55DD]/[0.04] border border-[#8B55DD]/[0.15] flex items-center justify-center text-[#8B55DD]">
//                     <Upload size={22} />
//                   </div>
//                   <p className="text-[0.9375rem] font-semibold text-[#3F3F46] m-0">Drop your documents here</p>
//                   <p className="text-[0.8125rem] text-[#71717A] -mt-2 m-0">or click to browse — supports multiple files</p>
//                   <span className="text-[0.6875rem] bg-black/[0.02] text-[#71717A] px-4 py-1.5 rounded-full border border-black/[0.08]">PDF · DOCX · TXT · XLS · CSV · PNG · JPG</span>
//                 </div>
//               ) : activeDoc && !activeDoc.ingestData && !activeDoc.ingesting ? (
//                 <div className="flex-1 flex flex-col items-center justify-center gap-6 text-[#71717A]">
//                   <div className="w-14 h-14 rounded-xl bg-[#8B55DD]/[0.05] border border-[#8B55DD]/[0.08] flex items-center justify-center text-[#9CA3AF] mb-3">
//                     <AlertCircle size={28} />
//                   </div>
//                   <span className="text-[0.8125rem] text-[#52525B]">Ingestion failed for this document</span>
//                   <span className="text-xs text-[#71717A]">Try removing and re-uploading</span>
//                 </div>
//               ) : (
//                 <div className="flex-1 flex flex-col items-center justify-center gap-6 text-[#71717A]">
//                   <span className="text-[0.8125rem] text-[#52525B]">Select a document tab above</span>
//                 </div>
//               )}
//             </div>

//             {/* Right: Results panel */}
//             <div className="w-[360px] flex-shrink-0 overflow-y-auto flex flex-col bg-white">
//               <div className={CLS.panelTopbar}>
//                 <span className={CLS.panelTitle}>Results</span>
//               </div>

//               {/* Stale banner */}
//               {isStale && (
//                 <div className="flex items-center gap-2 px-3.5 py-2.5 border-b border-[#e5e7eb] text-[0.8125rem] bg-[rgba(251,191,36,0.06)]">
//                   <RefreshCw size={14} className="text-[#f59e0b]" />
//                   <span>Schema updated — re-run to refresh</span>
//                   <button
//                     className={`${CLS.btn} ${CLS.btnPrimary} ml-auto !px-2.5 !py-1 !rounded-[5px] !text-[0.8rem]`}
//                     onClick={handleBatchExtract}
//                     disabled={!canExtract}
//                   >
//                     Run Again
//                   </button>
//                 </div>
//               )}

//               <div
//                 className="flex-1 overflow-y-auto transition-opacity duration-200"
//                 style={{ opacity: isStale ? 0.6 : 1 }}
//               >
//                 {activeDoc?.extracting ? (
//                   <div className="p-4">
//                     {fields.map((field, idx) => (
//                       <div key={idx} className="p-3 border border-[#e5e7eb] rounded-lg flex flex-col gap-2 mb-2">
//                         <span className="text-xs text-[#9ca3af] font-medium">
//                           {field.field_key}
//                         </span>
//                         <div className="h-3 rounded bg-[#f3f4f6] w-[90%]" style={{ animation: "ex-shimmer 1.5s ease-in-out infinite" }} />
//                         <div className="h-3 rounded bg-[#f3f4f6] w-[70%]" style={{ animation: "ex-shimmer 1.5s ease-in-out infinite" }} />
//                       </div>
//                     ))}
//                     {fields.length === 0 && (
//                       <div className="p-3 border border-[#e5e7eb] rounded-lg flex flex-col gap-2 mb-2">
//                         <div className="h-3 rounded bg-[#f3f4f6] w-[40%]" style={{ animation: "ex-shimmer 1.5s ease-in-out infinite" }} />
//                         <div className="h-3 rounded bg-[#f3f4f6] w-[90%]" style={{ animation: "ex-shimmer 1.5s ease-in-out infinite" }} />
//                         <div className="h-3 rounded bg-[#f3f4f6] w-[70%]" style={{ animation: "ex-shimmer 1.5s ease-in-out infinite" }} />
//                       </div>
//                     )}
//                   </div>
//                 ) : activeDoc?.result ? (
//                   activeDoc.result._error ? (
//                     <div className="flex flex-col items-center text-center px-6 py-10">
//                       <div className="w-14 h-14 rounded-xl bg-[#8B55DD]/[0.05] border border-[#8B55DD]/[0.08] flex items-center justify-center text-[#9CA3AF] mb-3">
//                         <AlertCircle size={28} />
//                       </div>
//                       <p className="text-[0.8125rem] font-semibold text-[#52525B] m-0 mb-1">Extraction Failed</p>
//                       <p className="text-xs text-[#9CA3AF] max-w-[300px] leading-[1.5] m-0">{activeDoc.result._error}</p>
//                     </div>
//                   ) : (
//                     <>
//                       <div className="px-3.5 py-2 border-b border-[#e5e7eb] text-xs text-[#10b981] flex items-center gap-1.5">
//                         <CheckCircle2 size={12} />
//                         Extracted successfully · {Object.keys(activeDoc.result?.extracted_data ?? activeDoc.result ?? {}).length} fields
//                       </div>

//                       <ResultRenderer
//                         data={activeDoc.result}
//                         templateName={template?.name ?? "Extraction"}
//                       />

//                       {fields.length > 0 && (
//                         <div className="px-3.5 py-2 border-t border-[#e5e7eb]">
//                           <span className="text-[0.625rem] font-bold text-[#71717A] uppercase tracking-[0.06em]">
//                             Highlight in document
//                           </span>
//                           {fields.map((field) => {
//                             const extractedData = activeDoc.result?.extracted_data ?? activeDoc.result;
//                             const val = extractedData?.[field.field_key];
//                             if (!val || typeof val !== "string") return null;
//                             return (
//                               <label
//                                 key={field.field_key}
//                                 className="flex items-center gap-2 py-1 text-xs text-[#3F3F46] cursor-pointer"
//                               >
//                                 <input
//                                   type="checkbox"
//                                   className="accent-[#8B55DD]"
//                                   checked={!!highlightFields[field.field_key]}
//                                   onChange={(e) => setHighlightFields((prev) => ({
//                                     ...prev,
//                                     [field.field_key]: e.target.checked,
//                                   }))}
//                                 />
//                                 {field.field_key.replace(/_/g, " ")}
//                               </label>
//                             );
//                           })}
//                         </div>
//                       )}
//                     </>
//                   )
//                 ) : (
//                   <div className="flex flex-col items-center text-center px-6 py-10 pt-12">
//                     <div className="w-14 h-14 rounded-xl bg-[#8B55DD]/[0.05] border border-[#8B55DD]/[0.08] flex items-center justify-center text-[#9CA3AF] mb-3">
//                       <Wand2 size={28} />
//                     </div>
//                     <p className="text-[0.8125rem] font-semibold text-[#52525B] m-0 mb-1">Run an extraction</p>
//                     <p className="text-xs text-[#9CA3AF] max-w-[300px] leading-[1.5] m-0">
//                       Upload a document and click Run Extraction to see results here.
//                     </p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </>
//         )}

//         {/* ── HISTORY TAB ────────────────────────────────────────────────── */}
//         {activeTab === "history" && (
//           <div className="flex-1 flex items-center justify-center">
//             <div className="flex flex-col items-center text-center px-6 py-10">
//               <div className="w-14 h-14 rounded-xl bg-[#8B55DD]/[0.05] border border-[#8B55DD]/[0.08] flex items-center justify-center text-[#9CA3AF] mb-3">
//                 <Clock size={28} />
//               </div>
//               <p className="text-[0.8125rem] font-semibold text-[#52525B] m-0 mb-1">History coming soon</p>
//               <p className="text-xs text-[#9CA3AF] max-w-[300px] leading-[1.5] m-0">
//                 Extraction history and version tracking will appear here.
//               </p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// // ─── Templates Dashboard ──────────────────────────────────────────────────────

// const TemplatesDashboard = ({ onNewTemplate, onOpenWorkspace }) => {
//   const [templates, setTemplates]   = useState([]);
//   const [loading, setLoading]       = useState(true);
//   const [dupeId, setDupeId]         = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [copiedTemplateId, setCopiedTemplateId] = useState(null);
//   const copyTimerRef = useRef(null);

//   useEffect(() => { loadTemplates(); }, []);

//   useEffect(() => () => {
//     if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
//   }, []);

//   useEffect(() => {
//     if (!openMenuId) return;
//     const handler = () => setOpenMenuId(null);
//     document.addEventListener("click", handler);
//     return () => document.removeEventListener("click", handler);
//   }, [openMenuId]);

//   const loadTemplates = async () => {
//     try {
//       const data = await getTemplates();
//       setTemplates(data);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Delete this template? This cannot be undone.")) return;
//     try {
//       const { deleteTemplate } = await import("./extractorApi");
//       await deleteTemplate(id);
//       setTemplates((prev) => prev.filter((t) => t.id !== id));
//     } catch {
//       alert("Failed to delete template.");
//     }
//   };

//   const handleDuplicate = async (id) => {
//     setDupeId(id);
//     try {
//       const copy = await duplicateTemplate(id);
//       setTemplates((prev) => [...prev, copy]);
//     } catch {
//       alert("Failed to duplicate.");
//     } finally {
//       setDupeId(null);
//     }
//   };

//   const handleCopyEndpoint = async (e, template) => {
//     e.stopPropagation();
//     if (!template?.slug) return;

//     try {
//       await copyTextToClipboard(buildUniversalExtractUrl(template.slug));
//       setCopiedTemplateId(template.id);
//       if (copyTimerRef.current) clearTimeout(copyTimerRef.current);
//       copyTimerRef.current = setTimeout(() => setCopiedTemplateId(null), 1800);
//     } catch {
//       window.alert("Couldn't copy automatically. Please copy the endpoint manually.");
//     }
//   };

//   const filteredTemplates = templates.filter((t) => {
//     if (!searchQuery.trim()) return true;
//     const q = searchQuery.toLowerCase();
//     return (
//       (t.name || "").toLowerCase().includes(q) ||
//       (t.slug || "").toLowerCase().includes(q)
//     );
//   });

//   return (
//     <div className="p-8 px-10 h-full overflow-auto w-full bg-[#FEF9F7]">
//       <div className="flex items-center justify-between mb-8">
//         <div>
//           <h1 className="text-xl font-bold text-[#171717] m-0">Templates</h1>
//         </div>
//         <button
//           className={`${CLS.btn} ${CLS.btnPrimary}`}
//           onClick={onNewTemplate}
//         >
//           <Plus size={14} /> New Template
//         </button>
//       </div>

//       {/* Onboarding Hero */}
//       <OnboardingHero />

//       {/* Starter Template Gallery */}
//       <StarterTemplateGallery
//         suggestedFields={SUGGESTED_FIELDS}
//         onOpenWorkspace={onOpenWorkspace}
//         onOpenWizard={onNewTemplate}
//       />

//       {loading ? (
//         <div className="flex justify-center items-center h-48 w-full">
//           <Spinner size={28} />
//         </div>
//       ) : templates.length === 0 ? (
//         <div className="flex flex-col items-center text-center px-6 py-10 mt-16">
//           <div className="w-14 h-14 rounded-xl bg-[#8B55DD]/[0.05] border border-[#8B55DD]/[0.08] flex items-center justify-center text-[#9CA3AF] mb-3">
//             <Layers size={40} />
//           </div>
//           <p className="text-[0.8125rem] font-semibold text-[#52525B] m-0 mb-1">No templates yet</p>
//           <p className="text-xs text-[#9CA3AF] max-w-[300px] leading-[1.5] m-0">Create your first extraction template to get started.</p>
//         </div>
//       ) : filteredTemplates.length === 0 ? (
//         <div className="flex flex-col items-center text-center px-6 py-10 mt-8">
//           <p className="text-[0.8125rem] font-semibold text-[#52525B] m-0 mb-1">No matching templates</p>
//           <p className="text-xs text-[#9CA3AF] max-w-[300px] leading-[1.5] m-0">Try a different search term.</p>
//         </div>
//       ) : (
//         <div className="grid grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-3">
//           {filteredTemplates.map((t) => (
//             <div
//               key={t.id}
//               className="group bg-white border border-black/[0.08] rounded-xl p-5 transition-all duration-200 cursor-pointer relative min-h-[172px] flex flex-col hover:border-black/[0.15] hover:shadow-[0_4px_20px_rgba(0,0,0,0.06)]"
//               onClick={() => onOpenWorkspace(t)}
//             >
//               <div className="flex justify-between items-start gap-3">
//                 <div className="flex-1 min-w-0">
//                   <p className="text-base font-bold text-[#171717] m-0 leading-[1.35] transition-colors duration-150 group-hover:text-[#8B55DD]">{t.name}</p>
//                   <div className="flex items-center gap-2 mt-2 flex-wrap">
//                     {t.slug && (
//                       <span className="text-xs font-mono text-[#8B55DD] bg-[#8B55DD]/[0.08] px-2 py-1 rounded-lg inline-flex max-w-full overflow-hidden text-ellipsis whitespace-nowrap">{t.slug}</span>
//                     )}
//                     <span className="text-[0.625rem] font-bold uppercase tracking-[0.06em] px-2.5 py-1 rounded-full bg-[#F5F4F3] text-[#71717A] border border-black/[0.08]">{t.document_type}</span>
//                   </div>
//                 </div>
//                 {/* Three-dot menu */}
//                 <div className="relative">
//                   <button
//                     className="w-7 h-7 flex items-center justify-center rounded-md border-none bg-transparent text-[#9ca3af] cursor-pointer transition-all duration-150 hover:bg-black/[0.06] hover:text-[#3F3F46]"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       setOpenMenuId(openMenuId === t.id ? null : t.id);
//                     }}
//                   >
//                     <MoreVertical size={16} />
//                   </button>
//                   {openMenuId === t.id && (
//                     <div className="absolute top-full right-0 min-w-[140px] bg-white border border-black/10 rounded-lg shadow-[0_4px_16px_rgba(0,0,0,0.1)] z-20 p-1 flex flex-col">
//                       <button
//                         className="flex items-center gap-2 px-3 py-[0.4375rem] border-none bg-transparent text-[0.8125rem] text-[#3F3F46] cursor-pointer rounded-md transition-colors w-full text-left hover:bg-black/[0.04]"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setOpenMenuId(null);
//                           onOpenWorkspace(t);
//                         }}
//                       >
//                         <Settings size={14} /> Edit
//                       </button>
//                       <button
//                         className="flex items-center gap-2 px-3 py-[0.4375rem] border-none bg-transparent text-[0.8125rem] text-[#3F3F46] cursor-pointer rounded-md transition-colors w-full text-left hover:bg-black/[0.04]"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setOpenMenuId(null);
//                           handleDuplicate(t.id);
//                         }}
//                         disabled={dupeId === t.id}
//                       >
//                         <Copy size={14} /> Duplicate
//                       </button>
//                       <button
//                         className="flex items-center gap-2 px-3 py-[0.4375rem] border-none bg-transparent text-[0.8125rem] !text-[#DC2626] cursor-pointer rounded-md transition-colors w-full text-left hover:bg-[#DC2626]/[0.06]"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setOpenMenuId(null);
//                           handleDelete(t.id);
//                         }}
//                       >
//                         <Trash2 size={14} /> Delete
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//               <div className="h-px bg-black/[0.06] mt-4 mb-3.5" />
//               <div className="flex items-end justify-between gap-3 mt-auto">
//                 <div className="flex flex-col gap-1.5 min-w-0">
//                   <span className="inline-flex items-center gap-1.5 text-xs text-[#71717A]">{t.fields?.length || 0} fields</span>
//                   <span className="inline-flex items-center gap-1.5 text-xs text-[#71717A]">
//                     <Clock size={11} />
//                     Updated {t.updated_at ? new Date(t.updated_at).toLocaleDateString() : "-"}
//                   </span>
//                 </div>
//                 <button
//                   className="inline-flex items-center gap-1.5 border border-[#8B55DD]/[0.18] bg-[#8B55DD]/[0.06] text-[#7C3AED] rounded-[10px] px-3 py-2 text-xs font-semibold cursor-pointer flex-shrink-0 transition-all duration-150 hover:enabled:bg-[#8B55DD]/10 hover:enabled:border-[#8B55DD]/[0.28] disabled:opacity-[0.45] disabled:cursor-not-allowed"
//                   onClick={(e) => handleCopyEndpoint(e, t)}
//                   disabled={!t.slug}
//                 >
//                   {copiedTemplateId === t.id ? (
//                     <><Check size={13} /> Copied</>
//                   ) : (
//                     <><Copy size={13} /> Copy Endpoint</>
//                   )}
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// // ─── Root Page Component ──────────────────────────────────────────────────────

// const Extractor = () => {
//   const [view, setView] = useState("TEMPLATES");
//   const [activeTemplate, setActiveTemplate] = useState(null);
//   const [slideOverOpen, setSlideOverOpen] = useState(false);

//   const openWorkspace = (template) => {
//     setActiveTemplate(template);
//     setView("WORKSPACE");
//   };

//   const goBackToTemplates = () => {
//     setActiveTemplate(null);
//     setView("TEMPLATES");
//   };

//   const handleTemplateCreated = (template) => {
//     setSlideOverOpen(false);
//     openWorkspace(template);
//   };

//   return (
//     <div className="flex h-full bg-[#FEF9F7] text-[#3F3F46] overflow-hidden font-['Outfit',-apple-system,BlinkMacSystemFont,'Segoe_UI','Inter',sans-serif]">
//       <main className="flex-1 overflow-hidden flex flex-col">
//         {view === "TEMPLATES" && (
//           <>
//             <TemplatesDashboard
//               onNewTemplate={() => setSlideOverOpen(true)}
//               onOpenWorkspace={openWorkspace}
//             />
//             <NewTemplateSlideOver
//               isOpen={slideOverOpen}
//               onClose={() => setSlideOverOpen(false)}
//               onCreated={handleTemplateCreated}
//             />
//           </>
//         )}
//         {view === "WORKSPACE" && activeTemplate && (
//           <TemplateWorkspace
//             template={activeTemplate}
//             onBack={goBackToTemplates}
//           />
//         )}
//       </main>
//     </div>
//   );
// };

// export { generateSlug, Spinner };
// export default Extractor;";

import React, { useState, useEffect, useCallback, useRef } from "react";
import "./extractor.css";
import TemplatesDashboard from "./TemplatesDashboard";
import TemplateWorkspace from "./TemplateWorkspace";
import NewTemplateSlideOver from "./NewTemplateSlideOver";
import TemplateBuilder from "./TemplateBuilder";
import StudioApp from "./Studio/StudioApp";
import { generateSlug, Spinner } from "./constants";

// Unified Extractor Studio (Builder landing → one Schema/Test/History workspace for
// every origin) is the primary flow. Flip to false to fall back to the legacy
// 3-view router below.
const USE_STUDIO = true;

const Extractor = () => {
  const [view, setView] = useState("TEMPLATES");
  const [activeTemplate, setActiveTemplate] = useState(null);
  const [slideOverOpen, setSlideOverOpen] = useState(false);

  const openWorkspace = (template) => {
    setActiveTemplate(template);
    setView("WORKSPACE");
  };

  const goBackToTemplates = () => {
    setActiveTemplate(null);
    setView("TEMPLATES");
  };

  const handleTemplateCreated = (template) => {
    setSlideOverOpen(false);
    openWorkspace(template);
  };

  const handleBuilderTemplateCreated = (template) => {
    setView("TEMPLATES");
    if (template) openWorkspace(template);
  };

  if (USE_STUDIO) {
    return (
      <div className="flex h-full bg-[#FEF9F7] text-[#3F3F46] overflow-hidden font-['Outfit',-apple-system,BlinkMacSystemFont,'Segoe_UI','Inter',sans-serif]">
        <main className="flex-1 overflow-hidden flex flex-col">
          <StudioApp />
        </main>
      </div>
    );
  }

  return (
    <div className="flex h-full bg-[#FEF9F7] text-[#3F3F46] overflow-hidden font-['Outfit',-apple-system,BlinkMacSystemFont,'Segoe_UI','Inter',sans-serif]">
      {/* Legacy Internal Sidebar Removed */}

      {/* Main */}
      <main className="flex-1 overflow-hidden flex flex-col">
        {view === "TEMPLATES" && (
          <>
            <TemplatesDashboard
              onNewTemplate={() => setSlideOverOpen(true)}
              onOpenWorkspace={openWorkspace}
              onBuildWithAI={() => setView("BUILDER")}
            />
            <NewTemplateSlideOver
              isOpen={slideOverOpen}
              onClose={() => setSlideOverOpen(false)}
              onCreated={handleTemplateCreated}
            />
          </>
        )}
        {view === "WORKSPACE" && activeTemplate && (
          <TemplateWorkspace
            template={activeTemplate}
            onBack={goBackToTemplates}
          />
        )}
        {view === "BUILDER" && (
          <TemplateBuilder
            onClose={goBackToTemplates}
            onTemplateCreated={handleBuilderTemplateCreated}
          />
        )}
      </main>
    </div>
  );
};

export { generateSlug, Spinner };
export default Extractor;